webpackJsonp([0],{

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    if (!LN.Core || !LN.Config) throw new Error("LN.Core || LN.Config missing");
})();

(function (Controller, Config, Helper, Service, Handler, Model, Message, Validation, View, $) {
    'use strict';

    Controller.validarTipoAsociacionClub = function () {
        Helper.updateToken();
        Service.ajaxPost('/Usuario/ObtenerDatosClub', false, function (res, status, xhr) {
            Handler.obtenerDatosClubHandler(res, status, xhr);
        }, null, {
            sentHeader: true
        });
    };

    Controller.buscarCredencial = function (credencial) {
        var crm = null;
        $(Model.Usuario.Credenciales).each(function () {
            if (this.nroTarjeta.replace(/-/gi, "") == credencial) crm = this.CrmId;
        });
        return crm;
    };

    Controller.asociarCrendecialValidaciones = function () {

        var credencial1 = $("#nro-credencial-1");
        var credencial2 = $("#nro-credencial-2");
        var credencial3 = $("#nro-credencial-3");
        var nroDocumento = $("#nro-documento");
        var tipoDocumentoValidacion = $("#tipo-documento option:selected").data('validator');

        var credencial = credencial1.val() + credencial2.val() + credencial3.val();
        var cantInputs = nroDocumento.length > 0 ? 2 : 1;
        var cantInputsOk = 0;

        // Validación nro de credencial 
        var bStatusCred1 = Validation.Validators.credencialClub1.test(credencial1.val());
        var bStatusCred2 = Validation.Validators.credencialClub2.test(credencial2.val());
        var bStatusCred3 = Validation.Validators.credencialClub3.test(credencial3.val());
        Helper.changeStatus(credencial1, bStatusCred1);
        Helper.changeStatus(credencial2, bStatusCred2);
        Helper.changeStatus(credencial3, bStatusCred3);

        var credencialErrorMensaje = $("#credencial-error");
        if (!bStatusCred1 || !bStatusCred2 || !bStatusCred3) credencialErrorMensaje.html(Message.Credencial['INCORRECTA']);else credencialErrorMensaje.html('');

        if (bStatusCred1 && bStatusCred2 && bStatusCred3) {
            if (Model.Usuario.Credenciales.length == 1 && Model.Usuario.TipoAsociarCredencial == "1") {
                // Caso de asociación rápida (solo ingreso los dos últimos dígitos)
                cantInputsOk++;
                Model.Usuario.Credencial = Model.Usuario.Credenciales[0].nroTarjeta.replace(/-/gi, "").substr(0, 14) + credencial3.val();
            } else if (Validation.Validators.credencialClub.test(credencial)) {
                cantInputsOk++;
                Model.Usuario.Credencial = credencial;
            }
        }

        // Validación nro de documento 
        if (nroDocumento.length > 0) {
            if (Model.Cliente.numeroDocumento != "" && Validation.Validators.dni.test(Model.Cliente.numeroDocumento)) {
                cantInputsOk++;
                Helper.changeStatus(nroDocumento, true);
            } else {
                Helper.changeStatus(nroDocumento, false, Message.Credencial['DNI_INCOMPLETO'], Message.Analytics.Credencial['DNI_INCOMPLETO']);
            }
        }
        return cantInputs === cantInputsOk;
    };

    Controller.asociarCredencialCall = function (data) {
        Helper.updateToken();
        Service.asociarCredencial(data);
    };

    // Asociación directa . Tengo que autocompletar nro-crendencial-1 y nro-credencial-2, hacer que el usuario complete nro-credencial-3 (para caso 1 ) 
    // Para caso 3 tengo que completar la credencial completa . 
    // Tengo en memoria crm y nro-credencial . Voy al servicio con usuario-id y crm . 
    Controller.asociarCredencialCorto = function () {
        //$(".tarjeta-incorrecta").css("display", "none");
        if (Controller.asociarCrendecialValidaciones()) {
            if (Controller.buscarCredencial(Model.Usuario.Credencial) === null) {
                if (Model.Window.errorAttemps == 0) {
                    // Mostrar error
                    Model.Window.errorAttemps++;
                    var credencialErrorMensaje = $("#credencial-error");
                    credencialErrorMensaje.html(Message.Credencial['INCORRECTA_ATTEMP']);
                    //$(".tarjeta-incorrecta").css("display", "table");                    
                } else {
                    // Le erró al ingresar la credencial y redirige al ingreso de DNI - Credencial . 
                    Model.Usuario.TipoAsociarCredencial = "2";
                    View.asociarTarjeta();
                }
            } else {
                var data = {
                    crmId: Controller.buscarCredencial(Model.Usuario.Credencial),
                    estado: Model.Usuario.Credenciales.length == 1 ? 1 : 2
                };
                Controller.asociarCredencialCall(data);
            }
        }
    };

    // Asociación largo . Tengo que completar nro-credencial y nro-documento . 
    Controller.asociarCredencialLargo = function () {

        // Si no tengo datos en el modelo, los cargo . 
        // Si lo tengo cargado en el modelo es porque entré por Flow D y tengo que asociar una credencial correspondiente al DNI cargado anteriormente .
        if (Model.Cliente.numeroDocumento == "" && Model.Cliente.tipoDocumento == "") {
            Model.Cliente.numeroDocumento = $("#nro-documento").val();
            Model.Cliente.tipoDocumento = $("#tipo-documento").val();
        }

        if (Controller.asociarCrendecialValidaciones()) {
            var data = {
                tipo_doc: Model.Cliente.tipoDocumento,
                nro_doc: Model.Cliente.numeroDocumento,
                nro_tarjeta: Model.Usuario.Credencial
            };
            Controller.asociarCredencialCall(data);
        }
    };

    Controller.finalizarAsociar = function () {
        Service.actualizarCookies(Controller.flowE);
    };
})(LN.Controller, LN.Config, LN.Helper, LN.Service, LN.Handler, LN.Model, LN.Message, LN.Validation, LN.View, jQuery);

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    if (!LN.Core || !LN.Config) throw new Error("LN.Core || LN.Config missing");
})();

(function (Controller, Service, Model) {
    'use strict';

    Controller.flowA = function (modo, combo) {
        Service.getFlow('A', { modo: modo || Model.Window.modo, combo: combo || Model.Window.combo });
    };

    Controller.flowB = function (combo, options) {
        Service.getFlow('B', combo, options);
    };

    Controller.flowC = function () {
        Service.getFlow('C');
    };

    Controller.flowD = function (data) {
        Service.getFlow('D', Model.Cliente);
    };

    Controller.flowE = function () {
        Service.getFlow('E');
    };

    Controller.flowF = function () {
        Service.getFlow('F');
    };

    Controller.flowG = function () {
        Service.getFlow('G');
    };
})(LN.Controller, LN.Service, LN.Model);

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assert = __webpack_require__(165);

(function () {
    if (!LN.Core || !LN.Config) throw new Error("LN.Core || LN.Config missing");
})();

(function (Controller, View, Config, Helper, Service, Handler, Model, Message, Validation, Analytics, FacebookInstantArticles, $, LocalStorage) {
    'use strict';

    /* METODOS PRIVADOS */

    var ComboController = function ComboController(modo) {
        /* Este controller reemplaza a Controller.comboBonificado y Controller.comboPago
         * como hay un unico route que tiene modo V, entonces elimino la condicion de source
         * No se cambia la funcionalidad solo refactory
         */
        if (modo === 'V' || Model.Window.lastFlow === "B") {
            if (Model.Cliente.comboElegido == Config.COMBO_BONIFICADO) {
                Controller.flowF();
            } else {
                Controller.flowC();
            }
        } else {
            Controller.flowB({
                combo: Model.Cliente.comboElegido
            });
        }
    };

    /* METODOS PUBLICOS */

    Controller.inicio = function (combo) {
        console.log('Iniciocontroller:' + combo);
        // Si no esta logueado redirecciona al combo que corresponde
        //var source = ((!Helper.isEmpty(source)) ? source : null);
        if (Helper.isEmpty(Model.Me)) {
            Service.isLogged(function () {
                Controller.inicio(combo);
            }, function () {
                Helper.redirectToLoginWCombo(combo);
                return false;
            });
            return false;
        }
        Model.Cliente.comboElegido = combo;
        Model.setCombo(combo);
        ComboController(Model.Window.modo);
    };

    Controller.ingresarDni = function () {
        if (!Validation.validateOnSubmit('datos_personales')) return false;
        Model.getInputsBy('datos_personales').save(Model.Cliente);
        Controller.flowD(Model.Cliente);
    };

    Controller.ingresarDni_OtroUsuario = function () {
        Helper.Ingreso_dni_MostrarMailOfuscado();
        LN.Wcentrix && LN.Wcentrix.initChat();
        Helper.hidePreloader();
    };

    Controller.formularioDatosPersonales = function () {
        if (!Validation.validateOnSubmit('datos_personales')) return false;
        Model.getInputsBy('datos_personales').save(Model.Cliente);
        Controller.iniciarVenta(null, Model.Cliente, function (res, status, xhr) {
            Handler.iniciarVenta(res, status, xhr);
        });

        // Una vez que guarda el cliente redirecciona a formularios de envio
        //Service.clienteGuardar(Model.Cliente, function (res, status, xhr) {
        //    Handler.clienteGuardar(res, status, xhr);
        //})
    };

    Controller.iniciarVenta = function (domicilio, cliente, cb) {
        var model = {
            SitioOrigen: Config.SitioOrigen,
            planId: Model.PlanElegido.id,
            campaniaId: Model.Campania.id,
            idCanalDeVenta: Model.canalDeVenta,
            idFormaDeContacto: Model.Window.contact
        };
        if (cliente) model.clienteModel = cliente;
        if (!domicilio) {
            model.domicilioModel = { domicilioExtranjero: true };
        } else {
            model.addressId = domicilio.id;
        }
        Service.iniciarVenta(model, function (res, status, xhr) {
            cb && cb(res, status, xhr);
        });
    };

    Controller.formularioDatosPersonalesClienteNuevo = function () {
        Model.Cliente.NuevoCliente = "true";
        Model.Cliente.email = LN.Model.Me.Usuario.usuarioemail;
        LN.AppEvent.sendEvent('DNI_OK');
        View.formularioDatosPersonales();
    };

    Controller.obtenerMontoACobrar = function (cb) {

        Service.obtenerMontoACobrar({
            idPlanVta: Model.PlanElegido.id,
            idCampania: Model.Campania.id
        }, function (r) {
            Handler.obtenerMontoACobrar(r);
            cb && cb();
        });
    };

    Controller.posdatarDomicilio = function () {
        Helper.hideCustomMessageError('error-domicilio');
        Helper.disableNextButton();

        var isAddressFormEmpty = Helper.isEmpty(LN.Model.getInputsBy("datos_envio", "calle").get().value) && Helper.isEmpty(LN.Model.getInputsBy("datos_envio", "altura").get().value) && Helper.isEmpty(LN.Model.getInputsBy("datos_envio", "cp").get().value) && Helper.isEmpty(LN.Model.getInputsBy("datos_envio", "localidad").get().value);

        if (isAddressFormEmpty) {

            // Si el formulario está vacío, se dirige a pantalla de gracias.
            View.confirmacionCombo2();
        } else {

            // Verifica si está OK el formulario.
            var isAddressOk = !Helper.isEmpty(Model.getInputsBy("datos_envio", 'id').get().value) || Validation.validateOnSubmit('datos_envio', { 'normalizar_domicilio': 'normalizar_domicilio' });

            if (isAddressOk) {

                Helper.showPreloader();

                var datarequest = {
                    "IdCanalVenta": Config.canalesDeVenta[Model.Window.modo] || Config.canalesDeVenta['S'],
                    "PlanId": Model.PlanElegido.id,
                    "EditarDomicilio": {
                        "addressId": Model.Venta.Domicilio.id,
                        "altura": Model.getInputsBy("datos_envio", 'altura').get().value,
                        "calle": Model.getInputsBy("datos_envio", 'calle').get().value,
                        "cp": Model.getInputsBy("datos_envio", 'cp').get().value,
                        "dpto": Model.getInputsBy("datos_envio", 'depto').get().value,
                        "entreCalle1": Model.getInputsBy("datos_envio", 'entreCalle1').get().value,
                        "entreCalle2": Model.getInputsBy("datos_envio", 'entreCalle2').get().value,
                        "localidad": Model.getInputsBy("datos_envio", 'localidad').get().value,
                        "pais": "ARGENTINA",
                        "piso": Model.getInputsBy("datos_envio", 'piso').get().value,
                        "provincia": Model.getInputsBy("datos_envio", 'provincia').get().value,
                        "torre": Model.getInputsBy("datos_envio", 'torre').get().value,
                        "cuerpo": Model.getInputsBy("datos_envio", 'cuerpo').get().value,
                        "lote": Model.getInputsBy("datos_envio", 'lote').get().value
                    }
                };

                // Si está bien, se realiza posdatar domicilio.
                Service.posdatarDomicilio(datarequest, function (data) {
                    console.log(data);
                    Helper.hidePreloader();
                    Handler.posdatarDomicilio(data);
                });
            } else {

                Helper.enableNextButton();
            }
        }
    };

    Controller.validarPago = function (pago) {
        console.log('validacion de pago');
        // Limpio mensaje de error
        $('#mensaje').html('');
        switch (pago.CODRTA) {
            case '1173-00':
            case '1174-00':

                // Solicitud OK
                var data = {
                    SitioOrigen: Config.SitioOrigen,
                    Codrta: pago.CODRTA,
                    Descripcion: pago.DESCRIPCION,
                    hash: pago.HASH,
                    password: pago.PASSWORD,
                    mascara: pago.MASCARA,
                    token: pago.TOKEN,
                    token_da: pago.TOKEN_DA,
                    esExtranjero: Model.Venta.esExtranjero,
                    planId: Model.PlanElegido.id,
                    campaniaId: Model.Campania.id,
                    importeEtapas: {
                        cantidadMesesPrimeraEtapa: Model.PlanElegido.mesesDescuento,
                        importePrimeraEtapa: Model.PlanElegido.precio,
                        importeSegundaEtapa: Model.PlanElegido.precioSinDescuento
                    }
                };

                Service.procesarPago(data, Handler.procesarPago);
                break;
            case '1174-04':
            case '1174-10':
                // Error en carga
                View.formularioPago(Message.Pago.ERROR_CARGA, true);
                break;
            case '1173-07':
            case '1174-08':
                // Solicitud vencida
                Controller.iniciarVenta(Model.Venta.Domicilio, null, function (res, status, xhr) {
                    if (res.code == '0000') {
                        Model.setPago(res.response.formularioWondersoft);
                        View.formularioPago(Message.Pago.SOLICITUD_VENCIDA);
                    }
                });
                break;
            case '1174-18':
            case 'TA':
                // Error de datos
                Controller.iniciarVenta(Model.Venta.Domicilio, null, function (res, status, xhr) {
                    if (res.code == '0000') {
                        Model.setPago(res.response.formularioWondersoft);
                        View.formularioPago(Message.Pago.DATOS_INVALIDOS);
                    }
                });
                break;
            default:
                // Error generico
                Controller.iniciarVenta(Model.Venta.Domicilio, null, function (res, status, xhr) {
                    if (res.code == '0000') {
                        Model.setPago(res.response.formularioWondersoft);
                        View.formularioPago(Message.Pago.ERROR_GENERAL);
                    }
                });
                break;
        }
    };

    Controller.formularioPago = function () {
        //Helper.hideCustomMessageError('error-domicilio');
        //Helper.hideCustomMessageError('error-tarjeta');
        //Helper.disableNextButton();

        ///********************************************/
        //if (validation_envio && validation_tarjeta) {

        //    Model.getInputsBy('datos_tarjeta').save(Model.TarjetaElegida);

        //}
        //else {
        //    //Hubo un error de validacion, habilito el boton para que el usuario corrja el dato y vuelva a hacer click en comprar
        //    Helper.enableNextButton();
        //}


        //};
        //Service.procesarWondersoft(dataProcesar, function (r) {
        //    if (r.code == '0000') {

        //    }
        //});
    };

    Controller.aceptaTyC = function () {
        var refreshError = true;
        Service.campanaObtener(Config.campaniaBonificada, function (res, status, xhr) {
            if (res.code == "0000") {
                Model.Campania.id = Config.campaniaBonificada;
                Model.PlanElegido = res.response.grupoPlanes[0];

                Service.iniciarVenta({
                    campaniaId: Model.Campania.id,
                    planId: Model.PlanElegido.id,
                    addressId: null,
                    tarjeta: null,
                    idCanalDeVenta: Model.canalDeVenta,
                    idFormaDeContacto: Model.Window.contact,
                    idOrigen: Model.idOrigen
                }, function (res, status, xhr) {
                    console.log(res.code);
                    if (res.code === "0000") {
                        var FacebookIA = new Promise(Controller.FbInstantArticlesVentaPromise);
                        var reshandler = function reshandler() {
                            Model.Cliente.comboElegido = Config.COMBO_BONIFICADO;
                            Handler.ventaGuardar(res, status, xhr);
                            refreshError = false;
                        };

                        Promise.all([FacebookIA]).then(reshandler).catch(reshandler);
                    } else Handler.aceptaTyCErrores(res.code);
                });
            } else Handler.aceptaTyCErrores(res.code);
        });
    };

    Controller.volver = function () {
        Helper.returnBack({
            url: document.referrer
        });
    };

    Controller.obtenerDatosPersonales = function () {
        Service.clienteObtenerDatosFiliatorios(function (data) {
            Handler.obtenerDatosFiliatorios(data);
        });
    };

    Controller.obtenerDatosPersonalesFormularioEnvio = function () {
        Service.clienteObtenerDatosFiliatorios(function (data, status, xhr) {
            Handler.obtenerDatosFiliatoriosFormularioEnvio(data, status, xhr);
        });
    };

    Controller.validarPinesProcesar = function () {

        if (!Validation.validateOnSubmit('validarpin')) return false;
        //View.validarPinGracias();
        $('#error').html('');

        Model.pin = Model.getInputsBy("validarpin", 'pin').get().value.trim();
        var dataValidar = {
            Pin: Model.pin
        };
        Service.validarPin(dataValidar, function (res) {
            Handler.validarPin(res);
        });
    };

    Controller.validarPinesTyC = function () {
        Analytics.clickValidarPin('Aceptar términos y condiciones');
        View.primerAcceso();
    };
    Controller.validarPinesMiClub = function () {
        Analytics.clickValidarPin('Desvincular');
        //window.open(Config.dominioMiCuenta + '/mi-club','_blank');
        location.href = Config.dominioMiCuenta + '/mi-club';
    };
    Controller.validarPinesReenviar = function () {
        //let dataReenviar = {};
        //Service.validarPinReenviar(dataReenviar, function (res) {
        //    Handler.validarPinReenviar();
        //});
        //View.validarPin(Message.Pines['PIN_VENCIDO']);
    };

    Controller.postVenta = function () {
        if (!Helper.isEmpty(Model.PlanElegido)) Analytics.transaccionExitosa(Model.PlanElegido.nombre, Model.PlanElegido.precio, Model.Window.lastFlow);
        // MOBILE: envio callback de venta OK.
        LN.AppEvent.sendEvent('VENTA-OK');
        LocalStorage.setItem('userLogedIn', true);
        localStorage.removeItem('userLogedIn');

        var onContinue = function onContinue(arg) {

            if (!Model.PlanElegido.planConCredencial) {
                // Si no requiere domicilio, muestra directamente la pantalla de gracias.
                Service.actualizarCookies(View.confirmacionCombo1());
            } else {
                if (!Model.Venta.esExtranjero) {
                    // Si necesita domicilio muestra el formulario de envio.
                    Service.actualizarCookies(View.formularioEnvio());
                } else {
                    // Es extranjero, no necesita domicilio, abro pantalla de gracias.
                    Service.actualizarCookies(View.confirmacionCombo2());
                }
            }
        };

        var FacebookIA = new Promise(Controller.FbInstantArticlesVentaPromise);

        Promise.all([FacebookIA]).then(onContinue).catch(onContinue);
    };

    Controller.postVentaBonificada = function () {
        var resetVarnish = new Promise(function (resolve, reject) {
            Helper.resetImg('varnishReset', 'http://www.lanacion.com.ar/apw/api/v1/reset.gif', function () {
                console.log('resolve varnishReset');
                resolve();
            });
        });
        var resetFB = new Promise(function (resolve, reject) {
            if (Model.IsInstantArticles()) {
                Helper.resetImg('externalPaywallToken', Model.ExternalPaywall.AutorizationToken, function () {
                    console.log('resolve externalPaywallToken');
                    resolve();
                });
            } else {
                resolve();
            }
        });

        var onContinue = function onContinue() {
            if (Model.IsInstantArticles()) {
                View.confirmacionBonificadoFacebook();
            } else {
                LN.AppEvent.sendEvent('VENTA-OK');
                LocalStorage.setItem('userLogedIn', true);
                localStorage.removeItem('userLogedIn');
                Helper.returnBack();
            }
        };

        Promise.all([resetVarnish, resetFB]).then(onContinue).catch(onContinue);
    };

    Controller.yaCompro = function () {
        var onContinue = function onContinue() {
            View.yaTieneCuentaFacebook();
        };
        if (Model.IsInstantArticles()) {
            var fbIA = new Promise(Controller.FbInstantArticlesYaTengoPromise);
            fbIA.then(onContinue).catch(onContinue);
        } else {
            View.yaCompro();
        }
    };

    Controller.yaTenia = function () {
        var onContinue = function onContinue() {
            View.yaTieneCuentaFacebook();
        };
        if (Model.IsInstantArticles()) {
            var fbIA = new Promise(Controller.FbInstantArticlesYaTengoPromise);
            fbIA.then(onContinue).catch(onContinue);
        } else {
            Model.Window.lastFlow = ""; // Limpio el ultimo flow ejecutado
            LN.AppEvent.sendEvent('YA-TENIA-PP');
            Helper.returnBack();
        }
    };
})(LN.Controller, LN.View, LN.Config, LN.Helper, LN.Service, LN.Handler, LN.Model, LN.Message, LN.Validation, LN.Analytics, LN.FacebookInstantArticles, jQuery, LN.LocalStorage);

/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
    if (!LN.Core) throw new Error("LN.Core missing");
})();

(function (Analytics, Helper, Config, Model) {
    'use strict';

    $(document.body).on('click', '.event-track', function (e) {
        e.preventDefault();
        var href = $(this).attr('href');
        var label = $(this).data('label');
        Analytics.otrosEnlaces(Helper.getSource(), label);
        window.location = href;
    });

    /*
    $(window).on('beforeunload', function(){
        return 'Desea salir?';
    });
    */

    $(window).on('unload', function () {
        var currentStep = Helper.getCurrentStep();
        if (Helper.isEmpty(currentStep)) return;
        var forms = Config.Blocks[currentStep.toUpperCase()].forms;
        if (!Helper.isEmpty(forms)) {
            for (var index in forms) {
                var inputs = Model.getInputsBy(forms[index]).all();
                if ((typeof inputs === 'undefined' ? 'undefined' : _typeof(inputs)) === 'object') {
                    for (var i in inputs) {
                        if (Helper.isEmpty(inputs[i].value)) {
                            Analytics.onBeforeUnload(inputs[i].name, null);
                        }
                    }
                }
            }
        }
        return;
    });

    /*
    -- 3
    Medición de pageviews virtuales durante Sign Wall
    Conforme el usuario avanza en los distintos procesos relacionados con la
    autenticación, se le presentarán diversas instancias del formulario mediante ajax y
    sin cambio en la URL. Es por ello que cada una de ellas se deberá medir mediante
    páginas virtuales, siguiendo el siguiente esquema:
    */

    Analytics.paginaVirtualSignWall = function (page) {
        Analytics.pushData({
            'event': 'trackPageView',
            'pageName': page // Pagina actual   
        });
    };

    /*
    -- 4
    Interacciones con botones de SSO
    El usuario dispone a lo largo del flujo de botones para acceder a La Nación mediante
    Google o Facebook, tales como los que se muestran a continuación:    
    */

    Analytics.clickSSO = function (method) {
        Analytics.pushData({
            'event': 'trackClickSSO',
            'login-method': method // Google, Facebook  
        });
    };

    /*
    -- 5
    Estos acontecimientos deben ser medidos mediante la ejecución de una sentencia
    push al momento en que se muestra la alerta de dicho error al usuario. La interacción
    se medirá como un evento estándar en Analytics, a través de Google Tag Manager,
    como se observa en el Snippet que se encuentra a continuación.    
     */

    Analytics.formError = function (label) {
        Analytics.pushData({
            'event': 'trackEvent',
            'eventCategory': 'carrito-paywall',
            'eventAction': 'error-form',
            'eventLabel': label
        });
    };

    /*
    -- 7
    Un usuario puede abandonar un paso del formulario –tanto de SignWall como de
    PayWall– sin avanzar a la siguiente pantalla, ni retroceder al anterior. Si lo hace, debe
    registrarse mediante un push al dataLayer dicho acontecimiento.
    */

    Analytics.onBeforeUnload = function (empty, error) {
        Analytics.pushData({
            'event': 'trackAbandonment',
            'flow': 'carrito-paywall',
            'emptyFields': empty,
            'errorFields': error
        });
    };

    /*
    -- 8
    Una página virtual es un contenido nuevo que se le carga al usuario, pero que
    no recarga la totalidad de la página (No recarga por ejemplo el código de GTM). En
    consecuencia para medirlos será necesario utilizar un push al dataLayer con los
    siguientes datos:
    */

    Analytics.error = function (error) {
        Analytics.pushData({
            'event': 'trackErrorPageV',
            'flow': 'carrito-paywall',
            'errorType': error,
            'errorPage': true
        });
    };

    /*
    -- 9
    Una página virtual es un contenido nuevo que se le carga al usuario, pero que
    no recarga la totalidad de la página (No recarga por ejemplo el código de GTM). En
    consecuencia para medirlos será necesario utilizar un push al dataLayer con los
    siguientes datos:
    */
    Analytics.login = function (isNew, method, id) {
        Analytics.pushData({
            'event': 'trackLogin',
            'newUser': isNew,
            'loginMethod': method, // Facebook,Google,Mail
            'userID': id
        });
    };

    /* 
     -- 11.1
    Tanto en el Muro como en la Landing de PayWall se espera que el usuario cliquee
    sobre los CTA de los paquetes. Esta medición también aplicará para la pantalla de
    “plan insuficiente” (G.05) y para la de “Muro sin Combo
    */

    Analytics.clickCombo = function (name, price, list) {
        Analytics.pushData({
            'event': 'trackClickProd',
            'name': name,
            'price': price,
            'list': list
        });
    };

    /* 
    -- 11.2
    Tanto en el Muro como en la Landing de PayWall, si el usuario ya es Premium o
    Black, puede continuar sin cargo. Esta medición también aplicará para la pantalla
    de “plan insuficiente” (G.05) y para la de “Muro sin Combo”    
    */

    Analytics.clickCombo3 = function (list) {
        Analytics.pushData({
            'event': 'trackEvent',
            'eventCategory': 'paywall',
            'eventLabel': 'Continuar sin cargo',
            'eventAction': list
        });
    };

    /* 
    -- 11.3
    */

    Analytics.otrosEnlaces = function (modo, label) {
        Analytics.pushData({
            'event': 'trackPage',
            'eventCategory': 'paywall',
            'eventAction': modo, // Indicará según corresponda uno de los siguientes strings: muro  landing pantalla plan insuficiente muro-sin-combo 
            'eventLabel': label // Se indicará según corresponda uno de los siguientes strings: logo header //  volver // mas informacion // mail
        });
    };

    Analytics.clickValidarPin = function (label) {
        Analytics.pushData({
            'event': 'trackEvent',
            'eventCategory': 'Código de Activación',
            'eventLabel': label
        });
    };

    Analytics.clickYaTengoSuscripcion = function () {
        Analytics.pushData({
            'event': 'trackEvent',
            'eventCategory': 'Ya tengo suscripcion',
            'eventLabel': 'Ya tengo suscripcion'
        });
    };

    /* 
    -- 12
    Una página virtual es un contenido nuevo que se le carga al usuario, pero que
    no recarga la totalidad de la página (No recarga por ejemplo el código de GTM). En
    consecuencia para medirlos será necesario utilizar un push al dataLayer con los
    siguientes datos
    */

    Analytics.paginaVirtual = function (name, product) {
        Analytics.pushData({
            'event': 'trackPage',
            'pageName': name, // Pagina actual   
            'checkoutProd': product != null ? product : ''
        });
    };

    /* 
    -- 13
    Durante el Flujo del Checkout será necesario enriquecer la información de la página
    medida agregando el key “checkout” informado en el apartado 12, que consistirá en
    un objeto con información adicional
    */

    Analytics.medicionCheckOut = function (name, price) {
        Analytics.pushData({
            'event': 'page',
            'pageName': Model.Window.currentStep, // Pagina actual   
            'checkout': {
                'name': name, // Indicará un string con el nombre del paquete, por ejemplo: Acceso Digital
                'price': price // Valor de la suscripción.
            }

        });
    };

    /* 
    -- 14
    Si bien la medición de transacciones en Google Analytics se realizará directamente
    desde backend para reducir las inconsistencias de la herramienta, es una buena
    práctica contar con una medición desde front end disponible en el dataLayer para
    eventualmente aprovechar las ventajas de la medición vía GTM con otras
    herramientas (Por ejemplo: Facebook, Adwords, etc.).
    */

    Analytics.transaccionExitosa = function (name, price, started) {
        Analytics.pushData({
            'event': 'trackTransaction',
            'name': name, // Indicará un string con el nombre del paquete, por ejemplo: Acceso Digital     
            'price': price, // Valor de la suscripción
            'started': started, // Indicará con un string la letra del flujo por el cual inició. Por ejemplo: B
            'article': Model.Window.paginaId
        });
    };

    /* 
    -- 15
    Cuando un usuario ya tiene contratado un producto puede asociar el mismo para
    continuar sin cargo consumiendo contenidos al observar el muro. El éxito del proceso
    de asociación será medido aplicando una sentencia push al dataLayer, que incluirá
    los siguientes atributos:
    */

    Analytics.asociacionExitosa = function (type, started) {
        Analytics.pushData({
            'event': 'trackAccountLink',
            'accountType': type, // Indicará un string con el nombre del servicio que tiene el usuario, por ejemplo: Black       
            'started': started // Indicará con un string la letra del flujo por el cual inició. Por ejemplo: B
        });
    };

    Analytics.trackViewPaywall = function () {
        Analytics.pushData({
            'event': 'trackViewPaywall'
        });
    };

    /* CALL */
    Analytics.pushData = function (data) {
        typeof dataLayer !== 'undefined' && dataLayer && dataLayer.push(data);
    };
})(LN.Analytics, LN.Helper, LN.Config, LN.Model);

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    if (!LN.Core) throw new Error("LN.Core missing");
})();

(function (AppEvent, Model) {
    'use strict';

    AppEvent.sendEvent = function (event, data) {
        if (Model.Embed.Mobile) {

            var request = {
                event: event,
                data: data
            };
            console.log('AppEvent');
            console.log(request);
            try {
                webkit && webkit.messageHandlers.ios.postMessage(JSON.stringify(request));
            } catch (err) {
                console.error('Error IOs: ' + err.message);
            }
            try {
                android && android.performClick(JSON.stringify(request));
            } catch (err) {
                console.error('Error Android: ' + err.message);
            }
        }
    };
})(LN.AppEvent, LN.Model);

/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (Config, Constantes) {
    'use strict';

    Config.defaultModo = 'V';
    Config.defaultModoRedirect = 'C';
    Config.defaultCombo = '1';
    Config.urlRedirect = window.location.origin + "/suscripcion/C/";
    Config.urlRedirectAccion = window.location.origin + "/suscripcion/A/";
    Config.urlBlocks = window.location.origin + '/views/paywall/blocks/';
    Config.urlLayouts = window.location.origin + '/views/paywall/layouts/';
    Config.dominioIngresar = window.location.origin + "/ingresar/P/1/?callback=";
    Config.urlAvatar = Constantes.Dominios.static + "/images/avatar/";
    Config.urlEdicionImpresa = Constantes.Dominios.lanacion + "/edicion-impresa";

    Config.SitioOrigen = Constantes.SitioOrigen;

    Config.HotjarRecordingTrigger = Constantes.HotjarRecordingTrigger;

    Config.HotjarHeatmapFormDocumento = Constantes.HotjarHeatmapFormDocumento;
    Config.HotjarHeatmapFormPersonales = Constantes.HotjarHeatmapFormPersonales;
    Config.HotjarHeatmapFormDomicilio = Constantes.HotjarHeatmapFormDomicilio;
    Config.HotjarHeatmapFormPago = Constantes.HotjarHeatmapFormPago;
    Config.HotjarHeatmapWall = Constantes.HotjarHeatmapWall;

    /*nombres provisorios*/
    /*Estos datos tiene que ser pisados por lo venga en Constantes */
    Config.COMBO_ACCESO_DIGITAL = parseInt(Constantes.COMBO_ACCESO_DIGITAL); // 5;
    Config.COMBO_ACCESO_DIGITAL_CREDENCIAL = parseInt(Constantes.COMBO_ACCESO_DIGITAL_CREDENCIAL); //6;
    Config.COMBO_NYT = parseInt(Constantes.COMBO_NYT); //7;
    /*
     * Por ahora solo voy a configurar los que vayan en el wall
     */
    /*
    Config.COMBO_PROMO_ACCESO_DIGITAL_CREDENCIAL = parseInt(Constantes.COMBO_PROMO_ACCESO_DIGITAL_CREDENCIAL); // 8;
    Config.COMBO_CALL_ACCESO_Y_CLUB = parseInt(Constantes.COMBO_CALL_ACCESO_Y_CLUB);
    Config.COMBO_CALL_ACCESO_Y_CLUB_50_OFF = parseInt(Constantes.COMBO_CALL_ACCESO_Y_CLUB_50_OFF);
    Config.COMBO_CALL_ACCESO_Y_CLUB_5_DESCUENTO = parseInt(Constantes.COMBO_CALL_ACCESO_Y_CLUB_5_DESCUENTO);
    */

    Config.COMBO_BONIFICADO = parseInt(Constantes.COMBO_BONIFICADO); // 3;

    Config.PRODUCTO_NOTA = parseInt(Constantes.PRODUCTO_NOTA); // 1;
    Config.PRODUCTO_PDF = parseInt(Constantes.PRODUCTO_PDF); //2;
    Config.ACCION_YA_TIENE_SUSCRIPCION = 1;

    Config.Routes = Constantes.Routes;
    Config.ExternalPaywall = Constantes.ExternalPaywall;

    Config.debugMode = false;
    Config.debugFlowData = {
        "A": {
            codeResult: "04",
            message: ""
        },
        "B": {
            codeResult: "04",
            message: ""
        },
        "C": {
            codeResult: "04",
            message: ""
        },
        "D": {
            codeResult: "05",
            message: ""
        },
        "E": {
            codeResult: "01",
            message: ""
        },
        "F": {
            codeResult: "20",
            message: ""
        }
    };

    Config.defaultUrl = window.location.origin + '/suscripcion/' + Config.defaultModo + '/' + Config.defaultSitioId + '/?';

    Config.canalesDeVenta = Constantes.CanalesDeVenta;

    // ==================================================
    // Modos permitidos
    // al agrtegar una entrada en el route automaticamente la configura como modo permitido
    // ==================================================      
    Config.Modos = [];
    for (var x in LN.Config.Routes) {
        LN.Config.Modos.push(LN.Config.Routes[x].modo);
    }

    // ==================================================
    // Campañas permitidas 
    // 373 : Campaña bonificada
    // 374 : Campaña paga
    // ==================================================  
    Config.campaniaBonificada = Constantes.campaniaBonificada;
    Config.campaniaPaga = Constantes.campaniaPaga;

    Config.Layouts = {
        WALL: {
            file: 'wall',
            class: 'paywall',
            css: ''
        },
        WALL_DINAMICO: {
            file: 'wall_dinamico',
            class: 'landing newsletter',
            css: ''
        },
        WALL_SUSCRIBIME: {
            file: 'wall_suscribirme',
            class: 'paywall suscribirme-principal',
            css: ''
        },
        PROCESAR_PAGO: {
            file: 'procesar_pago',
            class: 'paywall',
            css: ''
        },
        FULL_SCREEN: {
            file: 'full_screen',
            class: 'formularios',
            css: ''
        },
        FULL_SCREEN_DATOS: {
            file: 'full_screen_datos',
            class: 'formularios',
            css: ''
        },
        TWO_COLUMNS: {
            file: 'two_columns',
            class: 'login paywall-login',
            css: ''
        },
        LANDING: {
            file: 'landing',
            class: 'landing',
            css: ''
        },
        WALL_FULL_SCREEN: {
            file: 'wall_full_screen',
            class: 'paywall',
            css: ''
        },
        PLAN_INSUFICIENTE: {
            file: 'plan_insuficiente',
            class: 'paywall',
            css: ''
        },
        NO_TIENE_SUSCRIPCION: {
            file: 'no_tiene_suscripcion',
            class: 'paywall',
            css: ''
        },
        PDF_SIN_SUSCRIPCION: {
            file: 'pdf_sin_suscripcion',
            class: 'paywall',
            css: ''
        },
        PDF_SUSCRIPTO_SIN_ACCESO: {
            file: 'pdf_suscripto_sin_acceso',
            class: 'paywall',
            css: ''
        }
    };

    // ==================================================
    // Constantes de steps o pasos
    // ==================================================  
    Config.Blocks = {
        WALL: {
            title: 'Acceso Digital',
            layout: 'WALL',
            file: '',
            class: '',
            forms: [],
            flow: []
        },
        WALL_DINAMICO: {
            title: 'Acceso Digital',
            layout: 'WALL_DINAMICO',
            file: '',
            class: '',
            forms: [],
            flow: []
        },
        WALL_SUSCRIBIME: {
            title: 'Acceso Digital',
            layout: 'WALL_SUSCRIBIME',
            file: '',
            class: '',
            forms: [],
            flow: []
        },
        PDF_SIN_SUSCRIPCION: {
            title: 'Acceso Digital',
            layout: 'PDF_SIN_SUSCRIPCION',
            file: '',
            class: '',
            forms: [],
            flow: []
        },
        PDF_SUSCRIPTO_SIN_ACCESO: {
            title: 'Acceso Digital',
            layout: 'PDF_SUSCRIPTO_SIN_ACCESO',
            file: '',
            class: '',
            forms: [],
            flow: []
        },
        PROCESAR_PAGO: {
            title: 'Acceso Digital',
            layout: 'PROCESAR_PAGO',
            file: '',
            class: '',
            forms: [],
            flow: []
        },
        PDF_MURO_SIN_COMBO: {
            title: 'Acceso Digital',
            layout: 'TWO_COLUMNS',
            file: 'pdf_muro_sin_combo',
            class: '',
            forms: [],
            flow: []
        },
        FORMULARIO_DATOS_PERSONALES: {
            title: 'Acceso Digital',
            layout: 'FULL_SCREEN_DATOS',
            file: 'formulario_datos_personales',
            forms: ['datos_personales'],
            class: '',
            flow: []
        },
        INGRESAR_DNI: {
            title: 'Acceso Digital',
            layout: 'FULL_SCREEN_DATOS',
            file: 'ingresar_dni',
            forms: ['datos_personales'],
            class: '',
            flow: []
        },
        FORMULARIO_PAGO: {
            title: 'Acceso Digital',
            layout: 'FULL_SCREEN_DATOS',
            forms: ['datos_envio', 'datos_tarjeta'],
            file: 'formulario_pago',
            class: '',
            flow: []
        },
        FORMULARIO_ENVIO: {
            title: 'Acceso Digital',
            layout: 'FULL_SCREEN_DATOS',
            forms: ['datos_envio', 'datos_tarjeta'],
            file: 'formulario_envio',
            class: '',
            flow: []
        },
        CONFIRMACION_COMBO_1: {
            title: 'Acceso Digital',
            layout: 'FULL_SCREEN',
            file: 'confirmacion_combo_1',
            forms: [],
            class: 'custom-felicitaciones',
            flow: []
        },
        CONFIRMACION_COMBO_2: {
            title: 'Acceso Digital',
            layout: 'FULL_SCREEN',
            file: 'confirmacion_combo_2',
            forms: [],
            class: 'custom-felicitaciones',
            flow: []
        },
        VALIDAR_PINES: {
            title: 'Acceso Digital',
            layout: 'WALL_FULL_SCREEN',
            file: 'validar_pines',
            forms: [],
            class: 'pin',
            flow: []
        },
        VALIDAR_PINES_GRACIAS: {
            title: 'Acceso Digital',
            layout: 'WALL_FULL_SCREEN',
            file: 'validar_pines_gracias',
            forms: [],
            class: 'pin',
            flow: []
        },
        FALTA_DE_PAGO: {
            title: 'Acceso Digital',
            layout: 'TWO_COLUMNS',
            file: 'falta_de_pago',
            forms: [],
            class: '',
            flow: []
        },
        YA_TIENE_CUENTA: {
            title: 'Acceso Digital',
            layout: 'TWO_COLUMNS',
            file: 'ya_tiene_cuenta',
            forms: [],
            class: '',
            flow: []
        },
        PRIMER_ACCESO: {
            title: 'Acceso Digital',
            layout: 'TWO_COLUMNS',
            file: 'primer_acceso',
            forms: [],
            class: '',
            flow: []
        },
        TIENE_DEUDA: {
            title: 'Acceso Digital',
            layout: 'TWO_COLUMNS',
            file: 'tiene_deuda',
            forms: [],
            class: '',
            flow: []
        },
        PLAN_INSUFICIENTE: {
            title: 'Acceso Digital',
            layout: 'PLAN_INSUFICIENTE',
            file: '',
            forms: [],
            class: '',
            flow: []
        },
        ASOCIAR_TARJETA: {
            title: 'Asociar Tarjeta',
            layout: 'TWO_COLUMNS',
            file: 'asociar_tarjeta',
            forms: [],
            class: '',
            flow: []
        },
        MOSTRAR_ERROR: {
            title: 'Error',
            layout: 'TWO_COLUMNS',
            file: 'mostrar_error',
            forms: [],
            class: '',
            flow: []
        },
        YA_COMPRO: {
            title: 'Acceso Digital',
            layout: 'TWO_COLUMNS',
            file: 'ya_compro',
            forms: [],
            class: '',
            flow: []
        },
        NO_TIENE_SUSCRIPCION: {
            title: 'Acceso Digital',
            layout: 'NO_TIENE_SUSCRIPCION',
            file: '',
            forms: [],
            class: '',
            flow: []
        },
        LANDING: {
            title: 'Acceso Digital',
            layout: 'LANDING',
            file: '',
            forms: [],
            class: '',
            flow: []
        },
        DOMICILIO_NO_EXISTE: {
            title: 'Acceso Digital',
            layout: 'TWO_COLUMNS',
            file: 'domicilio_no_existe',
            forms: [],
            class: '',
            flow: []
        },
        MOSTRAR_TRIBUNO: {
            title: 'Acceso Digital',
            layout: 'TWO_COLUMNS',
            file: 'mostrar_tribuno',
            forms: [],
            class: '',
            flow: []
        },
        MOSTRAR_UNO: {
            title: 'Acceso Digital',
            layout: 'TWO_COLUMNS',
            file: 'mostrar_uno',
            forms: [],
            class: '',
            flow: []
        },
        YA_TIENE_FACEBOOK: {
            title: 'Acceso Digital',
            layout: 'FULL_SCREEN',
            file: 'ya_tiene_facebook',
            forms: [],
            class: 'fbInsta custom-felicitaciones',
            flow: []
        },
        CONFIRMACION_BONIFICADO_FACEBOOK: {
            title: 'Acceso Digital',
            layout: 'FULL_SCREEN',
            file: 'confirmacion_bonificado_facebook',
            forms: [],
            class: 'fbInsta custom-felicitaciones',
            flow: []
        }
    };

    //Config.MostrarBotonSWG = Constantes.MostrarBotonSWG;
})(LN.Config, window.config.Constantes);

/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


window.LN = window.LN || {};
LN.App = {};
LN.Core = {};
LN.Config = {};
LN.Model = {};
LN.Service = {};
LN.Helper = {};
LN.Controller = {};
LN.Handler = {};
LN.Router = {};
LN.View = {};
LN.Message = {};
LN.Message.Analytics = {};
LN.Analytics = {};
LN.Hotjar = {};
LN.Validation = {};
LN.IFrames = {};
LN.AppEvent = {};
LN.SWG = {};
LN.FacebookInstantArticles = {};
LN.ViewPartial = {};

if (!Object.values) {
    Object.values = function (object) {
        return Object.keys(object).map(function (key) {
            return object[key];
        });
    };
}

/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _util = __webpack_require__(163);

(function () {
    if (!LN.Core) throw new Error("LN.Core missing");
})();

(function (Helper, Config, View, Model, Handlebars, Constantes, Validation, Message, Controller, Analytics, $, IFrames) {
    'use strict';

    var meses = {
        '0': 'Enero',
        '1': 'Febrero',
        '2': 'Marzo',
        '3': 'Abril',
        '4': 'Mayo',
        '5': 'Junio',
        '6': 'Julio',
        '7': 'Agosto',
        '8': 'Septiembre',
        '9': 'Octubre',
        '10': 'Noviembre',
        '11': 'Diciembre'
    };

    // ==================================================
    // Obtiene la descripcion del mes
    // Params : {Date}
    // ==================================================   
    Helper.getMonthDescription = function (date) {
        if ((typeof date === "undefined" ? "undefined" : _typeof(date)) != 'object') {
            date = new Date(date);
        }
        return meses[date.getMonth()];
    };

    // ==================================================
    // Setea el titulo de la pagina
    // Params : {string}
    // ==================================================    
    Helper.setPageTitle = function (title) {
        document.title = title;
    };

    Helper.setFirstStart = function (bool) {
        Model.Window.firstStart = bool;
    };

    Helper.checkFirstStart = function () {
        return Model.Window.firstStart;
    };

    // ==================================================
    // Redireccion
    // Params : {string}
    // ==================================================   
    Helper.redirectUrl = function (url) {
        window.location = url;
    };

    // ==================================================
    // Redireccion Passport
    // Params : {string}
    // ==================================================   
    Helper.redirectPassport = function (url) {
        window.location = Config.urlPassport + encodeURIComponent(url);
    };

    // ==================================================
    // Muestra preloader
    // ==================================================
    Helper.showPreloader = function () {
        $(document.body).addClass("loading").each(function () {
            //
        });
    };

    // ==================================================
    // Oculta preloader
    // ==================================================
    Helper.hidePreloader = function () {
        $(document.body).removeClass("loading").each(function () {
            $('.preloader').css('display', 'none');
        });
    };

    Helper.removeBlur = function () {
        $('#main-view').removeClass("loading");
    };

    // ==================================================
    // Valida si esta vacio cualquier tipo de dato
    // Params : {obj} || {arr} || {str}
    // ==================================================
    Helper.isEmpty = function (obj) {
        if (obj == null) return true;
        if (obj.length > 0) return false;
        if (obj.length === 0) return true;
        for (var key in obj) {
            if (hasOwnProperty.call(obj, key)) return false;
        }
        return true;
    };

    Helper.setToken = function (token) {
        if (Helper.isEmpty(token)) return;
        Helper.createCookie('token', token, Config.cookieExpirationTime, Config.dominioCookie);
        Model.Usuario.xToken = token;
    };

    Helper.updateToken = function () {
        Model.Usuario.xToken = Helper.readCookie("token");
    };

    Helper.setXValue = function (xvalue) {
        if (Helper.isEmpty(xvalue)) return;
        Helper.createCookie('xvalue', xvalue, Config.cookieExpirationTime, Config.dominioCookie);
        Model.Usuario.xValue = xvalue;
    };

    // ==================================================
    // Setea en cookies todo un objeto
    // ==================================================
    Helper.setupCookies = function (obj) {
        for (var key in obj) {
            var aux;
            var cookie;
            // Busco si la key se encuentra en el diccionario de cookies para ver si la grabo o no . 
            if (Config.DiccionarioCookiesAGuardar.indexOf(key) > -1 && typeof obj[key] == "string") {
                switch (key) {
                    case 'UsuarioDetalleGuid':
                        aux = "usuario%5Fdetalle%5Fguid";
                        cookie = '{' + Helper.readCookie("token") + '}';
                        break;
                    case 'UsuarioDetalleNick':
                        aux = "usuario%5Fdetalle%5Fnick";
                        cookie = obj[key];
                        break;
                    case 'UsuarioId':
                        aux = "usuario%5Fid";
                        cookie = obj[key];
                        break;
                    case 'UsuarioUsuario':
                        aux = "usuario%5Fusuario";
                        cookie = obj[key];
                        break;
                    case 'usuarioLogTkn':
                        aux = "usuario%5Flogtkn";
                        cookie = obj[key];
                        break;
                    case 'TokenJWT':
                        aux = "PersoTKN";
                        cookie = obj[key];
                        break;
                    default:
                        aux = key;
                        cookie = obj[key];
                }
                //console.log("Create Cookie - Name : " + aux + " - Value : " + cookie);
                Helper.createCookie(aux, cookie, Config.cookieExpirationTime, Config.dominioCookie);
            }
        }
    };

    // ==================================================
    // Crea una cookie
    // Params : {str} {str} {str} {str}
    // ==================================================
    Helper.createCookie = function (name, value, seconds, domain) {
        var expires;
        if (seconds) {
            var date = new Date();
            date.setTime(date.getTime() + seconds * 1000);
            expires = "; expires=" + date.toGMTString();
        } else {
            expires = "";
        }

        if (document.domain === 'localhost') {
            document.cookie = name + "=" + value + expires + "; path=/";
        } else {
            document.cookie = name + "=" + value + expires + ";domain=" + domain + "; path=/";
        }
    };

    // ==================================================
    // Lee el valor de una cookie
    // Params : {str}
    // ==================================================   
    Helper.readCookie = function (name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1, c.length);
            }if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    };

    // ==================================================
    // Borra todas las cookies
    // ==================================================   
    Helper.deleteAllCookies = function () {
        var cookies = document.cookie.split(";");
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            var eqPos = cookie.indexOf("=");
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;

            if (Config.DiccionarioCookiesAGuardar.indexOf(name.trim()) > -1) {
                if (document.domain === 'localhost') {
                    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
                } else {
                    //console.log("Delete Cookie - Name : " + name);
                    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=" + Config.dominioCookie;
                }
            }
        }
    };

    // ==================================================
    // Borra cookie según nombre dado 
    // ==================================================   
    Helper.deleteCookie = function (name) {
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=" + Config.dominioCookie;
    };

    // ==================================================       
    Helper.setCanSubmit = function (bool) {
        Model.Window.canSubmit = bool;
    };

    Helper.canSubmit = function () {
        return Model.Window.canSubmit;
    };

    // ==================================================
    // Trae Todos los inputs del dom
    // ==================================================   
    Helper.getAllInputs = function () {
        var inputs = $(':input');
        var values = {};
        inputs.each(function () {
            values[this.name] = $(this).val();
        });
        return values;
    };

    // ==================================================
    // Trae Todos los inputs del dom y los convierte a un objeto
    // ==================================================   
    Helper.getAllInputsObject = function () {
        var inputs = $(':input');
        return inputs;
    };

    // ==================================================
    // Extrae un parametro de la current url
    // ==================================================   
    Helper.getURLParameter1 = function (n) {
        return decodeURIComponent((new RegExp('[?|&]' + n + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
    };

    Helper.getURLPath = function () {
        var pathArray = window.location.pathname.split('/');
        return pathArray[1];
    };

    Helper.getSource = function () {
        return Model.Window.source;
    };

    Helper.getURLParameter = function (n) {
        //deprecado

        var pathArray = window.location.pathname.replace("/suscripcion/", "").replace("/que-es-acceso-digital/", "").replace("/acceso-digital/", "").replace('/validar-pin/', '').split('/');
        switch (n) {
            case 'param1':
                return !Helper.isEmpty(pathArray[0]) ? pathArray[0] : null;
                break;
            case 'param2':
                return !Helper.isEmpty(pathArray[1]) ? pathArray[1] : null;
                break;
            case 'param3':
                return !Helper.isEmpty(pathArray[2]) ? pathArray[2] : null;
                break;
            case 'param4':
                return !Helper.isEmpty(pathArray[3]) ? pathArray[3] : null;
                break;
            default:
                return null;
                break;
        }
    };

    Helper.getURLPathParameter = function (n) {
        var pathArray = window.location.pathname.split('/');
        switch (n) {
            case 'param1':
                return !Helper.isEmpty(pathArray[2]) ? pathArray[2] : null;
                break;
            case 'param2':
                return !Helper.isEmpty(pathArray[3]) ? pathArray[3] : null;
                break;
            case 'param3':
                return !Helper.isEmpty(pathArray[4]) ? pathArray[4] : null;
                break;
            case 'param4':
                return !Helper.isEmpty(pathArray[5]) ? pathArray[5] : null;
                break;
            default:
                return null;
                break;
        }
    };

    Helper.redirectToLogin = function (url) {
        var encode_url = window.btoa(Model.Window.location);
        if (!Helper.isEmpty(url)) encode_url = window.btoa(url);
        LN.AppEvent.sendEvent('REDIRECT', window.atob(encode_url));
        if (Model.Embed.Mobile) {
            return;
        }
        if (Model.Embed.Article) {
            encode_url = encode_url + '&article=' + true;
        }
        Helper.redirectUrl(Config.dominioIngresar + encode_url);
    };

    var AppendMultipleParams = function AppendMultipleParams(url, keys, values) {
        var i = 0;
        for (i in keys) {
            url = AppendToUrl(url, keys[i], values[keys[i]]);
        }
        return url;
    };

    var AppendToUrl = function AppendToUrl(url, key, value) {
        if (url.indexOf('?') == -1) {
            url = url + '?';
        } else {
            url = url + '&';
        }
        url = url + key + '=' + value;
        return url;
    };

    var urlBuilder = function urlBuilder(url) {
        if (Model.canalDeVenta != 0) {
            url = AppendToUrl(url, 'cv', Model.canalDeVenta);
        }
        if (Model.Window.contact != 0) {
            url = AppendToUrl(url, 'fc', Model.Window.contact);
        }
        if (Model.Window.pagina) {
            url = AppendToUrl(url, 'callback', window.btoa(Model.Window.pagina));
        }
        if (Model.ExternalPaywall.Name) {
            url = AppendMultipleParams(url, Model.ExternalPaywall.Params, Model.ExternalPaywall.Values);
        }

        return url;
    };

    Helper.redirectToLoginWAction = function (accion) {
        //redirecciona a login para que vuelva a una pagina de accion /A/1/?algo... EJ YA TENGO..
        var url = Config.urlRedirectAccion + accion + '/?';
        url = urlBuilder(url);
        var encode_url = window.btoa(url);
        LN.AppEvent.sendEvent('REDIRECT', window.atob(encode_url));
        if (Model.Embed.Mobile) {
            return;
        }
        encode_url = Config.dominioIngresar + encode_url;
        if (Model.Embed.Article) {
            encode_url = AppendToUrl(encode_url, 'article', true);
        }
        Helper.redirectUrl(encode_url);
    };

    Helper.redirectToLoginWReturnAction = function (url, action) {
        var currentLocation = Model.Window.location;
        if (!Helper.isEmpty(url)) currentLocation = Model.Window.origin + url;
        if (action) {
            if (currentLocation.includes('?')) {
                currentLocation = currentLocation + '&a=' + action;
            } else {
                currentLocation = currentLocation + '/?a=' + action;
            }
        }
        var encode_url = window.btoa(currentLocation);
        LN.AppEvent.sendEvent('REDIRECT', currentLocation);
        if (Model.Embed.Mobile) {
            return;
        }
        Helper.redirectUrl(Config.dominioIngresar + encode_url);
    };

    Helper.redirectToLoginWCombo = function (combo) {
        //redirecciona a login para que vuelva a una pagina de Compra /C/14/?algo... carrito
        var url = Config.urlRedirect + combo + '/?';
        url = urlBuilder(url);
        var encode_url = window.btoa(url);
        LN.AppEvent.sendEvent('REDIRECT', window.atob(encode_url));
        if (Model.Embed.Mobile) {
            return;
        }
        encode_url = Config.dominioIngresar + encode_url;
        if (Model.Embed.Article) {
            encode_url = AppendToUrl(encode_url, 'article', true);
        }
        Helper.redirectUrl(encode_url);
    };

    Helper.getURLQueryString = function () {
        return window.location.search.replace("?", "");
    };

    Helper.removeCustomClass = function () {
        $(document.body).removeClass(function (index, className) {
            return (className.match(/(^|\s)custom-\S+/g) || []).join(' ');
        });
    };

    Helper.addCustomClass = function (c) {
        $(document.body).addClass(c);
    };

    // ==================================================
    // Helpers Custom
    // ================================================== 

    // ==================================================
    // Setea el step actual en el modelo Window
    // ==================================================     
    Helper.setCurrentStep = function (step) {
        Model.Window.currentStep = step;
    };

    Helper.getCurrentStep = function () {
        return Model.Window.currentStep;
    };

    Helper.setCurrentLayout = function (layout) {
        Model.Window.currentLayout = layout;
    };

    Helper.getCurrentLayout = function () {
        return Model.Window.currentLayout;
    };

    Helper.callView = function (view, data, cb, reload) {
        Helper.addStep(view, data, cb, reload);
    };

    // ==================================================
    // Valida si el modo en la URL esta permitido (Se saca desde config.js)
    // ================================================== 
    Helper.modoPermitido = function (modo) {
        if (Config.Modos.indexOf(modo) == -1) return false;
        return true;
    };

    // ==================================================
    // Valida si el sitio en la URL esta permitido (Se saca desde config.js)
    // ================================================== 
    Helper.sitioPermitido = function (sitio) {
        if (Config.Sitios[sitio] == null) return false;
        return true;
    };

    Helper.ocultarMail = function (email) {
        if (email != null && email != "" && email != "undefined") {
            var hasta = email.indexOf('@');
            var dominio = email.substring(hasta, email.length);
            var nombreMail = email.substring(0, 1) + "****";
            nombreMail += dominio;
            return nombreMail;
        }
        return "";
    };

    Helper.getTemplateAjax = function (path, data, selector, cb) {
        var source;
        var template;
        var viewContent = {
            Config: Config,
            Model: Model,
            Data: data,
            Message: Message,
            Constantes: Constantes,
            Combo: function Combo(combo, options) {
                var p = Model.getPlan(combo);
                if (p) return options.fn(p);else return options.inverse(this);
            },
            MonthLegend: function MonthLegend(meses) {
                if (!meses) return '';
                if (meses === 1) {
                    return 'mes';
                } else {
                    return 'meses';
                }
            },
            OneMonth: function OneMonth(meses, options) {
                if (!meses) return false;
                if (meses === 1) return options.fn(true);
                return options.inverse(this);
            },
            PriceFormat: function PriceFormat(price) {
                if ((0, _util.isNullOrUndefined)(price)) return '';
                return new Handlebars.SafeString(price.toFixed(2));
                //if (price % 1 != 0)// tiene decimales

                //else
                //    return new Handlebars.SafeString(price.toString());
            },
            Ceil: function Ceil(price) {
                if ((0, _util.isNullOrUndefined)(price)) return '';
                return new Handlebars.SafeString(Math.ceil(price));
            },
            CurrentMonth: function CurrentMonth() {
                var date = new Date();
                return Helper.getMonthDescription(date);
            },
            NextMonth: function NextMonth() {
                var date = new Date();
                date.setMonth(date.getMonth() + 1);
                return Helper.getMonthDescription(date);
            }
        };

        $.ajax({
            url: path,
            cache: true
        }).done(function (res, status, xhr) {
            source = res;
            template = Handlebars.compile(source);
            $(selector).html(template(viewContent)).each(function () {
                if (path.indexOf("wall_suscribirme") >= 0) {
                    console.log('wall_suscribirme');
                }
                cb && cb();
            });
        });
    };

    Helper.guid = function () {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    };
    // ==================================================
    // Agrega una nueva vista reemplazando la actual
    // step = Step valido sacado de config.js
    // data = Todas las vistas tienen objeto de referencia llamado Data para ser usado por handlebars al compilar, se envia en forma de objeto 
    // cb = callback post ejecucion
    // reload = true / false Esto permite forzar el reload de una pantalla si lo requisiera
    // ==================================================     
    Helper.addStep = function (step, data, cb, reload) {

        var currentStep = Helper.getCurrentStep();
        var stepFile = Config.Blocks[step].file;
        var stepCustomClass = Config.Blocks[step].class;
        var stepLayout = Config.Layouts[Config.Blocks[step].layout].file;
        var stepLayoutClass = Config.Layouts[Config.Blocks[step].layout].class;
        var flow = Config.Blocks[step].flow;
        var data = data || {};
        Helper.setPageTitle(Config.Blocks[step].title);
        if (flow.length > 0 && flow.indexOf(currentStep) === -1) throw new Error("Flow no permitido");

        // si queres ejecutar el mismo flow devuelve true
        //console.log(currentStep,stepFile)
        //if (!Helper.isEmpty(currentStep) && !Helper.isEmpty(stepFile) && (currentStep === stepFile)) return true;

        LN.Helper.showPreloader();
        // Pregunto si esta el layout cargado de este step
        if (document.getElementById(stepLayout) === null || reload) {
            $(document.body).fadeOut('fast', function () {
                Helper.getTemplateAjax(Config.urlLayouts + stepLayout, data, document.body, function () {
                    // Agrego la class al body desde el config
                    $(document.body).removeClass().addClass(stepLayoutClass);
                    // Pregunto si el step o block esta cargado o necesita recargarse
                    if (!Helper.isEmpty(stepFile)) {
                        if (document.getElementById(stepFile) === null || reload) {
                            $('#main-block').fadeOut('fast', function () {
                                Helper.getTemplateAjax(Config.urlBlocks + stepFile, data, '#main-block', function () {
                                    // Quito las custom class del body si existiera
                                    Helper.removeCustomClass();
                                    // Agrego la custom class
                                    Helper.addCustomClass(stepCustomClass);
                                    $('.steps').addClass('hide').each(function (index, el) {
                                        // Valida si es landing o formuarios         
                                        Helper.cleanKeyPress();
                                        Helper.hidePreloader();
                                        Helper.explorador();
                                        Helper.disableTop();
                                        Helper.quickView();
                                        Helper.addReturnBackArrow();
                                        Helper.placeHolderAnimationOnStepLoad();
                                        // Muestro el body y el contenido
                                        $(document.body).fadeIn('fast').each(function () {
                                            $('#main-block').fadeIn('fast');
                                        });
                                        if (Model.PlanElegido) {
                                            Analytics.paginaVirtual(stepFile, Model.PlanElegido.nombre);
                                        }
                                        if (Helper.checkFirstStart() === false) {
                                            typeof ga !== "undefined" && ga('set', 'page', '/' + stepFile);
                                            typeof ga !== "undefined" && ga('send', 'pageview');
                                        }
                                        Helper.setFirstStart(false);
                                        cb && cb();
                                    });
                                });
                            });
                        }
                    } else {
                        // Pagina sin bloques
                        $(document.body).fadeIn('fast');
                        if (Model.PlanElegido) {
                            Analytics.paginaVirtual(stepLayout, Model.PlanElegido.nombre);
                        }
                        Helper.quickView();
                        cb && cb();
                    }
                });
            });
        } else {
            // Si ya esta cargado el layout
            if (!Helper.isEmpty(stepFile)) {
                if (document.getElementById(stepFile) === null || reload) {
                    $('#main-block').fadeOut('fast', function () {
                        Helper.getTemplateAjax(Config.urlBlocks + stepFile, data, '#main-block', function () {
                            // Quito las custom class del body si existiera
                            Helper.removeCustomClass();
                            // Agrego la custom class
                            Helper.addCustomClass(stepCustomClass);
                            $('.steps').addClass('hide').each(function (index, el) {
                                Helper.cleanKeyPress();
                                Helper.hidePreloader();
                                Helper.explorador();
                                Helper.disableTop();
                                Helper.quickView();
                                Helper.addReturnBackArrow();
                                Helper.placeHolderAnimationOnStepLoad();
                                if (Model.PlanElegido) {
                                    Analytics.paginaVirtual(stepFile, Model.PlanElegido.nombre);
                                }
                                // Muestro el body y el contenido
                                $(document.body).fadeIn('fast').each(function () {
                                    $('#main-block').fadeIn('fast');
                                });
                                cb && cb();
                            });
                        });
                    });
                }
            } else {
                // Pagina sin bloques
                $(document.body).fadeIn('fast');
                Analytics.paginaVirtual(stepLayout, Model.PlanElegido.nombre);
                cb && cb();
            }
        }
        Helper.setCurrentLayout(stepLayout);
        Helper.setCurrentStep(stepFile);
    };

    Helper.addReturnBackArrow = function () {
        if ($(".atras-form").length) $('#atras-header').attr('data-step', $(".atras-form").data('step'));
    };

    Helper.explorador = function () {
        // NAVEGADOR FIX
        var BrowserDetect = {
            init: function init() {
                this.browser = this.searchString(this.dataBrowser) || "An unknown browser";
                this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || "an unknown version";
                this.OS = this.searchString(this.dataOS) || "an unknown OS";
            },
            searchString: function searchString(data) {
                for (var i = 0; i < data.length; i++) {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;
                    this.versionSearchString = data[i].versionSearch || data[i].identity;
                    if (dataString) {
                        if (dataString.indexOf(data[i].subString) != -1) return data[i].identity;
                    } else if (dataProp) return data[i].identity;
                }
            },
            searchVersion: function searchVersion(dataString) {
                var index = dataString.indexOf(this.versionSearchString);
                if (index == -1) return;
                return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
            },
            dataBrowser: [{ string: navigator.userAgent, subString: "Chrome", identity: "Chrome" }, { string: navigator.userAgent, subString: "OmniWeb", versionSearch: "OmniWeb/", identity: "OmniWeb" }, { string: navigator.vendor, subString: "Apple", identity: "Safari", versionSearch: "Version" }, { prop: window.opera, identity: "Opera", versionSearch: "Version" }, { string: navigator.vendor, subString: "iCab", identity: "iCab" }, { string: navigator.vendor, subString: "KDE", identity: "Konqueror" }, { string: navigator.userAgent, subString: "Firefox", identity: "Firefox" }, { string: navigator.vendor, subString: "Camino", identity: "Camino" }, { // for newer Netscapes (6+)
                string: navigator.userAgent,
                subString: "Netscape",
                identity: "Netscape"
            }, { string: navigator.userAgent, subString: "MSIE", identity: "Explorer", versionSearch: "MSIE" }, { string: navigator.userAgent, subString: "Gecko", identity: "Mozilla", versionSearch: "rv" }, { // for older Netscapes (4-)
                string: navigator.userAgent,
                subString: "Mozilla",
                identity: "Netscape",
                versionSearch: "Mozilla"
            }],
            dataOS: [{ string: navigator.platform, subString: "Win", identity: "Windows" }, { string: navigator.platform, subString: "Mac", identity: "Mac" }, { string: navigator.userAgent, subString: "iPhone", identity: "iPhone/iPod" }, { string: navigator.platform, subString: "Linux", identity: "Linux" }]

        };
        BrowserDetect.init();
        var browserDetection = BrowserDetect.browser;
        var browserVersion = 'v' + BrowserDetect.version;
        var OSname = BrowserDetect.OS;
        $('body').addClass(browserDetection + ' ' + browserVersion + ' ' + OSname);
        // NAVEGADOR FIX
    };

    Helper.disableTop = function () {
        if ($('.cabezal-black').length) {
            $('main').addClass('login-black');
            $('#main-view').addClass('no-top');
            $(window).on("load", function (event) {
                if ($(this).width() < 999) {
                    $(".bottom-content, #contenedor>div").addClass('mobile');
                } else {
                    $(".bottom-content, #contenedor>div").removeClass('mobile');
                }
            });
        };
        $('body').scrollTop(0);
    };

    Helper.returnBack = function (options) {
        var pagina = !Helper.isEmpty(options) && !Helper.isEmpty(options.url) ? options.url : Model.Window.pagina;
        if (!Helper.isEmpty(pagina)) Helper.redirectUrl(pagina || Config.defaultRedirectUrl);
    };

    Helper.returnBackPassport = function (options) {
        var pagina = !Helper.isEmpty(options) && !Helper.isEmpty(options.url) ? options.url : Model.Window.pagina;
        if (!Helper.isEmpty(pagina)) Helper.redirectPassport(pagina || Config.defaultRedirectUrl);
    };

    Helper.returnBackLogout = function (options) {
        var pagina = !Helper.isEmpty(options) && !Helper.isEmpty(options.url) ? options.url : Model.Window.pagina;
        if (!Helper.isEmpty(pagina)) Helper.redirectUrl(pagina || Config.defaultRedirectUrl);
    };

    Helper.changeStatus = function (selector, status, message, cb) {
        Helper.displayMessage(selector, status);
        Helper.hidePreloader();
        if (status == false && message) {
            selector.parent().find('span').html(message);
        } else if (selector.parent().find('span').hasClass('current')) {
            // Valido para el nice-select
        } else {
            selector.parent().find('span').html('');
        }
        cb && cb();
    };

    Helper.cleanStatus = function (selector) {

        if (!selector.parent().hasClass('input')) return;

        selector.removeClass("error");
        selector.removeClass("check");
        selector.parent().removeClass("error");
        selector.parent().removeClass("check");

        if (selector.parent().find('span').hasClass()) return;
        selector.parent().find('span').html('');
    };

    Helper.displayMessage = function (selector, status) {
        if (status) {
            selector.parent(".input").removeClass('error');
            selector.parent(".input").addClass('check');
        } else {
            selector.parent(".input").addClass('error');
            selector.parent(".input").removeClass('check');
        }
    };

    Helper.showBlockMessageError = function (s) {
        Helper.hidePreloader();
        $("." + s).css("display", "initial");
        var text = $("." + s).find('p').text();
        Analytics.error(text);
        var topError = $("." + s).offset().top;
        $("body, html").animate({
            scrollTop: topError - 100
        }, 500);
    };

    Helper.hideCustomMessageError = function (s) {
        //Helper.hidePreloader();
        $("." + s).css("display", "none");
    };

    Helper.placeHolderAnimation = function (obj, method) {
        obj.parent(".input").each(function () {
            $("label", this).css({
                "line-height": "20px",
                "font-size": "12px",
                "top": "0px"
            });
            $(".spin", this).css({
                "width": "100%"
            });
            if (method != "focus") $("input", this).focus();
        });
    };

    Helper.placeHolderAnimationOnStepLoad = function () {
        $('input').each(function () {
            if (!Helper.isEmpty($(this).val())) {
                //Helper.changeStatus($(this), true);
                Helper.enableNextButton();
                $(this).parent().find("label").css({
                    "line-height": "20px",
                    "font-size": "12px",
                    "top": "0px"
                });
            }
        });
    };

    Helper.checkNextButton = function (selector) {
        Helper.cleanStatusInputs();
        if (!Helper.isEmpty(selector.val())) Helper.enableNextButton();else Helper.disableNextButton();
    };

    Helper.enableNextButton = function () {
        $('.next-step').addClass('active');
        $('.next-step').prop("disabled", false);
    };

    Helper.disableNextButton = function () {
        $('.next-step').removeClass('active');
        $('.next-step').prop("disabled", true);
    };

    Helper.placeHolder = function () {
        //if ($('.mostrarPass').length > 0) {
        //Helper.showHide();
        //}   
        $(document.body).on('click', "div.input label", function (e) {
            e.preventDefault();
            Helper.placeHolderAnimation($(this), "click");
        });

        $(document.body).on('focus', "div.input input", function (e) {
            e.preventDefault();
            Helper.placeHolderAnimation($(this), "focus");
        });

        $(document.body).on('blur', "div.input input", function (e) {
            $(".spin").css({
                "width": "0px"
            });
            if ($(this).val() == "") {
                $(this).parent(".input").each(function () {
                    $("label", this).css({
                        "line-height": "33px",
                        "font-size": "14px",
                        "font-weight": "400",
                        "top": "15px"
                    });
                });
            }
        });
    };

    Helper.cleanSpecialCharsInput = function (str) {
        return Helper.removeDiacritics(Helper.removeSpecialChars(str));
    };

    Helper.removeSpecialChars = function (str) {
        return str.replace(/[^a-zA-ZÀ-ÿ ]/g, "");
    };

    Helper.removeDiacritics = function (str) {
        var defaultDiacriticsRemovalMap = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

        for (var i = 0; i < defaultDiacriticsRemovalMap.length; i++) {
            str = str.replace(defaultDiacriticsRemovalMap[i].letters, defaultDiacriticsRemovalMap[i].base);
        }
        return str;
    };

    Helper.initialpreloader = function () {
        //$(document.body).html('<div class="preloader-main"><span class="preloader-gif"></span></div>')
        $('.preloader').delay(400).fadeOut(500);
    };

    Helper.cleanInputs = function () {
        $('.input input').val('');
    };

    Helper.cleanStatusInputs = function () {
        $(".input").each(function () {
            if (($(this).hasClass("error") || $(this).hasClass("check")) && $(this).hasClass("no-validate-keyup") == false && $(this).find("input").val() !== 0) {
                Helper.cleanStatus($(this));
            }
        });
    };

    Helper.cleanInputName = function (s) {
        var n = s.attr("name").match(/\[.*?\]/);
        var o = n[0].replace("[", "").replace("]", "");
        return o;
    };

    Helper.globalResize = function () {
        Model.Window.width = $(window).width();
        Model.Window.height = $(window).height();
    };

    Helper.carrito = function () {
        /*defino el alto para el despelgable dinamico*/
        var altoCarro = $(".carrito").height() - 60;
        $(".carrito").css({ "bottom": "-" + altoCarro + "px" });

        /*carrito click despelgable dinamico*/
        $(".carrito > div:first-child").off('click').on("click", function () {
            var flechita = $(".carrito > div:first-child > span:first-child");
            $(".carrito").toggleClass("abrir");

            if ($(".carrito.abrir").length > 0) {
                flechita.removeClass("icon-arrow-up");
                flechita.addClass("icon-arrow-down");
            } else {
                flechita.removeClass("icon-arrow-down");
                flechita.addClass("icon-arrow-up");
            }
        });
        //para que el loader quede siempre en el medio dependiendo del tamaño del main
        $('.preloader-gif').css({ 'left': $('main').width() / 2 + 'px' });

        //hacemos que el carrito se oculte cuando se despliega el teclado.
        var $carrito = document.querySelector('.carrito');
        var altoInicial = window.innerHeight;

        window.addEventListener('resize', function () {
            if (window.innerHeight != altoInicial) {
                $carrito.style.display = "none";
            } else {
                $carrito.style.display = "block";
            }
        }, true);
    };

    Helper.yaCompraste = function () {
        //cambios en el carrito cuadno compra DESKTOP
        $('.call').css({ 'display': 'none' });
        $('.recordar').css({ 'display': 'none' });
        $('.icon-carrito').addClass('move');
        $('.producto h3').addClass('bounceOutRight');
        setTimeout(function () {
            $('.producto h3').html('Compraste');
            $('.producto h3').removeClass('bounceOutRight');
            $('.producto h3').addClass('fadeInUp2');
            $('.producto div.icon-carrito div:first-child').addClass('zoomIn');
        }, 1000);
    };
    // on resize
    Helper.onResize = function () {
        Model.Window.width = $(window).width();
        Model.Window.height = $(window).height();
    };

    Helper.cleanKeyPress = function () {
        Model.Window.keyPress = 0;
    };

    // ==================================================
    // Limpia el modelo, cookies y resetea parametros de URL
    // ==================================================   
    Helper.resetAll = function (cb) {
        $(':input').val('');
        for (var index in Model.Usuario) {
            Model.Usuario[index] = '';
        }
        Helper.deleteAllCookies();
        Model.Usuario.SitioId = Model.Window.SitioId;
        cb && cb();
    };

    Helper.showModalAddress = function () {
        $(".modal_address").fadeIn();

        if (Model.getInputsBy("datos_envio", 'pais').get().value != "AR") {
            $(".form-digital-exterior").css("display", "initial");
            $(".form-digital").css("display", "none");
        } else {
            $(".form-digital-exterior").css("display", "none");
            $(".form-digital").css("display", "initial");
        }
    };

    Helper.hideButtonNewAddress = function () {
        $("#nuevo-dom").fadeOut();
    };

    Helper.hideModalAddress = function () {
        $(".modal_address").fadeOut();
    };

    Helper.checkIfAddressExist = function (address) {
        for (var i in Model.Domicilios) {
            if (Model.Domicilios[i].domicilio === address.calle + ' ' + address.altura) return Model.Domicilios[i].id;
        }
        return false;
    };

    Helper.selectAddressRadio = function (id) {

        $(".toggle-nuevo-dom").prop("disabled", true);

        $(':input[name="datos_envio[selector]"]').each(function () {
            if ($(this).val() === id) {
                $(this).prop('checked', true);
                $(this).prop('disabled', false);
                Model.getInputsBy("datos_envio", 'id').set(id);
                // Toggle al menu de nuevo domicilio
                if ($(".nuevo-dom").is(':visible')) {
                    Model.getInputsBy("datos_envio").clean();
                    $(".nuevo-dom").toggle();
                }
                return true;
            }
        });
    };

    // ==================================================
    // Obtiene la IP local/publica a traves de webrtc
    // ==================================================    


    Helper.getClientIP = function () {
        window.RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
        var client = new RTCPeerConnection({ iceServers: [] }),
            noop = function noop() {};
        client.createDataChannel(""); //create a bogus data channel
        client.createOffer(client.setLocalDescription.bind(client), noop); // create offer and set local description
        client.onicecandidate = function (ice) {
            //listen for candidate events
            if (!ice || !ice.candidate || !ice.candidate.candidate) return;
            var ip = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/.exec(ice.candidate.candidate)[1];
            Model.Window.ip = ip;
            client.onicecandidate = noop;
        };
    };

    Helper.eventosDatosPersonales = function () {
        /* $(document).on('change', 'input[name="datos_personales[tipo_documento]"]', function(e) {
             var optionSelected = $('input[name="datos_personales[tipo_documento]"] option:selected').val();
             (optionSelected == 'PAS') ? $('input[name="datos_personales[tipo_documento]"]').attr('type', 'text'): $('input[name="datos_personales[tipo_documento]"]').attr('type', 'number');
         });        */
        /*FUNCION CENTRAR LOAD EN MAIN*/
        var mainWidth = $("main").width();
        mainWidth = mainWidth / 2;
        $('.preloader .preloader-gif').css({ 'left': mainWidth + 33 + 'px' });

        /*FUNCION TOOLTIP*/
        $('.icon-ayuda').click(function () {
            if ($(".visible").length > 0) {
                $('.tooltip').fadeOut();
                $('.tooltip').removeClass("visible");
            } else {
                $('.tooltip').fadeIn();
                $('.tooltip').addClass("visible");
            }
            return false;
        });
        $('body').click(function () {

            if ($(".visible").length > 0) {
                $('.tooltip').fadeOut();
                $('.tooltip').removeClass("visible");
            }
        });

        $(':radio[name="datos_personales[selector_residencia]"]').change(function () {
            $(this).prop('checked', true);

            Model.getInputsBy("datos_personales", 'residencia').set($(this).val());
            if (Model.PlanElegido.planConCredencial) {
                if ($(this).val() == 'true') {
                    // Es extranjero
                    $(".modal_country").fadeIn();
                    $(".modal_country, .modal-pais span button").on("click", function () {
                        $(".modal").fadeOut();
                    });
                    $("#plan_elegido_imagen").attr('src', Model.PlanElegido.imagenExtranjera);
                } else {
                    $("#plan_elegido_imagen").attr('src', Model.PlanElegido.imagen);
                    //$("#plan_elegido_nombre").html(combo.nombre);
                    // $("#plan_elegido_nombre_mobile").html(combo.nombre);
                }
            }
        });

        // (Model.Cliente.comboElegido == Config.COMBO_ACCESO_DIGITAL) ? $(".carrito .tarjeta-premium").hide() : null;

        if ($(window).width() > 768) $(".nombre").focus();
    };

    Helper.eventosInicio = function () {
        // Acción de click en todo el div de combo, no solo en Suscribirme . 
        $(".combo").click(function (event) {
            // Valido que el click no se haga en el expandir detalles .
            // Ni tampoco en el botón de continuar (que ya está seteado el step)
            if (!$(event.target).hasClass("ver-mas") && !$(event.target).hasClass("btn-principal") && !$(event.target).hasClass("swg-button-light")) {
                var btnContinuar = $(this).find(".btn-principal");
                Controller.inicio(btnContinuar.data('combo'));
            }
        });
    };

    Helper.eventosInicioMuroNuevo = function () {

        //===========================
        //Animacion combos
        //===========================

        //------Funcion para agregar una misma fn a varios metodos del eventListener //
        function addListenerMulti(el, s, fn) {
            s.split(' ').forEach(function (e) {
                return el.addEventListener(e, fn, false);
            });
        }

        //-----funcion que realiza el evento cuando la seccion se visualiza en el monitor en el primer render o se llega mediante scroll------
        var elementView = function elementView($section, Hagamoslo, parametros) {
            if (parametros.PANTALLA_BOTTOM > $section.offsetTop && parametros.PANTALLA_ARRIBA < $section.offsetTop + $section.offsetHeight) {
                Hagamoslo();
            }
        };

        //------funcion en el cual recorre un all y le asigna un valor de aniamcion------     
        var visibleArticle = function visibleArticle(elemento, animacion, delay) {
            var num = 0;
            // hago el undefined poruqe si viene un solo elemento el Array.from rompe
            if (elemento.length !== undefined) {
                Array.from(elemento).map(function (item) {
                    item.classList.add(animacion);
                    item.style.animationDelay = num + 's';
                    num += delay;
                });
            } else {
                elemento.classList.add(animacion);
                elemento.style.animationDelay = num + 's';
            }
        };

        //------Aca armamos todos los elementos que queremos que participen en esta hermosa fiesta------
        var EyesViews = function EyesViews() {
            var PANTALLA_ARRIBA = window.pageYOffset;
            var PANTALLA_TAMANIO_Y = window.innerHeight;
            var PANTALLA_BOTTOM = PANTALLA_ARRIBA + PANTALLA_TAMANIO_Y;
            var parametros = {
                PANTALLA_ARRIBA: PANTALLA_ARRIBA,
                PANTALLA_TAMANIO_Y: PANTALLA_TAMANIO_Y,
                PANTALLA_BOTTOM: PANTALLA_BOTTOM
            };
            //animacion en scroll para preguntas frecuentes
            var $pregFrecuentesImg = document.querySelector('.preg-frecuentes__imgs');
            var $preFrecuentes = document.querySelector('.preg-frecuentes__descrip');
            var $preFrecuentesArticle = document.querySelectorAll('.preg-frecuentes__descrip article');
            if ($pregFrecuentesImg !== null) {
                elementView($preFrecuentes, function () {
                    visibleArticle($preFrecuentesArticle, 'fadeInUp', 0.4);
                }, parametros);
                elementView($pregFrecuentesImg, function () {
                    visibleArticle($pregFrecuentesImg, 'fadeInUp', 0.6);
                }, parametros);
            }
            //animacion en scroll para Contacto
            var $contacto = document.querySelector('.contacto');
            if ($contacto !== null) {
                var $contactoH6 = document.querySelector('.contacto h6');
                var $lineaContacto = document.querySelector('.contacto .separador-gris');
                elementView($contacto, function () {
                    visibleArticle($contactoH6, 'fadeInUp', 0.8);
                }, parametros);
                elementView($contacto, function () {
                    visibleArticle($lineaContacto, 'dibuje', 1);
                }, parametros);
            }

            //animacion para suscripcion a diarios y revistas
            var $suscripDiarios = document.querySelector('.suscrip-diarios');
            if ($suscripDiarios !== null) {
                var $suscripDiariosTitulo = document.querySelector('.suscrip-diarios__titulo');
                var $suscripDiariosCaja = document.querySelector('.suscrip-diarios__caja');
                elementView($suscripDiarios, function () {
                    visibleArticle($suscripDiariosTitulo, 'fadeInUp', 0.8);
                }, parametros);
                elementView($suscripDiarios, function () {
                    visibleArticle($suscripDiariosCaja, 'fadeInUp', 0.8);
                }, parametros);
            }

            //Animacion en Data-Fiscal
            var $dataFiscal = document.querySelector('.data-fiscal');
            var $lineaDataFiscal = document.querySelector('.data-fiscal .separador-gris');
            if ($dataFiscal !== null) {
                elementView($dataFiscal, function () {
                    visibleArticle($lineaDataFiscal, 'dibuje', 0.8);
                }, parametros);
            }
        };

        EyesViews();

        addListenerMulti(window, 'scroll', EyesViews);

        //preg cuantos combos vienen y le agregamos el style que le corresponde
        var $combo = document.querySelectorAll(".combo");
        if ($combo.length > 0) {
            var $listaCombos = document.querySelector(".lista-combos");
            visibleArticle($combo, 'fadeInUp', 0.2);
            if ($combo.length > 3) {
                $listaCombos.style.justifyContent = "space-between";
            } else {
                $listaCombos.style.justifyContent = "space-evenly";
            }
        }

        // Expandir mostrar mas . 
        var $mostrarMas = document.querySelectorAll('.combo__detalles__button');
        Array.from($mostrarMas).map(function (item) {
            item.addEventListener('click', function (event) {
                var $comboDetalles = event.target.parentNode;
                if ($comboDetalles.classList.contains('--activo')) {
                    $comboDetalles.classList.remove('--activo');
                    event.target.innerHTML = "Mostrar detalles";
                } else {
                    $comboDetalles.classList.add('--activo');
                    event.target.innerHTML = "Ocultar detalles";
                }
            });
        });
    };

    Helper.TieneProductoPremiumPDF = function () {
        var ppCookie = Helper.readCookie("ProductoPremiumId");
        if (ppCookie) {
            var ids = ppCookie.split(",");
            if (ids.includes("3")) {
                return true;
            }
        }
        return false;
    };

    Helper.TieneAccesoDigital = function () {
        var ppCookie = Helper.readCookie("ProductoPremiumId");
        if (ppCookie) {
            var ids = ppCookie.split(",");
            if (ids.includes("2")) {
                return true;
            }
        }
        return false;
    };

    Helper.eventosInicioWall = function () {
        $(window).on('storage', function (ev) {
            if (ev.originalEvent.key !== 'userLogedIn') return; // ignore other keys
            var message = JSON.parse(ev.originalEvent.newValue);
            if (!message) return; // ignore empty msg or msg reset

            if (message === true) {
                var ppCookie = Helper.readCookie("ProductoPremiumId");
                if (ppCookie) {
                    var ids = ppCookie.split(",");
                    if (ids.includes("2")) {
                        var base64Matcher = new RegExp("^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})$");
                        if (Helper.getURLParameter1('callback') != null) {
                            if (base64Matcher.test(LN.Helper.getURLParameter1('callback'))) {
                                var redirectUrl = Config.dominiosPermitidos.test(window.atob(Helper.getURLParameter1('callback'))) ? window.atob(Helper.getURLParameter1('callback')) : "";
                                if (redirectUrl) Helper.redirectUrl(redirectUrl);
                            }
                        }
                    }
                }
            }
        });
    };

    Helper.eventosInicioSuscribirme = function () {
        $("section.linea").each(function () {
            var widthContenedor = $(this).width();
            var widthTitulo = $(this).children("div:nth-child(2)").width();
            var elementoLineas = $(this).children("div.lineas");
            var promedio = widthContenedor - widthTitulo - 40;
            var total = promedio / 2;
            $(elementoLineas).css("width", total);
            $(this).find("h3").addClass("zoomIn");
            $(this).find("hr").addClass("write");
        });

        setTimeout(function () {
            $(".combo").addClass("fadeInUp2");
            if ($(window).width() >= 760) {
                $(".tarjeta").addClass("bounceInUp");
            }
            setTimeout(function () {
                $(".combo").css("animation-name", "none");
            }, 1900);
        }, 500);
    };

    Helper.eventosInputIngresarDocumento = function (inputName) {
        $('input[name="' + inputName + '"]').on("keyup", function (e) {
            if (e.keyCode == 190 || e.keyCode == 110) {
                if ($('select[name*="[tipoDocumento]"] option:selected').val() != 'PAS') $('input[name="' + inputName + '"]').val("");
            }
        });

        $('.nro-documento').focus();

        var func = function func() {
            var optionSelected = $('select[name*="[tipoDocumento]"] option:selected').val();
            optionSelected == 'PAS' ? $('input[name="' + inputName + '"]').attr('type', 'text') : $('input[name="' + inputName + '"]').attr('type', 'number');
        };
        $('select[name*="[tipoDocumento]"]').on('change', function (e) {
            func();
        });
        func();

        var mainWidth = $("main").width();
        mainWidth = mainWidth / 2;
        $('.preloader .preloader-gif').css({ 'left': mainWidth + 33 + 'px' });
    };

    Helper.eventosPago = function () {
        $('#hidden-form').submit();
        IFrames.ValidarPago(function (data) {
            Controller.validarPago(data);
        });
        var preguntasfrecuentes = Config.dominioMiCuenta + "/tyc-acceso-digital-app";
        IFrames.TYC(function (data) {
            console.log('TYC');
            LN.AppEvent.sendEvent('TYC');
            if (Model.Embed.Mobile) {
                window.open(preguntasfrecuentes);
            }
        });
    };

    Helper.setIframeHeight = function () {
        IFrames.Height(function (data) {
            $("iframe.document-height").css({ "height": data + 50 + "px" });
        });
    };

    Helper.Ingreso_dni_MostrarMailOfuscado = function () {
        $("#mail").text(Model.Cliente.mailOfuscado);

        /* Display error */
        var text = $("#mailofuscado").find('p').text();

        Analytics.formError('numeroDocumento-El documento está asociado a otra cuenta');
        //Analytics.error(text.trim());        

        $("#mailofuscado").show();
    };

    Helper.quickView = function () {
        if (Config.enableQuickView === false) return true;
        if (!$('#debug').is(':empty')) return true;

        var views = Object.getOwnPropertyNames(LN.View);
        var debug = document.getElementById("debug")[0];
        for (var i in views) {
            var button = $('<button/>').addClass("next-button").attr('data-step', 'quick_view').attr('data-view', views[i]).html(views[i]);
            $('#debug').append(button).append('<br />');
        }
    };

    Helper.eventosDatosEnvios = function () {

        $("#country").on("click", function (e) {
            e.preventDefault();
            $(".country").slideToggle(250);
        });
        $(".codigo-postal").focus();
    };

    /*Extension helpers Handlebars*/
    Handlebars.registerHelper('compare', function (lvalue, rvalue, options) {
        if (arguments.length < 3) throw new Error("Handlerbars Helper 'compare' needs 2 parameters");
        var operator = options.hash.operator || "==";
        var operators = {
            '==': function _(l, r) {
                return l == r;
            },
            '===': function _(l, r) {
                return l === r;
            },
            '!=': function _(l, r) {
                return l != r;
            },
            '<': function _(l, r) {
                return l < r;
            },
            '>': function _(l, r) {
                return l > r;
            },
            '<=': function _(l, r) {
                return l <= r;
            },
            '>=': function _(l, r) {
                return l >= r;
            },
            'typeof': function _typeof(l, r) {
                return (typeof l === "undefined" ? "undefined" : _typeof(l)) == r;
            }
        };
        if (!operators[operator]) throw new Error("Handlerbars Helper 'compare' doesn't know the operator " + operator);
        var result = operators[operator](lvalue, rvalue);
        if (result) {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }
    });

    Handlebars.registerHelper('checkProductPremium', function (options) {
        var product = Helper.readCookie('ProductoPremiumId');
        if ((product != null || product != '') && !Helper.isEmpty(Model.Usuario.xToken)) {
            return options.inverse(this);
        }
        return options.fn(this);
    });

    Handlebars.registerHelper('NotProductPremium', function (options) {
        var product = Helper.readCookie('ProductoPremiumId');

        if (product && product != null && !Helper.isEmpty(Model.Usuario.xToken)) {
            return new Handlebars.SafeString('<span class="chapita-conSuscrip">SUSCRIPTOR DIGITAL</span>');
        }
        return new Handlebars.SafeString('<span class="chapita-sinSuscrip">SIN SUSCRIPCI&Oacute;N DIGITAL</span>');

        //if ((product != null || product != '') && !Helper.isEmpty(Model.Usuario.xToken)) {
        //    return options.fn(this); 
        //}
        //return options.inverse(this);
    });

    Handlebars.registerHelper("foreach", function (arr, options) {
        if (options.inverse && !arr.length) return options.inverse(this);

        return arr.map(function (item, index) {
            item.$index = index;
            item.$first = index === 0;
            item.$last = index === arr.length - 1;
            return options.fn(item);
        }).join('');
    });

    Handlebars.registerHelper('printPlanMessageByCategory', function (value) {
        var text = '';

        switch (value) {
            case 'C':

                text = 'Tu credencial es Classic. Para obtener Acceso Digital es necesario que seas titular o adicional Black o titular Premium.';
                break;

            case 'P':

                text = 'Tu credencial es adicional Premium. Para obtener Acceso Digital bonificado es necesario que la credencial sea titular.';
                break;

            default:

                text = 'Para obtener Acceso Digital es <br> necesario que seas titular o <br> adicional Black o titular Premium. <br /> <strong>Seleccioná un plan para seguir <br> navegando  <nobr>LA NACION</nobr> sin límites:</strong>';
                break;
        }

        return new Handlebars.SafeString(text);
    });

    Handlebars.registerHelper('ContextEmbedHide', function (options) {
        if (Model.Embed.Mobile || Model.Embed.Article) {
            return options.inverse(this);
        } else {
            return options.fn(this);
        }
    });

    Handlebars.registerHelper('ContextEmbedShow', function (options) {
        if (Model.Embed.Mobile || Model.Embed.Article) {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }
    });

    Handlebars.registerHelper('ArticleContextHide', function (options) {
        if (Model.Embed.Article) {
            return options.inverse(this);
        } else {
            return options.fn(this);
        }
    });

    Handlebars.registerHelper('ArticleContextShow', function (options) {
        //Posiblemente deprecado
        if (Model.Embed.Article) {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }
    });

    Handlebars.registerHelper('landing-moreinfo-html', function (options) {
        if (Model.Landing.TipoMasInfo == 'html') {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }
    });

    Handlebars.registerHelper('landing-moreinfo-iframe', function (options) {
        if (Model.Landing.TipoMasInfo == 'iframe') {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }
    });

    Handlebars.registerHelper('landing-combo-link', function (combo) {
        return AppendToUrl(urlBuilder(Config.urlRedirect + combo + '/?'), 'campaign', Model.Landing.IdCampania);
    });

    Handlebars.registerHelper('get-plan-by-combo', function (combo, options) {
        var p = Model.getPlan(combo);
        if (p) return options.fn(p);else return options.inverse(this);
    });

    Handlebars.registerHelper('get-label-for-month', function (meses) {
        if (!meses) return '';
        if (meses === 1) {
            return 'mes';
        } else {
            return 'meses';
        }
    });

    Handlebars.registerHelper('ceil', function (price) {
        if ((0, _util.isNullOrUndefined)(price)) return '';
        return new Handlebars.SafeString(Math.ceil(price));
    });

    // ==================================================
    // Bindings de eventos para pantallas 
    // ================================================== 
    Helper.asociarCredencialBindings = function () {
        $(".num-cred").autotab();
        $('select').niceSelect();

        $("#nro-credencial-1, #nro-credencial-2, #nro-credencial-3").on("keydown", function (e) {
            // Solo permito ingresar numero y enter . 
            var keycode = event.which;

            if (e.ctrlKey && keycode == 67 || e.ctrlKey && keycode == 86) return true;

            if (keycode == 13 || keycode == 32 || keycode == 107 || keycode == 190 || keycode == 188 || keycode == 189 || keycode == 109 || keycode >= 65 && keycode <= 90) {
                e.preventDefault();
                return false;
            }
        });

        $("#nro-credencial-1").on("keyup focusout", function () {
            if ($(this).val() === '') Helper.cleanStatus($(this));else if (Validation.Validators.credencialClub1.test($(this).val()) && $(this).val() !== '') Helper.changeStatus($(this), true);else Helper.changeStatus($(this), false);
        });

        $("#nro-credencial-2").on("keyup focusout", function () {
            if ($(this).val() === '') Helper.cleanStatus($(this));else if (Validation.Validators.credencialClub2.test($(this).val()) && $(this).val() !== '') Helper.changeStatus($(this), true);else Helper.changeStatus($(this), false);
        });

        $("#nro-credencial-3").on("keyup focusout", function () {
            if ($(this).val() === '') Helper.cleanStatus($(this));else if (Validation.Validators.credencialClub3.test($(this).val()) && $(this).val() !== '') Helper.changeStatus($(this), true);else Helper.changeStatus($(this), false);
        });

        $('#nro-documento').on('keypress', function (e) {
            var optionSelected = $("#tipo-documento option:selected").data('validator');
            if (this.value.length >= Validation.Validators.Max[optionSelected]) return false;
        });

        $('#tipo-documento').on('change', function (e) {
            var optionSelected = $("#tipo-documento option:selected").val();
            optionSelected == 'PAS' ? $("#nro-documento").attr('type', 'text') : $("#nro-documento").attr('type', 'number');
        });

        // Eventos de popup credencial dos últimos números . 
        // TODO : ver si puede ir en formularios.js
        $("b.burbuja").click(function () {
            $(".burbuja-inner").toggle();
        });
        $(document).on("click", function (e) {
            if ($(e.target).is("b.burbuja, .burbuja-inner") === false) {
                $(".burbuja-inner").hide();
            }
        });

        // Dependiendo el modo y cantidad de credenciales levantadas cargo en inputs valor de credencial . 

        switch (Model.Usuario.TipoAsociarCredencial) {
            case "1":
                if (Model.Usuario.Credenciales.length == 1) {
                    var credencialAsociada = LN.Model.Usuario.Credenciales[0].nroTarjeta.replace(/-/gi, "");
                    $("#nro-credencial-1").prop("readonly", true).val(credencialAsociada.substring(0, 6));
                    Helper.changeStatus($("#nro-credencial-1"), true);
                    $("#nro-credencial-2").attr("type", "text").prop("readonly", true).val("XXXXXXXX");
                    Helper.changeStatus($("#nro-credencial-2"), true);
                    $("#nro-credencial-3").focus().click();
                    $(".nro-credencial").removeClass("completa");
                    $("#asociar_tarjeta").addClass("cargado");
                }
                break;
            case "2":
                Model.Cliente.numeroDocumento == "" ? $("#nro-documento").focus().click() : $("#nro-credencial-1").focus().click();
                break;
        }
    };

    Helper.SetFocus = function (step, name) {
        $(LN.Model.getInputsBy(step, name).get().object).focus();
    };

    Helper.HideVincularTarjetaForm = function () {
        $(document).ready(function () {
            $('.vincular-tarjeta-form').hide();
        });
    };

    Helper.HideSubTituloTarjetaForm = function () {
        $('.subtituloCodigo').hide();
    };

    Helper.resetGif = function (cb) {
        console.log('reset');
        $('body').append("<img id='varnishReset' src='http://www.lanacion.com.ar/apw/api/v1/reset.gif' style='display:none;'>");
        var img = document.querySelector('#varnishReset');
        var cbSleep = function cbSleep() {
            setTimeout(function () {
                cb();
            }, 5000);
        };

        if (img.complete) {
            console.log('completed');
            cbSleep();
        } else {
            $(img).on('load', function () {
                console.log('load');
                cbSleep();
            });
            $(img).on('error', function () {
                console.log('err');
                cb();
            });
        }
    };

    Helper.resetImg = function (id, url, cb) {
        $('body').append("<img id='" + id + "' src='" + url + "' style='display:none;'>");
        var img = document.querySelector('#' + id);
        var cbSleep = function cbSleep() {
            setTimeout(function () {
                cb();
            }, 3000);
        };

        if (img.complete) {
            console.log('completed ' + url);
            cbSleep();
        } else {
            $(img).on('load', function () {
                console.log('load ' + url);
                cbSleep();
            });
            $(img).on('error', function () {
                console.log('err ' + url);
                cb();
            });
        }
    };

    Helper.BtnGoogle = function () {
        document.body.classList.add("googleBtn");
        var $divGoogle = document.querySelector('.googlepay');
        var $p = document.createElement("span");
        var $p2 = document.createElement("span");
        $p.innerHTML = 'O bien';
        $p2.innerHTML = Constantes.LeyendaPrecioSWG;
        $p2.style.fontSize = "13px";
        $divGoogle.appendChild($p);
        GoogleSubscribe.drawButton('googlepay');
        $divGoogle.appendChild($p2);
    };

    Helper.trackPaywallView = function () {
        Analytics.trackViewPaywall();
    };
})(LN.Helper, LN.Config, LN.View, LN.Model, Handlebars, window.config.Constantes, LN.Validation, LN.Message, LN.Controller, LN.Analytics, jQuery, LN.IFrames);

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    if (!LN.Core) throw new Error("LN.Core missing");
})();

(function (Hotjar, Config, $) {
    'use strict';

    Hotjar.callTrigger = function (label) {
        console.log('hotjar-trigger: ' + label);
        hj('trigger', label);
    };

    Hotjar.startRecording = function (tag) {
        hj('trigger', Config.HotjarRecordingTrigger);
        hj('tagRecording', tag);
    };
})(LN.Hotjar, LN.Config, jQuery);

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (Config, IFrames) {

    IFrames.ValidarPago = function (fn) {
        frameEventClient.listen('PAGO-VALIDARPAGO', function (e) {
            fn && fn(e.data);
        });
    };

    IFrames.TYC = function (fn) {
        frameEventClient.listen('TYC', function (e) {
            fn && fn(e.data);
        });
    };

    IFrames.Height = function (fn) {
        frameEventClient.listen('DOCUMENT-HEIGHT', function (e) {
            fn && fn(e.data);
        });
    };
})(LN.Config, LN.IFrames);

/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

window.logger = new function PaywallLogger() {
    var self = this;
    var types = {
        info: { name: 'info', level: 2 },
        trace: { name: 'trace', level: 0 },
        warn: { name: 'warn', level: 3 },
        debug: { name: 'debug', level: 1 },
        error: { name: 'error', level: 4 },
        fatal: { name: 'fatal', level: 5 }
    };
    var elmahLevel = LN.Config.elmahLevel;

    function post(data) {

        $.ajax({
            url: LN.Config.dominioMiCuenta + '/pw-log',
            type: 'POST',
            data: JSON.stringify(data),
            async: true,
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            }

        });
    }

    function log(type, message, ex) {
        try {

            if (ex != null && (typeof ex === 'undefined' ? 'undefined' : _typeof(ex)) == "object") {
                ex = JSON.stringify(ex);
            }

            var values = {
                type: type,
                message: message,
                exception: ex
            };

            if (types[type].level >= types[elmahLevel].level) {
                post(values);
            }
            return self;
        } catch (exp) {
            console.log('Error logueando');
        }
    }

    this.error = function (message, ex) {
        return log(types.error.name, message, ex);
    };

    this.info = function (message, ex) {
        return log(types.info.name, message, ex);
    };

    this.trace = function (message, ex) {
        return log(types.trace.name, message, ex);
    };

    this.warn = function (message, ex) {
        return log(types.warn.name, message, ex);
    };
    this.debug = function (message, ex) {
        return log(types.debug.name, message, ex);
    };
    this.fatal = function (message, ex) {
        return log(types.fatal.name, message, ex);
    };
    this.exception = function (message, ex) {
        return log(types.fatal.name, message, ex);
    };
}();

/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  if (!LN.Core) throw new Error("LN.Core missing");
})();

(function (Message) {
  'use strict';
  // ==================================================
  // Mensajes de error
  // ==================================================  

  Message.Error = {
    '500': "Internal Server Error",
    '400': "Bad Request",
    '401': "Unauthorized",
    '403': "Forbidden",
    '404': "Not Found",
    '405': "Method Not Allowed",
    'TIMEOUT': "Connection Timeout",
    'ABORT': "Aborted",
    'GENERAL': "Sucedió un error inesperado. Volvé a intentarlo más tarde.",
    'ENLACE_CADUCADO': "El link no se encuentra vigente."
  };

  Message.Analytics.Error = {
    '500': "Internal Server Error",
    '400': "Bad Request",
    '401': "Unauthorized",
    '403': "Forbidden",
    '404': "Not Found",
    '405': "Method Not Allowed",
    'TIMEOUT': "Connection Timeout",
    'ABORT': "Aborted",
    'GENERAL': "Sucedió un error inesperado. Volvé a intentarlo más tarde.",
    'ENLACE_CADUCADO': "El link no se encuentra vigente."
  };
  // ==================================================
  // Mensajes de error
  // ==================================================  
  Message.Usuario = {
    'CAPTCHA_INVALIDO': 'Captcha inválido',
    'CAPTCHA_REQUERIDO': 'Confirmá el captcha para poder continuar',
    'USUARIO_INVALIDO': 'Ingresá un e-mail o un usuario válido',
    'EMAIL_INVALIDO': 'Ingresá un e-mail válido',
    'CLAVE_INVALIDA': 'Ingresá una clave valida',
    'SUSPENDIDO_POR_ABUSO': 'Suspendido por abuso',
    'ELIMINADO_LOGICO': 'Eliminado Logico',
    'SUSPENDIDO_DEFINITIVO': 'Suspendido definitivo',
    'USUARIO_EXISTE_MAIL': 'Se produjo un error al enviar el mail al nuevo usuario registrado',
    'USUARIO_EXISTE': 'El usuario ya existe',
    'USUARIO_NO_EXISTE': 'El usuario no existe',
    'USUARIO_O_GUID_NO_EXISTE': 'El usuario o GUID no existe',
    'NO_ACTUALIZA': 'No se pudo actualizar',
    'LOGUEATE_RED_SOCIAL': 'El usuario ya esta registrado por redes sociales. Iniciá sesión con Google o Facebook.',
    //'LOGUEATE_RED_SOCIAL': 'Ese e-mail ya esta registrado por redes sociales. Iniciá sesión con Google o Facebook.',
    'NOMBRE_APELLIDO_INCORRECTO': 'Tenés que incluir al menos 2 caracteres sin números ni símbolos',
    'DOMINIO_INVALIDO': 'Dominio no permitido.',
    'FACEBOOK_EXISTE': 'Ya existe un usuario con el perfil de facebook ingresado.',
    'GMAIL_EXISTE': 'Ya existe un usuario con la cuenta de Google ingresada.',
    'CLAVE_ACTUAL_INVALIDA': 'La clave actual ingresada es incorrecta',
    'CLAVE_ANTERIOR_INVALIDA': 'Su clave anterior es incorrecta',
    'VOLVER_A_INTENTARLO': 'Volver a intentarlo',
    'USUARIO_DOMINIO_INVALIDO': 'El dominio está inhabilitado. Intentá con otro.',
    'USUARIO_CLAVE_REPETIDA': 'La nueva contraseña no puede ser igual a una contraseña utilizada previamente.',
    'USUARIO_CAMPO_FALTANTE': 'Debe completar todos los datos para darse de alta.',
    'ALTA_RED_INVALIDA': 'El usuario ya esta registrado o asociado por redes sociales.',
    'ALTA_MAIL_NO_ENVIO': 'Se produjo un error al enviar el mail al nuevo usuario registrado.',
    'CODIGO_INVALIDO': 'Codigo verificacion invalido.',
    'CARACTER_INVALIDO_MAIL': 'El E-mail no puede contener caracteres especiales.',
    'INFORMACION_NO_ENCONTRADA': 'Informacion del contacto no encontrada.',
    'CARACTER_INVALIDO_PASS_REG': 'Tu contraseña incluye caracteres especiales no permitidos. Intentá nuevamente evitando; acentos, ñ, comillas y otros símbolos.'
  };

  Message.Analytics.Usuario = {
    'CAPTCHA_INVALIDO': 'Captcha inválido',
    'CAPTCHA_REQUERIDO': 'Confirmá el captcha para poder continuar',
    'USUARIO_INVALIDO': 'Ingresá un e-mail o un usuario válido',
    'EMAIL_INVALIDO': 'Ingresá un e-mail válido',
    'CLAVE_INVALIDA': 'Ingresá una clave valida',
    'SUSPENDIDO_POR_ABUSO': 'Suspendido por abuso',
    'ELIMINADO_LOGICO': 'Eliminado Logico',
    'SUSPENDIDO_DEFINITIVO': 'Suspendido definitivo',
    'USUARIO_EXISTE_MAIL': 'Se produjo un error al enviar el mail al nuevo usuario registrado',
    'USUARIO_EXISTE': 'El usuario ya existe',
    'USUARIO_NO_EXISTE': 'El usuario no existe',
    'USUARIO_O_GUID_NO_EXISTE': 'El usuario o GUID no existe',
    'NO_ACTUALIZA': 'No se pudo actualizar',
    'LOGUEATE_RED_SOCIAL': 'El usuario ya esta registrado por redes sociales. Iniciá sesión con Google o Facebook.',
    //'LOGUEATE_RED_SOCIAL': 'Ese e-mail ya esta registrado por redes sociales. Iniciá sesión con Google o Facebook.',
    'NOMBRE_APELLIDO_INCORRECTO': 'Tenés que incluir al menos 2 caracteres sin números ni símbolos',
    'DOMINIO_INVALIDO': 'Dominio no permitido.',
    'FACEBOOK_EXISTE': 'Ya existe un usuario con el perfil de facebook ingresado.',
    'GMAIL_EXISTE': 'Ya existe un usuario con la cuenta de Google ingresada.',
    'CLAVE_ACTUAL_INVALIDA': 'La clave actual ingresada es incorrecta',
    'CLAVE_ANTERIOR_INVALIDA': 'Su clave anterior es incorrecta',
    'VOLVER_A_INTENTARLO': 'Volver a intentarlo',
    'USUARIO_DOMINIO_INVALIDO': 'El dominio está inhabilitado. Intentá con otro.',
    'USUARIO_CLAVE_REPETIDA': 'La nueva contraseña no puede ser igual a una contraseña utilizada previamente.',
    'USUARIO_CAMPO_FALTANTE': 'Debe completar todos los datos para darse de alta.',
    'ALTA_RED_INVALIDA': 'El usuario ya esta registrado o asociado por redes sociales.',
    'ALTA_MAIL_NO_ENVIO': 'Se produjo un error al enviar el mail al nuevo usuario registrado.',
    'CODIGO_INVALIDO': 'Codigo verificacion invalido.',
    'CARACTER_INVALIDO_MAIL': 'El E-mail no puede contener caracteres especiales.',
    'INFORMACION_NO_ENCONTRADA': 'Informacion del contacto no encontrada.',
    'CARACTER_INVALIDO_PASS_REG': 'Tu contraseña incluye caracteres especiales no permitidos. Intentá nuevamente evitando; acentos, ñ, comillas y otros símbolos.'
  };

  // ==================================================
  // Mensajes de error
  // ==================================================  
  Message.Credencial = {
    'ERROR_ASOCIAR': 'No se pudo vincular tu tarjeta. Volvé a intentar ingresando DNI y número de tarjeta de Club LA NACION. <br><br>' + 'Si el error persiste comunicata el <b>5199-4787</b> o desde el exterior a accesodigital@lanacion.com.ar <br>' + 'Horario de atención telefónica: Lunes a Viernes de 8 a 20hs. Sábados y Domingos de 8 a 14hs.',
    'ERROR_NO_COINCIDEN': 'Los números de DNI y Tarjeta que ingresaste no coinciden.  Cargalos nuevamente. <br> ¿Tenés dudas? Llamanos al <b>5199-4787</b> o escribinos desde el exterior a <b>accesodigital@lanacion.com.ar</b> ',
    'ERROR_YA_ASOCIADO': 'La tarjeta está vinculada con el e-mail: <b>{{email}}</b> <br>' + 'Si es tuyo, ingresá con esa cuenta. <br><br>' + 'Sino llamanos al <b>5199-4787</b> o desde el exterior a accesodigital@lanacion.com.ar <br>' + 'Horario de atención telefónica: Lunes a Viernes de 8 a 20hs. Sábados y Domingos de 8 a 14hs. <br><br>' + '<a href="https://goo.gl/K3gZWY" target="_blank">¿cómo desvincular la credencial para usarla en mi nueva cuenta?</a>',
    //'ERROR_YA_ASOCIADO_CORTO': 'Tu tarjeta está asociada a otro email. Para continuar, ingresá con esa cuenta.<br><br>' + 
    //                           '¿Tenés dudas? Llamanos al <b>5199-4787</b> o escribinos desde el exterior a <b>accesodigital@lanacion.com.ar</b>',
    'ERROR_DEUDA': 'No podés asociar tu tarjeta porque tu cuenta registra una deuda con <b>LA NACION</b>.<br><br>' + 'Para continuar comunicate al <b>5199-4787</b> o desde el exterior a <b>accesodigital@lanacion.com.ar</b>',
    'DNI_INCOMPLETO': 'Revisá que el número de documento esté completo',
    'INCORRECTA': 'Tarjeta incorrecta',
    'INCORRECTA_ATTEMP': 'El número de tarjeta es incorrecto. Por favor, revisalo y volvé a ingresarlo.'
  };

  Message.Analytics.Credencial = {
    'ERROR_ASOCIAR': 'No se pudo vincular tu tarjeta. Volvé a intentar ingresando DNI y número de tarjeta de Club LA NACION. <br><br>' + 'Si el error persiste comunicata el <b>5199-4787</b> o desde el exterior a accesodigital@lanacion.com.ar <br>' + 'Horario de atención telefónica: Lunes a Viernes de 8 a 20hs. Sábados y Domingos de 8 a 14hs.',
    'ERROR_NO_COINCIDEN': 'Los números de DNI y Tarjeta que ingresaste no coinciden.  Cargalos nuevamente. <br> ¿Tenés dudas? Llamanos al <b>5199-4787</b> o escribinos desde el exterior a <b>accesodigital@lanacion.com.ar</b> ',
    'ERROR_YA_ASOCIADO': 'La tarjeta está vinculada con el e-mail: <b>{{email}}</b> <br>' + 'Si es tuyo, ingresá con esa cuenta. <br><br>' + 'Sino llamanos al <b>5199-4787</b> o desde el exterior a accesodigital@lanacion.com.ar <br>' + 'Horario de atención telefónica: Lunes a Viernes de 8 a 20hs. Sábados y Domingos de 8 a 14hs. <br><br>' + '<a href="https://goo.gl/K3gZWY" target="_blank">¿cómo desvincular la credencial para usarla en mi nueva cuenta?</a>',
    //'ERROR_YA_ASOCIADO_CORTO': 'Tu tarjeta está asociada a otro email. Para continuar, ingresá con esa cuenta.<br><br>' + 
    //                           '¿Tenés dudas? Llamanos al <b>5199-4787</b> o escribinos desde el exterior a <b>accesodigital@lanacion.com.ar</b>',
    'ERROR_DEUDA': 'No podés asociar tu tarjeta porque tu cuenta registra una deuda con <b>LA NACION</b>.<br><br>' + 'Para continuar comunicate al <b>5199-4787</b> o desde el exterior a <b>accesodigital@lanacion.com.ar</b>',
    'DNI_INCOMPLETO': 'Revisá que el número de documento esté completo',
    'INCORRECTA': 'Tarjeta incorrecta',
    'INCORRECTA_ATTEMP': 'El número de tarjeta es incorrecto. Por favor, revisalo y volvé a ingresarlo.'
  };

  Message.Pines = {
    'PIN_VENCIDO': 'El código de activación ha vencido. Por favor, comunicate al call center: 5199-4787',
    'PIN_USADO': 'El código de activación que ingresaste ya ha sido utilizado.',
    'PIN_INEXISTENTE': 'Código de Activación inválido.',
    'PIN_ASOCIADA': 'Tu cuenta de LA NACION ya tiene una tarjeta asociada. Para continuar, es necesario que desvincules esa tarjeta desde <a href="#" target="_blank" class="next-button" data-step="validar_pines_miclub">Mi Cuenta</a>. <br>' + 'Luego podrás volver a cargar tu código de activación. <br> ' + 'Sino podés activarlo con otra cuenta de LA NACION.',
    'PIN_ASOCIADA_BONIFICADO': 'Tenes una tarjeta asociada en tu cuenta de LA NACION que te permite tener acceso digital bonificado. <br> ' + 'No es necesario que utilices el código de activación. <br> ' + 'Disfrutá del beneficio que te ofrece tu tarjeta {credencial} <a href="#" class="next-button"  data-step="validar_pines_tyc" >activándolo ahora</a>.',
    'PIN_SUSCRIPCION_ACTIVA': 'Tu cuenta de LA NACION ya tiene una suscripción digital activa. El código de activación podrás aplicarlo en otra cuenta diferente.',
    'PIN_ASOCIADO_A_OTRO_CRM': 'No hemos podido activar el PIN a tu usuario porque se encuentra asociado a otro cliente.<br><br> Te pedimos que por favor te comuniques al 5199-4787.<br> Muchas gracias!'
  };

  Message.Analytics.Pines = {
    'PIN_VENCIDO': 'El código de activación ha vencido. Por favor, comunicate al call center: 5199-4787',
    'PIN_USADO': 'El código de activación que ingresaste ya ha sido utilizado.',
    'PIN_INEXISTENTE': 'Código de Activación inválido.',
    'PIN_ASOCIADA': 'Tu cuenta de LA NACION ya tiene una tarjeta asociada. Para continuar, es necesario que desvincules esa tarjeta desde <a href="#" target="_blank" class="next-button" data-step="validar_pines_miclub">Mi Cuenta</a>. <br>' + 'Luego podrás volver a cargar tu código de activación. <br> ' + 'Sino podés activarlo con otra cuenta de LA NACION.',
    'PIN_ASOCIADA_BONIFICADO': 'Tenes una tarjeta asociada en tu cuenta de LA NACION que te permite tener acceso digital bonificado. <br> ' + 'No es necesario que utilices el código de activación. <br> ' + 'Disfrutá del beneficio que te ofrece tu tarjeta {credencial} <a href="#" class="next-button"  data-step="validar_pines_tyc" >activándolo ahora</a>.',
    'PIN_SUSCRIPCION_ACTIVA': 'Tu cuenta de LA NACION ya tiene una suscripción digital activa. El código de activación podrás aplicarlo en otra cuenta diferente.',
    'PIN_ASOCIADO_A_OTRO_CRM': 'No hemos podido activar el PIN a tu usuario porque se encuentra asociado a otro cliente.<br><br> Te pedimos que por favor te comuniques al 5199-4787.<br> Muchas gracias!'
  };

  Message.Pago = {
    'ERROR_CARGA': 'Ha ocurrido un error al procesar tu compra. Por favor, volvé a intentarlo nuevamente.',
    'SOLICITUD_VENCIDA': 'Has excedido el tiempo de compra. Por favor, volvé a ingresar los datos de la forma de pago.',
    'DATOS_INVALIDOS': 'Los datos ingresados no son correctos. Por favor, ingresalos nuevamente.',
    'ERROR_GENERAL': 'Ha ocurrido un error al procesar tu compra. Por favor, volvé a intentarlo nuevamente.'
  };

  Message.Analytics.Pago = {
    'ERROR_CARGA': 'Ha ocurrido un error al procesar tu compra. Por favor, volvé a intentarlo nuevamente.',
    'SOLICITUD_VENCIDA': 'Has excedido el tiempo de compra. Por favor, volvé a ingresar los datos de la forma de pago.',
    'DATOS_INVALIDOS': 'Los datos ingresados no son correctos. Por favor, ingresalos nuevamente.',
    'ERROR_GENERAL': 'Ha ocurrido un error al procesar tu compra. Por favor, volvé a intentarlo nuevamente.'
  };
})(LN.Message);

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  if (!LN.Core || !LN.Model) throw new Error("LN.Core || LN.Model missing");
})();

(function (Model, Config, Helper, Validation) {
  'use strict';

  Model.Campania = {};
  Model.Landing = {};
  Model.PlanElegido = {};
  Model.PlanMonto = {};

  Model.canalDeVenta = 0;
  Model.idOrigen = 0;

  Model.pin = '';
  Model.pinUrl = '';
  Model.pinDesc = '';

  Model.ComboAccesoSuscripcion = false;
  Model.YaTieneSuscripcion = false;

  Model.Cliente = {
    apellido: "",
    email: "",
    nombre: "",
    numeroDocumento: "",
    telefonoCelular: "",
    telefonoInterno: "",
    tipoDocumento: "",
    planElegido: null,
    mailOfuscado: ""
  };

  Model.Domicilios = [];
  Model.DomicilioElegido = {};
  Model.DomicilioTemp = {};
  Model.SWGSubscriptions = null;

  Model.Usuario = {
    UsuarioId: "",
    AccessToken: "",
    OrigenLoginTipoId: "",
    TipoAsociarCredencial: "",
    xToken: "",
    xValue: "",
    Retorno: "",
    UsuarioUsuario: "",
    Email: "",
    EmailCodificado: "",
    UsuarioDetalleNombre: "",
    UsuarioDetalleApellido: "",
    Credencial: "",
    Credenciales: [],
    tipoDocumento: "",
    dni: "",
    tipoParticipacion: "",
    UserAgent: "",
    Recaptcha: "",
    Codigo: "",
    SitioId: 1,
    EstadoId: "",
    Avatar: Config.urlAvatar + 'avatar-0.jpg',
    Campania: null,
    Combo: 0,
    ComboNombre: "",
    ComboPrecio: "",
    ComboPrecioSinDescuento: ""
  };

  Model.Window = {
    width: "",
    height: "",
    body: "",
    html: "",
    origenId: "",
    sitioId: "",
    modo: "",
    combo: "",
    pagina: "",
    paginaId: "",
    path: "",
    referer: "",
    userAgent: "",
    origenLoginTipoId: "",
    currentStep: "",
    currentLayout: "",
    lastFlow: "",
    canSubmit: true,
    ip: "",
    keyPress: 0,
    firstStart: true,
    location: window.location.href,
    origin: window.location.origin,
    errorAttemps: 0,
    contact: 0,
    originForCallback: "",
    source: ""
  };

  Model.Embed = {
    Mobile: false,
    Article: false,
    Name: ""
  };

  Model.ExternalPaywall = {
    Name: "",
    Type: "",
    Params: [],
    AutorizationToken: ""
  };

  Model.FormularioDatosPersonales = {};
  Model.FormularioDatosEnvio = {};
  Model.Me = {};

  Model.Venta = {
    Domicilio: null,
    esExtranjero: false,
    Pago: null
  };
  // ==================================================
  // METODOS PRIVADOS
  // ==================================================       

  var UpdateExternalPaywall = function UpdateExternalPaywall() {
    for (var item in Config.ExternalPaywall) {
      var this_paywall_is_active = false;
      var values = [];
      for (var param in Config.ExternalPaywall[item].Params) {
        if (Helper.isEmpty(Helper.getURLParameter1(Config.ExternalPaywall[item].Params[param]))) {
          this_paywall_is_active = false;
        } else {
          /*let obj = {};
          obj[Config.ExternalPaywall[item].Params[param]] = Helper.getURLParameter1(Config.ExternalPaywall[item].Params[param]);*/
          values[Config.ExternalPaywall[item].Params[param]] = Helper.getURLParameter1(Config.ExternalPaywall[item].Params[param]);
          this_paywall_is_active = true;
        }
      }
      if (this_paywall_is_active) {
        //si sali del for por true , este paywall esta configurado
        Model.Embed[Config.ExternalPaywall[item].Type] = true;
        Model.Embed.Name = Config.ExternalPaywall[item].Name;
        Model.ExternalPaywall = Config.ExternalPaywall[item];
        Model.ExternalPaywall.Values = values;
        break;
      }
    }
  };

  // ==================================================
  // Inicializacion de las variables de entorno
  // ==================================================       

  Model.updateAccesoWindowModel = function () {
    Model.Window.modo = Helper.getURLPathParameter('param1') !== null && Helper.modoPermitido(Helper.getURLPathParameter('param1')) ? Helper.getURLPathParameter('param1') : null;
    Model.Window.SitioId = Helper.getURLPathParameter('param3') !== null && Helper.sitioPermitido(parseInt(Helper.getURLPathParameter('param3'))) ? parseInt(Helper.getURLPathParameter('param3')) : Config.defaultSitioId;
    Model.Window.combo = Helper.getURLPathParameter('param2') !== null ? parseInt(Helper.getURLPathParameter('param2')) : null;

    Model.Window.landingUrl = Helper.getURLPathParameter('param1') !== null ? Helper.getURLPathParameter('param1') : null;
    if (Helper.getURLParameter1('campaign') != null) {
      Model.Window.landingCampaign = Helper.getURLParameter1('campaign');
    }

    Model.Embed.Mobile = LN.Helper.readCookie("platform") !== '' && LN.Helper.readCookie("platform") != null ? LN.Helper.readCookie("platform") : false;
    UpdateExternalPaywall();
    // Pagina
    var base64Matcher = new RegExp("^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})$");
    if (Helper.getURLParameter1('callback') != null) {
      if (base64Matcher.test(LN.Helper.getURLParameter1('callback'))) {
        Model.Window.pagina = Config.dominiosPermitidos.test(window.atob(Helper.getURLParameter1('callback'))) ? window.atob(Helper.getURLParameter1('callback')) : Config.defaultRedirectUrl;
      } else {
        Model.Window.pagina = Config.defaultRedirectUrl;
      }
    } else {
      if (base64Matcher.test(LN.Helper.getURLQueryString())) {
        Model.Window.pagina = Config.dominiosPermitidos.test(window.atob(Helper.getURLQueryString())) ? window.atob(Helper.getURLQueryString()) : Config.defaultRedirectUrl;
      } else {
        Model.Window.pagina = Config.defaultRedirectUrl;
      }
    }

    if (Helper.getURLParameter1('fc') != null) {
      Model.Window.contact = parseInt(Helper.getURLParameter1('fc'));
    }

    // Fin pagina
    if (Model.Window.pagina.split('-nid')[1]) {
      Model.Window.paginaId = Model.Window.pagina.split('-nid')[1];
    }
    Model.Window.path = Helper.getURLPath();
    Model.Usuario.SitioId = Model.Window.SitioId;
  };

  Model.IsInstantArticles = function () {
    if (Model.Embed.Article === true && Model.Embed.Name === "FacebookInstantArticles") {
      return true;
    }
    return false;
  };

  Model.setUsuario = function () {
    Model.Usuario.UsuarioUsuario = LN.Helper.readCookie("token") && Helper.readCookie("token") !== '' && Helper.readCookie("usuario%5Fusuario") && Helper.readCookie("usuario%5Fusuario") !== '' ? Helper.readCookie("usuario%5Fusuario") : null;
    Model.Usuario.Email = LN.Helper.readCookie("token") && Helper.readCookie("token") !== '' && Helper.readCookie("usuarioemail") && Helper.readCookie("usuarioemail") !== '' ? Helper.readCookie("usuarioemail") : null;
  };

  Model.getAllInputs = function () {
    var inputs = $(':input');
    var values = {};
    inputs.each(function () {
      values[this.name] = $(this).val();
    });
    return values;
  };

  Model.getInputsBy = function (step, name, error) {
    var inputs = $(':input[name^="' + step + '"]');
    var values = [];
    this.output = [];
    inputs.each(function () {
      var n = $(this).attr("name").match(/\[.*?\]/);
      var o = n[0].replace("[", "").replace("]", "");
      var c = $(this).attr('class');
      if (c) c.split(/\s+/);
      values[o] = {
        'name': o,
        'value': $(this).val(),
        'validations': c,
        'object': $(this),
        'text': $(this).is('select') ? $(this).children("option:selected").text() : $(this).val()
      };
    });

    function get() {
      if (!Helper.isEmpty(name) && values.indexOf(name) === -1) {
        if (Helper.isEmpty(values[name]) && Helper.isEmpty(values[name].object) && values[name].object.is(':radio') && !values[name].object.is(':checked')) {
          return false;
        } else if (Helper.isEmpty(values[name]) && values[name].object.is(':radio') && values[name].object.is(':checked')) {
          return values[name];
        }
        return values[name];
      }
    }

    function set(value) {
      if (!Helper.isEmpty(name) && values.indexOf(name) === -1) {
        return values[name].object.val(value);
      }
    }

    function all() {
      return values;
    }

    function clean() {
      for (var key in values) {
        var o = values[key].object;
        if (o.attr('type') == 'text' || o.attr('type') == 'number') {
          o.val('');
          Helper.cleanStatus(o);
        }
      }
    }

    function save(obj) {
      for (var key in values) {
        var k = values[key].name;
        var v = values[key].value;
        obj[k] = v;
      }
    }

    function validate() {
      if (Helper.isEmpty(name) && values.indexOf(name) !== -1) return false;
      var v = values[name];
      return Validation.checkValidations(v.object);
    }

    return {
      get: get,
      set: set,
      all: all,
      save: save,
      clean: clean,
      validate: validate
    };
  };

  Model.updateModel = function (step) {
    var data = Model.getInputsBy('datos_personales');
    for (var key in data) {
      Model.DatosPersonales[key] = data[key].value;
    }
  };

  Model.updatePinFromUrl = function () {
    Model.pin = Helper.getURLParameter('param1');
  };

  Model.getAction = function () {
    return Helper.getURLParameter1('a');
  };

  Model.updateDatosEnvio = function () {
    var data = Model.getInputsBy('datos_personales');
  };

  Model.setMe = function (res) {
    Model.Me = JSON.parse(res.response);
    if (!Helper.isEmpty(Model.Me.Usuario.Usuario_detalle_foto_perfil)) {
      Model.Usuario.Avatar = Config.urlAvatar + 'avatar-' + Model.Me.Usuario.Usuario_detalle_foto_perfil + '.jpg';
    }
  };

  Model.setCliente = function (res) {
    Model.Cliente = $.extend(Model.Cliente, res.response);
  };

  Model.setPago = function (pago) {
    Model.Venta.Pago = pago;
  };

  //Model.setPreventa = function (res) {
  //    Model.Preventa = res.response;
  //}


  Model.setPlanMonto = function (monto) {
    Model.PlanMonto = monto;
  };

  Model.setCombo = function (combo) {

    if (combo == Config.COMBO_BONIFICADO) {
      Model.PlanElegido = null;
      Model.Cliente.numeroDocumento = "";
      Model.Cliente.tipoDocumento = "";
    } else {
      var plan = Model.getPlan(combo);
      Model.Usuario.Credenciales = [];
      Model.PlanElegido = plan.planes[0];

      if (plan.imagenProducto) {
        Model.PlanElegido.imagen = plan.imagenProducto;
      } else {
        Model.PlanElegido.imagen = Config.urlBucket + plan.imagen.url;
      }
      Model.PlanElegido.imagenExtranjera = plan.imagenExtranjera;
    }
  };

  Model.updateCanalDeVenta = function (modo) {
    // Si el Canal de Venta no se encuentra en la URL, lo levanto del archivo de configuraci�n.
    if (Helper.getURLParameter1('cv') != null) {
      Model.canalDeVenta = parseInt(Helper.getURLParameter1('cv'));
    } else {
      if (!modo) modo = 'W';
      var idCanal = Config.canalesDeVenta[modo] === undefined ? Config.canalesDeVenta["W"] : Config.canalesDeVenta[modo];

      Model.canalDeVenta = idCanal;
    }
  };

  Model.setDomicilios = function (res) {
    Model.Domicilios = [];
    if (res.response.domicilios && Config.forceCreateNewAddress == false) {
      for (var i in res.response.domicilios) {
        var a = res.response.domicilios[i];
        if (!Helper.isEmpty(a.domicilio)) {
          Model.Domicilios.push(a);
        }
      }
      //Model.Domicilios = res.response.domicilios;
    } else {
      Model.Domicilios = [];
    }
  };

  Model.getFirstDomicilio = function () {
    if (!Helper.isEmpty(Model.Domicilios[0])) return Model.Domicilios[0];
    return false;
  };

  Model.obtenerDirecciones = function () {
    return Model.Domicilios;
  };

  Model.agregarDireccion = function (a) {
    return Model.Domicilios.push(a);
  };

  Model.getPlan = function (combo) {
    var plan = null;
    $.each(Model.Campania.grupoPlanes, function (i, e) {
      if (e.combo == combo) {
        plan = e;
        return;
      }
    });
    return plan;
  };

  Model.getPlanById = function (id) {
    var plan = null;
    $.each(Model.Campania.grupoPlanes, function (i, e) {
      if (e.id == id) {
        plan = e;
        return;
      }
    });
    return plan;
  };
})(LN.Model, LN.Config, LN.Helper, LN.Validation);

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    if (!LN.Core) throw new Error("LN.Core missing");
})();
(function (Router, Controller, Service, View, Helper, Model, $, Config) {
    'use strict';

    Router.handle = function () {

        Router.UpdateVaribales();

        var combo = Model.Window.combo;
        var modo = Model.Window.modo;

        switch (modo) {
            case 'W':
                View.wall();
                break;
            case 'S':
                View.wallSuscribime();
                break;
            case 'L':
                View.landing();
                break;
            case 'P':
                // Obtengo el codigo de validacion desde la URL y la guardo en Model.pin
                Model.updatePinFromUrl();
                // pantalla de activacion de pines
                View.validarPin(null, function () {
                    // Si viene desde login, hago el proceso de validacion automaticamente.
                    if (Model.getAction() == 'vp') {
                        Controller.validarPinesProcesar();
                    }
                });

                break;
            case 'C':
                Service.isLogged(function () {
                    Controller.flowB({
                        combo: combo
                    });
                }, function () {
                    Helper.redirectToLogin(Model.Window.originForCallback);
                });
                break;
            case 'A':
                Service.isLogged(function () {
                    switch (combo) {
                        case Config.ACCION_YA_TIENE_SUSCRIPCION:
                            {
                                Model.ComboAccesoSuscripcion = true;
                                Controller.flowA(Config.defaultModo, Config.defaultCombo);
                            }
                            break;
                        default:
                            {
                                logger && logger.error('Accion | No permitida (' + combo + ')');
                                throw new Error("No existe la accion");
                            }
                    }
                }, function () {
                    Helper.redirectToLogin();
                });
                break;
            case 'V':
                Model.YaTieneSuscripcion = true;
                Model.Window.originForCallback = Model.Window.location;
                Service.isLogged(function () {
                    Controller.flowA();
                }, function () {
                    View.wall();
                });
                break;
            case 'T':
                View.procesarPago();

                break;
            case 'D':
                if (Model.Window.landingUrl != null) {
                    View.wallDinamico();
                }
                break;
            default:
                throw new Error("No existe el modo");
        }
    };

    Router.UpdateVaribales = function () {
        Model.updateAccesoWindowModel();
        Router.MapUrl(Model.Window.modo);
        Model.updateCanalDeVenta(Model.Window.modo);
    };

    Router.MapContact = function (route) {
        if (!Model.Window.contact) {
            // el fc que viene en la url lo seteo en el Model.Window.contact de updateAccesoWindowModel
            //si no tiene fc seteado en la url, levanto el de la pagina correspondiente, o uno default
            if (route.formaContacto) Model.Window.contact = route.formaContacto;
        }
    };

    // ingresar.lanacion.com.ar/{path}/{modo}/{combo}/{sitioId}
    Router.MapUrl = function (modo) {

        var route;
        var encontro = false;
        var path = Helper.getURLPath();
        try {
            for (route in Config.Routes) {
                route = Config.Routes[route];
                //console.log(route);
                if (path === route.path) {
                    if (route.validaModo == null || !route.validaModo || route.modo === modo) {
                        Model.Window.modo = route.modo;
                        Model.Window.source = route.source;
                        encontro = true;
                        Router.MapContact(route);
                        break;
                    }
                }
            }
        } catch (ex) {
            logger && logger.error('MapUrl | Error (' + modo + ')', ex);
        }

        if (!encontro) {
            logger && logger.error('MapUrl | No existe el modo', { "modo": modo, "path": path });
            throw new Error("No existe el modo");
        }
    };
})(LN.Router, LN.Controller, LN.Service, LN.View, LN.Helper, LN.Model, jQuery, LN.Config);

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    if (!LN.Core) throw new Error("LN.Core missing");
})();
(function (Service, Router, Handler, Controller, Config, Model, Helper, Validation, Message, Analytics, CustomDimension, $) {
    'use strict';

    // ==================================================
    // Llamada ajax generica
    // Params : {url} {data} {success} {error}
    // ==================================================

    Service.ajaxPost = function (url, data, done, _error, options) {
        var sentHeader = !Helper.isEmpty(options) && 'sentHeader' in options ? true : false;
        var showPreloader = !Helper.isEmpty(options) && 'showPreloader' in options ? true : false;
        var hidePreloader = !Helper.isEmpty(options) && 'hidePreloader' in options ? true : false;
        var api = !Helper.isEmpty(options) && 'paywallApi' in options ? Config.apiPaywallUrl : Config.apiLoginUrl;

        var headers = {
            'X-Token': Model.Usuario.xToken || '',
            'X-Value': Model.Usuario.xValue || '',
            'X-Key': Model.Usuario.xKey || ''
        };
        showPreloader && Helper.showPreloader();
        $.ajax({
            url: api + url,
            type: 'POST',
            data: data || null,
            headers: sentHeader == true ? headers : null,
            success: function success(response, status, xhr) {
                //success && success(response,status,xhr);
            },
            error: function error(response, status, xhr) {
                _error && _error(response);
            },
            complete: function complete(response, status, xhr) {
                if (Config.env === "develop") console.log("Load", url);
            }
        }).done(function (res, status, xhr) {
            Helper.setCanSubmit(true);
            hidePreloader && Helper.hidePreloader();
            done && done(JSON.parse(res), status, xhr);
        }).fail(function (jqXHR, textStatus, errorThrown) {
            //logger && logger.error("Service Fail", { "data": url, "jqXHR": jqXHR, "textStatus": textStatus, "errorThrown": errorThrown });
            Handler.failHandler(jqXHR.status);
        });
    };

    Service.startHotjar = function () {
        (function (h, o, t, j, a, r) {
            h.hj = h.hj || function () {
                (h.hj.q = h.hj.q || []).push(arguments);
            };
            h._hjSettings = { hjid: parseInt(Config.hotjarId), hjsv: 6 };
            a = o.getElementsByTagName('head')[0];
            r = o.createElement('script');r.async = 1;
            r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
            a.appendChild(r);
        })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
    };

    Service.createCustomDimension = function () {

        var withToken = Helper.isEmpty(Helper.readCookie('token'));
        var usuarioLogeado = withToken ? 'no' : 'yes';
        var payUser = Helper.isEmpty(Helper.readCookie('ProductoPremiumId')) ? 'no' : 'yes';
        var userId = Helper.readCookie('usuario%5Fid');
        var clubLN = Helper.readCookie('usuarioDetalleClubNacion');
        var notasLeidas = Helper.readCookie('countNotas');

        if (!CustomDimension.exist()) {
            CustomDimension.setRegistrado('no');
            CustomDimension.setSuscriptorType('N/A');
            CustomDimension.setUserId('');
            CustomDimension.save();
        }

        var CD = CustomDimension.get();

        if (!window.dataLayer) {
            window.dataLayer = [{}];
        }

        dataLayer[0].notasLeidas = notasLeidas ? notasLeidas : 0;
        dataLayer[0].usuarioLogeado = usuarioLogeado;
        dataLayer[0].usuarioRegistrado = CD.usuarioRegistrado;
        dataLayer[0].payUser = payUser;
        dataLayer[0].suscriptorType = CD.suscriptorType;
        dataLayer[0].userId = CD.userId;
        dataLayer[0].credentialType = clubLN ? clubLN : 'N/A';
    };

    Service.startGoogleAnalytics = function () {
        (function (i, s, o, g, r, a, m) {
            i['GoogleAnalyticsObject'] = r;i[r] = i[r] || function () {
                (i[r].q = i[r].q || []).push(arguments);
            }, i[r].l = 1 * new Date();a = s.createElement(o), m = s.getElementsByTagName(o)[0];a.async = 1;a.src = g;m.parentNode.insertBefore(a, m);
        })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');
        ga && ga('create', Config.gaId, 'auto');
    };

    Service.startGoogleTagManager = function () {
        (function (w, d, s, l, i) {
            w[l] = w[l] || [];w[l].push({
                'gtm.start': new Date().getTime(), event: 'gtm.js'
            });var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s),
                dl = l != 'dataLayer' ? '&amp;l=' + l : '';j.async = true;j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl;f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', Config.gtmId);
    };

    Service.startComscore = function () {
        var _comscore = _comscore || [];
        _comscore.push({ c1: "2", c2: "6906398" });
        (function () {
            var s = document.createElement("script"),
                el = document.getElementsByTagName("script")[0];s.async = true;
            s.src = (document.location.protocol == "https:" ? "https://sb" : "http://b") + ".scorecardresearch.com/beacon.js";
            el.parentNode.insertBefore(s, el);
        })();
    };

    Service.startSwG = function (callback) {
        (window.SWG = window.SWG || []).push(function (subscriptions) {
            (Model.SWGSubscriptions = Model.SWGSubscriptions || subscriptions).init('lanacion.com.ar:acceso_digital');
            callback(Model.SWGSubscriptions);
        });
    };

    Service.startGoogleOptimize = function () {
        //Agregar a styles 
        //2.	<style>.async-hide { opacity: 0 !important} </style>
        (function (a, s, y, n, c, h, i, d, e) {
            s.className += ' ' + y;h.start = 1 * new Date();
            h.end = i = function i() {
                s.className = s.className.replace(RegExp(' ?' + y), '');
            };
            (a[n] = a[n] || []).hide = h;setTimeout(function () {
                i();h.end = null;
            }, c);h.timeout = c;
        })(window, document.documentElement, 'async-hide', 'dataLayer', 4000, { 'GTM-GHV6': true });
    };

    Service.startEstadisticas = function () {
        var rand_no = Math.random();
        var ip = '190.220.56.0'; /* NO SOY FELIZ HACIENDO ESTO -- ALE */
        rand_no = Math.ceil(rand_no * 1000000000);
        $("body").append('<img src="https://estadisticas.lanacion.com.ar/diario/default.gif?pagina=muropaywall&amp;servidor=' + ip + '&amp;nro=' + rand_no + '&amp;usuario=' + Helper.readCookie('usuario%5Fid') + '" width="1" height="1" />');
    };

    Service.mostrarError = function (message, analyticsError, error) {
        Analytics.error(analyticsError || message);
        LN.AppEvent.sendEvent('ERROR', message);
        console.log('{ Error: "' + error + '", Message: "' + message + '" }');
        Helper.callView('MOSTRAR_ERROR', {
            message: message,
            error: error
        });
        Model.Window.lastFlow = ""; // Limpio el ultimo flow ejecutado
    };

    Service.isLogged = function (success, error) {
        Model.Usuario.xToken = Helper.readCookie("token");
        if (Helper.isEmpty(Model.Usuario.xToken) || Validation.Validators.temporary.test(Model.Usuario.xToken)) {
            error && error();
            return;
        }
        Service.ajaxPost('/Usuario/Me', false, function (res, status, xhr) {
            if (!Helper.isEmpty(res.code) && res.code === '0000') {
                Model.setMe(res);
                success && success();
            } else {
                error && error();
            }
        }, null, {
            sentHeader: true,
            showPreloader: true
        });
    };

    Service.ifLoggedReturnBack = function () {
        setInterval(function () {
            Service.isLogged();
        }, Config.returnBackInterval);
    };

    Service.logout = function (options) {
        Model.Usuario.xToken = Helper.readCookie("token");
        Model.Usuario.xValue = Helper.readCookie("xvalue");
        Service.ajaxPost('/Usuario/Logout', Model.Usuario, function (res, status, xhr) {
            Service.smartlockSignOut();
            Helper.resetAll(function () {
                Helper.redirectToLogin();
            });
        }, function () {
            Service.smartlockSignOut();
            Helper.resetAll(function () {
                Helper.redirectToLogin();
            });
        }, { sentHeader: true });
    };

    // ==================================================
    // Flow Service
    // ==================================================   

    Service.getFlow = function (flow, requestData, options) {
        var data = {
            flow: flow
            // Activa el modo debug
        };if (Config.debugMode === true) {
            data.debug = true;
            data.codeResult = Config.debugFlowData[flow].codeResult;
        }

        if (!Helper.isEmpty(requestData)) data = $.extend(data, requestData);
        Model.Usuario.xToken = Helper.readCookie("token");
        Service.ajaxPost('/Paywall/GetFlow', data, function (res, status, xhr) {
            Model.Window.lastFlow = flow;
            Handler.flowHandler(flow, res, status, xhr, options);
        }, function (xhr) {
            xhr.status === 403 ? Helper.redirectToLogin() : Service.mostrarError(Message.Error[xhr.status], Message.Analytics.Error[xhr.status]);
        }, {
            sentHeader: true,
            paywallApi: true,
            showPreloader: true,
            hidePreloader: true
        });
    };

    // ==================================================
    // Servicios
    // ==================================================   
    Service.clienteObtener = function (cb) {
        Model.Usuario.xToken = Helper.readCookie("token");
        Service.ajaxPost('/Cliente/Obtener', null, function (res, status, xhr) {
            cb(res, status, xhr);
        }, function (xhr) {
            xhr.status === 403 ? Helper.redirectToLogin() : Service.mostrarError(Message.Error[xhr.status], Message.Analytics.Error[xhr.status]);
        }, {
            sentHeader: true,
            paywallApi: true,
            showPreloader: true,
            hidePreloader: true
        });
    };

    Service.clienteObtenerCrmId = function (dni, cb) {
        Model.Usuario.xToken = Helper.readCookie("token");
        Service.ajaxPost('/Cliente/ObtenerCrmId', {
            dni: dni
        }, function (res, status, xhr) {
            cb(res, status, xhr);
        }, function (xhr) {
            xhr.status === 403 ? Helper.redirectToLogin() : Service.mostrarError(Message.Error[xhr.status], Message.Analytics.Error[xhr.status]);
        }, {
            sentHeader: true,
            paywallApi: true,
            showPreloader: true,
            hidePreloader: true
        });
    };

    Service.clienteGuardar = function (cliente, cb) {
        Model.Usuario.xToken = Helper.readCookie("token");
        Service.ajaxPost('/Cliente/GuardarCliente', cliente, function (res, status, xhr) {
            cb(res, status, xhr);
        }, function (xhr) {
            xhr.status === 403 ? Helper.redirectToLogin() : Service.mostrarError(Message.Error[xhr.status], Message.Analytics.Error[xhr.status]);
        }, {
            sentHeader: true,
            paywallApi: true,
            showPreloader: true
        });
    };

    Service.clienteObtenerDatosFiliatorios = function (cb) {
        Model.Usuario.xToken = Helper.readCookie("token");
        Service.ajaxPost('/Cliente/ObtenerDatosFiliatorios', null, function (res, status, xhr) {
            cb && cb(res, status, xhr);
        }, function (xhr) {
            xhr.status === 403 ? Helper.redirectToLogin() : Service.mostrarError(Message.Error[xhr.status], Message.Analytics.Error[xhr.status]);
        }, {
            sentHeader: true,
            paywallApi: true,
            showPreloader: true,
            hidePreloader: true
        });
    };

    Service.campanaObtener = function (id, cb) {
        // TODO : Validar que el return de campaña 374 sean dos planes de venta . 
        // TODO : Validar que el return de campaña 375 sea un solo plan de venta . 
        Model.Usuario.xToken = Helper.readCookie("token");
        //if (Config.campanasPermitidas.indexOf(id) === -1) throw new Error("No existe la campaña");

        // Se levanta desde "caché" los datos de campaña si ya se encuentra en el modelo la misma que estoy solicitando .  
        if (!Helper.isEmpty(Model.Campania) && Model.Campania.id == id) return cb({ code: "0000", message: "OK", response: Model.Campania });
        Service.ajaxPost('/Campania/Obtener', {
            id: id
        }, function (res, status, xhr) {
            Model.Campania = res.response;
            cb(res, status, xhr);
        }, function (xhr) {
            xhr.status === 403 ? Helper.redirectToLogin() : Service.mostrarError(Message.Error[xhr.status], Message.Analytics.Error[xhr.status]);
        }, {
            sentHeader: true,
            paywallApi: true,
            showPreloader: true
            // hidePreloader: true   
        });
    };

    Service.landingObtener = function (id, cb) {
        Model.Usuario.xToken = Helper.readCookie("token");

        // Se levanta desde "caché" los datos de campaña si ya se encuentra en el modelo la misma que estoy solicitando .  

        Service.ajaxPost('/Campania/ObtenerCampaniasAutomaticas', { 'id': id }, function (res, status, xhr) {
            Model.Landing = res.response;
            /*  HARCODING POR PABLO MELICCHIO*/
            if (Model.Landing.PlanesDeVenta[0].BajadaPlan.toUpperCase().indexOf("CLUB") >= 0) {
                Model.Landing.PlanesDeVenta[0].TieneCredencial = true;
            }
            /* NUNCA QUISE HACER ESTO*/
            cb(res, status, xhr);
        }, function (xhr) {
            xhr.status === 403 ? Helper.redirectToLogin() : Service.mostrarError(Message.Error[xhr.status], Message.Analytics.Error[xhr.status]);
        }, {
            sentHeader: true,
            paywallApi: true,
            showPreloader: true
            // hidePreloader: true   
        });
    };

    Service.domicilioNormalizar = function (address, cb) {
        Model.Usuario.xToken = Helper.readCookie("token");
        Service.ajaxPost('/Domicilio/Normalizar', address, function (res, status, xhr) {
            cb(res, status, xhr);
        }, function (xhr) {
            xhr.status === 403 ? Helper.redirectToLogin() : Service.mostrarError(Message.Error[xhr.status], Message.Analytics.Error[xhr.status]);
        }, {
            sentHeader: true,
            paywallApi: true
        });
    };

    Service.domicilioCrear = function (address, cb) {
        Model.Usuario.xToken = Helper.readCookie("token");
        Service.ajaxPost('/Domicilio/CrearDomicilio', address, function (res, status, xhr) {
            cb(res, status, xhr);
        }, function (xhr) {
            xhr.status === 403 ? Helper.redirectToLogin() : Service.mostrarError(Message.Error[xhr.status], Message.Analytics.Error[xhr.status]);
        }, {
            sentHeader: true,
            paywallApi: true
        });
    };

    Service.posdatarDomicilio = function (address, fn) {
        Model.Usuario.xToken = Helper.readCookie('token');
        Service.ajaxPost('/Domicilio/PosdatarDomicilio', address, function (response, status, xhr) {
            fn(response, status, xhr);
        }, function (xhr) {
            xhr.status === 403 ? Helper.redirectToLogin() : Service.mostrarError(Message.Error[xhr.status], Message.Analytics.Error[xhr.status]);
        }, {
            sentHeader: true,
            paywallApi: true
        });
    };

    Service.iniciarVenta = function (data, cb) {

        Analytics.medicionCheckOut(Model.PlanElegido.nombre, Model.PlanElegido.precio);
        Model.Usuario.xToken = Helper.readCookie("token");
        Service.ajaxPost('/Venta/IniciarVenta', data, function (res, status, xhr) {
            cb(res, status, xhr);
        }, function (xhr) {
            xhr.status === 403 ? Helper.redirectToLogin() : Service.mostrarError(Message.Error[xhr.status], Message.Analytics.Error[xhr.status]);
        }, {
            sentHeader: true,
            paywallApi: true,
            showPreloader: true
        });
    };

    Service.pagoValidar = function (data, cb) {
        Model.Usuario.xToken = Helper.readCookie("token");
        Service.ajaxPost('/Pago/ValidarPago', data, function (res, status, xhr) {
            cb(res, status, xhr);
        }, function (xhr) {
            xhr.status === 403 ? Helper.redirectToLogin() : Service.mostrarError(Message.Error[xhr.status], Message.Analytics.Error[xhr.status]);
        }, {
            sentHeader: true,
            paywallApi: true,
            showPreloader: true,
            hidePreloader: true
        });
    };

    Service.obtenerMontoACobrar = function (data, cb) {
        Service.ajaxPost('/Venta/ObtenerMontoACobrar', data, function (res, status, xhr) {
            cb && cb(res, status, xhr);
        }, function (xhr) {}, {
            paywallApi: true,
            sentHeader: true
        });
    };

    Service.procesarPago = function (data, cb) {

        Service.ajaxPost('/Venta/ProcesarPago', data, function (res, status, xhr) {
            cb && cb(res, status, xhr);
        }, function (xhr) {
            console.log('error ' + xhr);
        }, {
            paywallApi: true,
            sentHeader: true,
            showPreloader: true,
            hidePreloader: true
        });
    };

    Service.actualizarCookies = function (cb) {
        Service.ajaxPost('/Usuario/Me', false, function (res, status, xhr) {
            if (!Helper.isEmpty(res.response)) {
                var usuario = JSON.parse(res.response);
                Model.Usuario.ClubNacion = usuario.Usuario.ClubNacion === undefined ? "" : usuario.Usuario.ClubNacion;
                Helper.setupCookies(usuario.Usuario);

                res.code == "0000" ? cb && cb(res, status, xhr) : Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']);
            }
        }, function (xhr) {
            xhr.status === 403 ? Helper.redirectToLogin() : Service.mostrarError(Message.Error[xhr.status], Message.Analytics.Error[xhr.status]);
        }, {
            sentHeader: true,
            showPreloader: true
        });
    };

    Service.asociarCredencial = function (data) {
        Service.ajaxPost('/Usuario/AsociarCredencial', data, function (res, status, xhr) {
            // Reseteo numero y tipo de DNI . Si salta error no puedo reemplazarlo . 
            // Si entro por combo 3 no lo tengo que cambiar, porque solo tengo que asignar credencial al DNI ingresado anteriormente . 
            if (Model.Cliente.comboElegido == Config.COMBO_BONIFICADO) {
                Model.Cliente.numeroDocumento = "";
                Model.Cliente.tipoDocumento = "";
            }
            Handler.asociarResponseHandler(res, status, xhr);
        }, null, {
            sentHeader: true,
            showPreloader: true,
            hidePreloader: true
        });
    };

    Service.validarPin = function (data, cb) {
        Helper.updateToken();
        Service.ajaxPost('/Pin/RedeemPin', data, function (res, status, xhr) {
            cb && cb(res, status, xhr);
        }, null, {
            showPreloader: true,
            hidePreloader: true,
            paywallApi: true,
            sentHeader: true
        });
    };

    Service.validarPinReenviar = function (data, cb) {
        Service.ajaxPost('Pin/ReenviarCodigo', data, function (res, status, xhr) {
            cb & cb(res, status, xhr);
        }, null, {
            showPreloader: true,
            hidePreloader: true,
            paywallApi: true,
            sentheader: true
        });
    };

    Service.ventaFacebook = function (data, cb) {

        Service.ajaxPost('/FacebookSubscription/Subscribe', data, function (res, status, xhr) {
            cb && cb(res, status, xhr);
        }, function (xhr) {
            console.log('error ' + xhr);
        }, {
            paywallApi: true,
            sentHeader: true,
            showPreloader: true,
            hidePreloader: true
        });
    };

    Service.ventaFacebookYaTenia = function (data, cb) {

        Service.ajaxPost('/FacebookSubscription/LogIntoAccount', data, function (res, status, xhr) {
            cb && cb(res, status, xhr);
        }, function (xhr) {
            console.log('error ' + xhr);
        }, {
            paywallApi: true,
            sentHeader: true,
            showPreloader: true,
            hidePreloader: true
        });
    };

    // ==================================================
    // Setup App
    // ==================================================   
    Service.setup = function () {
        Model.setUsuario();
        Validation.cleanOnFocusIn();
        Validation.validateOnFocus();
        Validation.validateOnKeyDownOnlyNumbers();
        Helper.placeHolder();
        Router.handle();
    };

    Service.smartlockSignOut = function () {
        smartlock && smartlock.signOut();
    };
})(LN.Service, LN.Router, LN.Handler, LN.Controller, LN.Config, LN.Model, LN.Helper, LN.Validation, LN.Message, LN.Analytics, LN.CustomDimension, jQuery);

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    if (!LN.Core || !LN.Config) throw new Error("LN.Core || LN.Config missing");
})();

(function (Validation, Config, Helper, Service, Handler, Model, Message, Analytics, $) {
    'use strict';

    /*
        Para agregar una validacion por expresion reguar:
        1. Agregar el regex en validators
        2. Agregar el mensaje en caso de error
        3. Agregar la class v-xxxx al input
          Para agregar una validacion por funcion:
        1. Agregar agregar la funcion extendiendo Validation.
        2. Agregar al switch de Validation.byFunction el nombre de la funcion
        3. Agregar el mensaje en caso de error
        4. Agregar la class v-xxxx al input
    */

    Validation.Validators = {
        required: /(.)/,
        text: /^[A-Za-zÀ-ÿ ]$/,
        numeric: /^\d+$/,
        email: /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
        name: /^[A-Za-zÀ-ÿ ']{3,50}$/,
        lastname: /^[A-Za-zÀ-ÿ ]{3,50}$/,
        credencialClub: /^[0-9]{15}?/,
        credencialClub1: /^[0-9]{6}?/,
        credencialClub2: /^[0-9X]{8}?/,
        credencialClub3: /^[0-9]{2}?/,
        tarjeta: /^[0-9]{15,16}$/,
        tarjeta_amex: /^[0-9]{15}$/,
        tarjeta_otras: /^[0-9]{16}$/,
        tarjeta_dinners: /^[0-9]{14}$/,
        dni: /^[1-9][0-9]{6,7}$/,
        passport: /^[A-Za-z0-9]{6,10}$/,
        visa: /^(?:4[0-9]{12}(?:[0-9]{3})?)$/,
        mastercard: /^(?:5[1-5][0-9]{14})$/,
        amex: /^(?:3[47][0-9]{13})$/,
        discover: /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/,
        temporary: /loginTemporalKey/,
        lettersonly: /^[A-Za-zÀ-ÿ ']*$/,
        nameLen2: /^.{2,}$/,
        until50: /^[A-Za-zÀ-ÿ ']{0,50}$/,
        until5: /^[A-Za-zÀ-ÿ 0-9]{1,5}$/,
        surnameLen2: /^.{2,}$/,
        phone: /^\d*$/,
        phonefrom6: /^(\d{6,9999})?$/,
        phoneUntil17: /^\d{6,17}$/,
        numeric_cp: /^[1-9][0-9]*$/,
        numeric_cp_ext: /^[0-9]*$/,
        numeric_cp_arg: /^[1-9][0-9]*$/,
        numeric_dni: /^[1-9][0-9]*$/,
        numeric_from_4: /^\d{4,5}$/,
        street: /^[A-Za-zÀ-ÿ 0-9\']*$/,
        piso: /^[A-Za-zÀ-ÿ 0-9]*$/
    };

    Validation.Messages = {
        /* Validaciones generales */
        text: 'El campo debe ser un texto',
        numeric: 'El número no es válido, ingresá sólo números sin guiones, puntos ni espacios',
        num_invalido: 'Número inválido',
        email: 'El e-mail es inválido',
        passport: 'Tenés que ingresar un pasaporte válido',
        doc_type: 'Ingrese un documento valido',
        error_credencial_incorrecta: ' El número de tarjeta es incorrecto',
        tc_invalida: 'Ingresá un número de tarjeta válido',
        tc_incorrecta: 'Los datos ingresados son incorrectos',
        tc_vencimiento: 'Ingresá una fecha de vencimiento válida',
        /*datos personales*/
        lettersonly: 'Solamente se admiten letras, espacios y un apóstrofe',
        nameLen2: 'Tu nombre debe tener al menos dos caracteres',
        surnameLen2: 'Tu apellido debe tener al menos dos caracteres',
        until50: 'El campo acepta hasta 50 caracteres',
        phone: 'Sólo se aceptan números sin guiones, puntos ni espacios',
        phonefrom6: 'Por lo menos 6 caracteres',
        phoneUntil17: 'El campo acepta hasta 17 caracteres',
        phone_diferentes: 'El telefono celular y particular no pueden ser iguales',
        numeric_cp: 'Debe ser numerico.',
        numeric_dni: 'Debe ser numerico.',
        numeric_from_4: 'Por lo menos 4 digitos',
        street: 'Solo acepta numeros y letras',
        piso: 'Solo acepta numeros y letras',
        /* Validación de campos obligatorios */
        required: 'Campo obligatorio',
        campos_obligatorios: 'Todos los campos con (*) son datos obligatorios',
        required_cp: 'El campo código postal, es obligatorio',
        required_provincia: 'El campo localidad, es obligatorio',
        required_partido: 'El campo partido, es obligatorio',
        codigo_postal_extranjero: 'Código postal inválido',
        /* TARJETA */
        tarjeta: 'Ingresá un número de tarjeta válido.',
        tarjeta_incorrecta: 'Número de tarjeta incorrecto',
        tarjeta_incompleta: 'Número de tarjeta incompleto',
        tarjetas_ultimos_dos: 'Los números ingresados son incorrectos. Ingresá los dos últimos números de tu tarjeta.',

        tarjeta_amex: 'Ingresá un número de tarjeta válido.',
        tarjeta_otras: 'Ingresá un número de tarjeta válido.',
        tarjeta_dinners: 'Ingresá un número de tarjeta válido.',

        /* ASOCIACION */
        doc_incompleto: 'Revisa que el número de documento esté completo',
        pasaporte_incompleto: 'Revisa que el número de pasaporte esté completo y contenga letras y números',
        le_incompleto: 'Revisa que el número de LE esté completo',
        /*MENSAJE AMARILLO*/
        error_compra: 'Ha ocurrido un error al procesar tu compra. Por favor, volvé a intentarlo nuevamente'
    };

    Validation.Validators.Max = {
        name: 50,
        lastname: 50,
        confirmCode: 24,
        credencialClub: 15,
        credencialClub1: 5,
        credencialClub2: 7,
        credencialClub3: 1,
        dni: 8,
        passport: 10
    };

    Validation.checkValidations = function (s, d, a, e) {
        // Si no tiene clase v-* no valida y retorna true.
        if (!s.is('[class*="v-"]')) return true;
        if (s.is('[disabled=disabled]')) return true;
        if (isNaN(a)) a = true; // true por defecto.        
        var validators = s.is(':input') && !s.hasClass('v-no-validate') ? s.attr('class').split(" ") : {};
        var response = true;
        for (var key in validators) {
            var v = validators[key].replace('v-', '');
            if (v == '') {
                break;
            }
            //  Validación por expresion regular.
            if (Validation.Validators[v] && !Validation.Validators[v].test(s.val())) {
                Helper.changeStatus(s, false, Validation.Messages[v]);
                if (a) Analytics.formError(Helper.cleanInputName(s) + ' - ' + Validation.Messages[v]);
                response = false;
                break;
            } else {
                response = response && Validation.byFunction(v, s, d, a, e);
                if (!response) {
                    break;
                } else {
                    Helper.changeStatus(s, true);
                }
            }
        }
        return response;
    };
    Validation.checkKeyUp = function (s, e) {
        // Primero chequeamos el length
        //console.log('keyCode:' + e.keyCode);
        var except = [8, 9, 13, 33, 34, 35, 36, 37, 39, 46];
        var block = [38, 40];
        var maxlenth = s.attr('maxlength');
        if (maxlenth && !except.includes(e.keyCode)) {
            // Tiene maxlength
            var length = s.val().length;
            if (length >= parseInt(maxlenth)) {
                // Supera la maxima, bloqueo caracteres
                e.preventDefault();
                return false;
            }
        }

        // si no hay validacion de keydown, retorno true
        if (!s.is('[class*="k-"]')) return true;
        var validators = s.attr('class').split(' ');
        var response = true;
        for (var key in validators) {
            if (!/k-/.test(validators[key])) continue;
            if (except.includes(e.keyCode)) return;
            if (s.attr('type') !== 'number' && block.includes(e.keyCode)) return false;
            var v = validators[key].replace('k-', '');
            if (v == '') {
                break;
            }

            if (!Validation.Validators[v].test(e.key)) {
                e.preventDefault();
                response = false;
            }
        }
        return response;
    };

    Validation.cleanOnFocusIn = function () {
        $(document.body).on('focusin ', ':input', function (event) {
            Helper.cleanStatus($(this));
        });
    };

    Validation.validateOnFocus = function () {
        $(document.body).on('change', 'select', function (event) {
            Validation.attachValidationProcess($(this));
        });
        $(document.body).on('focusout ', ':input', function (event) {
            Validation.attachValidationProcess($(this));
        });
        $(document.body).on('keydown', ':input', function (event) {

            return Validation.checkKeyUp($(this), event);
        });
    };

    Validation.attachValidationProcess = function (element) {
        if (Config.disableValidations === true) {
            return true;
        }
        if (element.hasClass("v-no-validate")) {
            return true;
        }
        if (element.val() === '') {
            Helper.cleanStatus(element);
        } else if (Validation.checkValidations(element) && element.val() !== '') {
            Helper.changeStatus(element, true);
        }
    };

    Validation.validateOnKeyDownOnlyNumbers = function () {
        $(document.body).on('keydown', '.e-solo_numeros', function (e) {
            if ($(this).attr('type') !== 'number') return;
            var keycode = e.which;
            if (e.ctrlKey && keycode == 67 || e.ctrlKey && keycode == 86) return true;
            if (keycode == 13 || keycode == 32 || keycode == 38 || keycode == 40 || keycode == 107 || keycode == 190 || keycode == 187 || keycode == 188 || keycode == 189 || keycode == 109 || keycode >= 65 && keycode <= 90) {
                e.preventDefault();
                return false;
            }

            if (keycode >= 48 && keycode <= 57 || keycode >= 96 && keycode <= 105) {
                // Ingreso numeros, chequeo lenght
                // Verify maxlenght
                var maxlenth = $(this).attr('maxlength');
                if (maxlenth) {
                    // Tiene maxlength
                    var length = $(this).val().length;
                    if (length >= parseInt(maxlenth)) {
                        // Supera la maxima, bloqueo caracteres
                        e.preventDefault();
                        return false;
                    }
                }
            }
        });
    };

    Validation.validateOnSubmit = function (step, disabledValidations) {
        if (Config.disableValidations === true) return true;
        var objects = Model.getInputsBy(step).all();
        for (var key in objects) {
            Validation.checkValidations(objects[key].object, disabledValidations, false, false);
        }
        return $(".input.error [name^='" + step + "']").length > 0 ? false : true;
    };

    /* EXTENSIONES DE VALIDACIONES */
    Validation.byFunction = function (f, s, d, a, e) {
        // Si la validacion esta deshabilitada
        if (!Helper.isEmpty(d) && !Helper.isEmpty(d[f]) && f == d[f]) return true;
        if (isNaN(a)) a = true;
        switch (f) {
            case 'demo':
                Validation.demo(f, s, a, e);
                break;
            case 'doc_type':
                return Validation.doc_type(f, s, a, e);
            case 'phone_diferentes':
                return Validation.phone_diferentes(f, s, a, e);
            case 'codigo_postal_extranjero':
                return Validation.codigo_postal_extranjero(f, s, a, e);
            case 'normalizar_domicilio':
                return Validation.normalizar_domicilio(f, s, a, e);
            default:
                return true;
        }
    };

    Validation.demo = function (f, s, a) {
        if (s.val() === 'aaaa') {
            Helper.changeStatus(s, true);
            return true;
        }
        Helper.changeStatus(s, false, Validation.Messages[f]);
        return false;
    };

    /* Validacion por DNI o Pasaporte*/
    Validation.doc_type = function (f, s, a, e) {
        var doc_type = Model.getInputsBy('datos_personales', 'tipoDocumento').get().value;
        var response = doc_type === 'PAS' ? response = Validation.Validators.passport.test(s.val()) : response = Validation.Validators.dni.test(s.val()) && !(s.val() == 0);
        Helper.changeStatus(s, response, Validation.Messages[f]);
        if (!response && a) {
            Analytics.formError(Helper.cleanInputName(s) + ' - ' + Validation.Messages[f]);
        }
        return response;
    };

    Validation.phone_diferentes = function (f, s, a, e) {
        var telefono = Model.getInputsBy('datos_personales', 'telefonoParticular').get().value;
        var response = telefono == "";
        Helper.changeStatus(s, response, Validation.Messages[f]);
        if (!response && a) {
            Analytics.formError(Helper.cleanInputName(s) + ' - ' + Validation.Messages[f]);
        }
        return response;
    };

    Validation.codigo_postal_extranjero = function (f, s, a, e) {

        var cp = Model.getInputsBy('datos_envio', 'cp').get().value;

        var response = Model.getInputsBy('datos_envio', 'pais').get().value === 'AR' ? Validation.Validators.numeric_cp_arg.test(s.val()) : Validation.Validators.numeric_cp_ext.test(s.val());

        Helper.changeStatus(s, response, Validation.Messages[f]);

        if (!response && a) {
            Analytics.formError(Helper.cleanInputName(s) + ' - ' + Validation.Messages[f]);
        }

        return response;
    };

    Validation.normalizar_domicilio = function (f, s, a, e) {
        // No valida nada si no es Argentina
        //if (Model.getInputsBy('datos_envio', 'pais').get().value !== 'AR') return true;
        // Seteo el model hasta tener los 3 campos
        Model.DomicilioElegido.calle = Model.getInputsBy('datos_envio', 'calle').get().value;
        Model.DomicilioElegido.altura = Model.getInputsBy('datos_envio', 'altura').get().value;
        Model.DomicilioElegido.cp = Model.getInputsBy('datos_envio', 'cp').get().value;

        if (!Helper.isEmpty(Model.DomicilioElegido.calle) && !Helper.isEmpty(Model.DomicilioElegido.altura) && !Helper.isEmpty(Model.DomicilioElegido.cp)) {
            Service.domicilioNormalizar(Model.DomicilioElegido, function (res, status, xhr) {

                switch (res.code) {

                    case '0000':
                        if (Model.PlanElegido.planConCredencial) {
                            if (!Helper.isEmpty(res.response.entreCalle1)) {
                                Model.getInputsBy('datos_envio', 'entreCalle1').set(res.response.entreCalle1);
                                Helper.SetFocus('datos_envio', 'entreCalle1');
                            }
                            if (!Helper.isEmpty(res.response.entreCalle2)) {
                                Model.getInputsBy('datos_envio', 'entreCalle2').set(res.response.entreCalle2);
                                Helper.SetFocus('datos_envio', 'entreCalle2');
                            }
                        }
                        if (!Helper.isEmpty(res.response.calle)) {
                            Model.getInputsBy('datos_envio', 'calle').set(res.response.calle);
                        }
                        if (!Helper.isEmpty(res.response.localidad)) {
                            Model.getInputsBy('datos_envio', 'localidad').set(res.response.localidad);
                            Helper.SetFocus('datos_envio', 'localidad');
                        }
                        if (!Helper.isEmpty(res.response.localidad)) {
                            Model.getInputsBy('datos_envio', 'partido').set(res.response.localidad);
                            Helper.SetFocus('datos_envio', 'partido');
                        }
                        if (!Helper.isEmpty(res.response.provincia)) {
                            //Model.getInputsBy('datos_envio', 'provincia').set(res.response.provincia);
                            //Helper.SetFocus('datos_envio', 'provincia');
                            $('select[name="datos_envio[provincia]"]').val(res.response.provincia);
                        }

                        Helper.placeHolderAnimationOnStepLoad();
                        if (Helper.checkIfAddressExist(res.response) !== false) {
                            Model.DomicilioTemp = res.response;
                            Helper.showModalAddress();
                        }
                        break;

                    case '0001':
                        logger && logger.fatal('domicilioNormalizar | Error General (' + res.code + ')');
                        break;
                    default:
                        logger && logger.error('domicilioNormalizar | No existe el codigo (' + res.code + ')');
                        Analytics.formError('Paywall | domicilioNormalizar | ' + res.message);
                        break;
                }
            });
        }
        return true;
    };
})(LN.Validation, LN.Config, LN.Helper, LN.Service, LN.Handler, LN.Model, LN.Message, LN.Analytics, jQuery);

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    if (!LN.Core) throw new Error("LN.Core missing");
})();
(function (App, View, Handler, Service, Controller, Config, Helper, Message, Model, Analytics, Hotjar, $) {
    'use strict';

    // ==================================================
    // Manejador datos credenciales 
    // ================================================== 

    Handler.obtenerDatosClubHandler = function (obj, status, xhr) {
        console.log('ObtenerDatosHandler | ' + obj.code);
        //if(!code ==)
        switch (obj.code) {
            //Caso Todo OK
            case '1':
            case '2':
                Model.Usuario.Credenciales = obj.response !== null ? obj.response : [];
                //if (Model.Usuario.TipoAsociarCredencial == "") Model.Usuario.TipoAsociarCredencial = obj.code;
                Model.Usuario.TipoAsociarCredencial = obj.code;
                View.asociarTarjeta();
                break;
            case '0001':
                logger && logger.fatal('ObtenerDatosHandler | Error General', { Response: obj, Model: Model });
                Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL'], {
                    'text': Message.Usuario['VOLVER_A_INTENTARLO'],
                    'stepBack': 'volver_a_ingresar'
                });
                break;
            default:
                logger && logger.error('ObtenerDatosHandler | No existe el tipo de estado (' + obj.code + ')', { Response: obj, Model: Model });
                throw new Error("No existe el tipo de estado");
        }
    };

    Handler.asociarResponseHandler = function (obj, status, xhr) {
        console.log('AsociarHandler | ' + obj.code);
        switch (obj.code) {
            case '1':
                // Chequeo si vengo de combo 1-2 o combo 3 . 
                if (Model.Cliente.comboElegido == Config.COMBO_BONIFICADO) Service.actualizarCookies(function () {
                    var usuarioDetalleClubNacion = Helper.readCookie("usuarioDetalleClubNacion");
                    Analytics.asociacionExitosa(usuarioDetalleClubNacion, Model.Window.lastFlow);
                    Controller.flowE();
                });else Service.actualizarCookies(function () {
                    var usuarioDetalleClubNacion = Helper.readCookie("usuarioDetalleClubNacion");
                    Analytics.asociacionExitosa(usuarioDetalleClubNacion, Model.Window.lastFlow);
                    View.primerAcceso();
                });
                break;
            case '-1':
                // Esto es para form corto 
                // Chequeo si el response del -1 error corresponde a credencial ya asociada a otro usuario . 
                if (obj.message == 'Ya existe la relacion') {
                    var errMsg = Message.Credencial['ERROR_YA_ASOCIADO'];
                    errMsg = errMsg.replace("{{email}}", obj.response);
                    View.asociarTarjeta(errMsg, 'advertencia', function () {
                        Helper.HideVincularTarjetaForm();
                        Helper.HideSubTituloTarjetaForm();
                        Hotjar.callTrigger('LN.Paywall.Vinculacion.ErrorEmail');
                    });
                } else {
                    logger && logger.error('AsociarHandler | Error General', { Response: obj, Model: Model });
                    var errMsg = Message.Credencial['ERROR_ASOCIAR'];
                    View.asociarTarjeta(errMsg, 'error');
                }
                break;
            case '-2':
                View.asociarTarjeta(Message.Credencial['ERROR_NO_COINCIDEN'], 'error');
                break;
            case '-3':
                var mensaje = Message.Credencial['ERROR_YA_ASOCIADO'];
                mensaje = mensaje.replace("{{email}}", obj.response);
                View.asociarTarjeta(mensaje, 'advertencia', function () {
                    Helper.HideVincularTarjetaForm();
                    Helper.HideSubTituloTarjetaForm();
                    Hotjar.callTrigger('LN.Paywall.Vinculacion.ErrorEmail');
                });

                break;
            default:
                logger && logger.error('AsociarHandler | No existe el tipo de estado (' + obj.code + ')', { Response: obj, Model: Model });
                View.asociarTarjeta(Message.Credencial['ERROR_ASOCIAR'], 'error');

        }
    };
})(LN.App, LN.View, LN.Handler, LN.Service, LN.Controller, LN.Config, LN.Helper, LN.Message, LN.Model, LN.Analytics, LN.Hotjar, jQuery);

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  if (!LN.Core) throw new Error("LN.Core missing");
})();
(function (App, View, Handler, Service, Controller, Config, Helper, Message, Model, $) {
  'use strict';

  Handler.flowHandler = function (flow, obj, status, xhr, options) {
    console.log('FlowHandler | ' + obj.code);
    switch (flow) {
      case 'A':
        if (!Model.ComboAccesoSuscripcion) {
          Handler.flowA(obj, status, xhr, options);
        } else {
          Handler.flowABis(obj, status, xhr, options);
        }
        break;
      case 'B':
        Handler.flowB(obj, status, xhr, options);
        break;
      case 'C':
        Handler.flowC(obj, status, xhr, options);
        break;
      case 'D':
        Handler.flowD(obj, status, xhr, options);
        break;
      case 'E':
        Handler.flowE(obj, status, xhr, options);
        break;
      case 'F':
        Handler.flowF(obj, status, xhr, options);
        break;
      //case 'G':
      //    Handler.flowG(obj, status, xhr);
      //    break;                              
      default:
        logger && logger.error('FlowHandler | No existe el tipo de error (' + flow + ')', { Response: obj, Model: Model });
        throw new Error("No existe el tipo de flow");
    }
  };

  // ==================================================
  // Manejador de respustas ajax
  // ================================================== 
  Handler.flowA = function (obj, status, xhr, options) {
    console.log('FlowA | ' + obj.code);
    switch (obj.code) {
      case '07':
        View.tieneDeuda();
        break;
      case '08':
        // Es PP sin Deuda                
        if (Model.Window.combo == Config.PRODUCTO_PDF && !Helper.TieneProductoPremiumPDF()) {
          View.pdfSuscriptoSinAcceso();
        } else {
          Controller.yaTenia();
        }
        break;

      case '13': // Es Classic
      case '14': // No tiene credencial Activa
      case '04': // No esta asociado
      case '26':
        // No es black ni premium
        if (Model.Window.combo == Config.PRODUCTO_PDF) {
          if (Helper.TieneAccesoDigital()) {
            View.pdfSuscriptoSinAcceso();
          } else {
            View.pdfSinSuscripcion();
          }
        } else {
          View.wall();
        }
        break;
      case '25':
        // Es Premium Titular
        View.primerAcceso();
        break;
      case '28':
        // Es Black
        View.primerAcceso();
        break;
      case '30':
      case '31':
        View.wall();
        break;
      case '0001':
        logger && logger.fatal('FlowA | ' + obj.message, { Response: obj, Model: Model });
        Service.mostrarError(Message.Error['GENERAL']);
        break;
      case '0005':
        logger && logger.error('FlowA | ' + obj.message, { Response: obj, Model: Model });
        Service.mostrarError(Message.Error['GENERAL']);
        break;
      default:
        logger && logger.error('FlowA | No existe el codigo (' + obj.code + ')', { Response: obj, Model: Model });
        throw new Error("No existe el tipo de flow");

    }
  };

  Handler.flowABis = function (obj, status, xhr, options) {
    console.log('FlowA Bis | ' + obj.code);
    switch (obj.code) {
      case '04':
      case '13':
      case '14':
      case '26':
      case '30':
      case '31':
        // No tiene producto premium.
        View.noTieneSuscripcion();
        break;
      case '07':
        View.tieneDeuda();
        break;
      case '08':
        // Es PP sin Deuda.
        Controller.yaTenia();
        break;

      case '25':
        // Es Premium Titular.
        View.primerAcceso();
        break;

      case '28':
        // Es Black.
        View.primerAcceso();
        break;
      case '0001':
        logger && logger.fatal('FlowA Bis | ' + obj.message, { Response: obj, Model: Model });
        Service.mostrarError(Message.Error['GENERAL']);
        break;
      default:
        logger && logger.error('FlowA Bis | No existe el codigo (' + obj.code + ') ', { Response: obj, Model: Model });
        throw new Error("No existe el tipo de flow");
    }
  };

  Handler.flowB = function (obj, status, xhr, options) {
    console.log('FlowB | ' + obj.code);
    switch (obj.code) {
      case '02':
        // No es producto premium
        // Ejecuto el controller inicio con el combo de la url
        Service.campanaObtener(Model.Window.landingCampaign || Config.campaniaPaga, function (res, status, xhr) {
          Controller.inicio(Model.Cliente.comboElegido || Model.Window.combo);
        });
        break;
      case '07':
        View.tieneDeuda();
        break;
      case '08':
        // Es PP sin deuda
        //Helper.returnBack();
        Controller.yaCompro();
        break;
      case '0001':
        logger && logger.fatal('FlowB | ' + obj.message, { Response: obj, Model: Model });
        Service.mostrarError(Message.Error['GENERAL']);
        break;
      case '0005':
        logger && logger.error('FlowB | ' + obj.message, { Response: obj, Model: Model });
        Service.mostrarError(Message.Error['GENERAL']);
        break;
      default:
        logger && logger.error('FlowB | No existe el codigo (' + obj.code + ')', { Response: obj, Model: Model });
        throw new Error("No existe el tipo de flow");
    }
  };

  Handler.flowC = function (obj, status, xhr, options) {
    console.log('FlowC | ' + obj.code);
    switch (obj.code) {
      case '04':
        // No esta asociado
        Controller.obtenerMontoACobrar(function () {
          //View.ingresarDni();
          if (!Model.Cliente.email) {
            Model.Cliente.email = Helper.readCookie('usuarioemail');
          }
          View.formularioDatosPersonales();
        });
        break;
      case '07':
        // Tiene deuda
        View.tieneDeuda();
        break;
      case '13':
        // Es Classic
        Controller.obtenerMontoACobrar(function () {
          Controller.obtenerDatosPersonales();
        });
        break;
      case '14':
        // No tiene Credenciales
        Controller.obtenerMontoACobrar(function () {
          Controller.obtenerDatosPersonales();
        });
        break;
      case '21':
        Controller.yaCompro();
        break;
      case '25':
        // Es Premium Titular
        View.yaTieneCuenta();
        break;
      case '26':
        // Es Premium Adicional
        Controller.obtenerMontoACobrar(function () {
          Controller.obtenerDatosPersonales();
        });
        break;
      case '28':
        // Es Black
        View.yaTieneCuenta();
        break;
      case '30':
      case '31':
        Controller.obtenerMontoACobrar(function () {
          Controller.obtenerDatosPersonales();
        });
        break;
      case '0001':
        logger && logger.fatal('FlowC | ' + obj.message, { Response: obj, Model: Model });
        Service.mostrarError(Message.Error['GENERAL']);
        break;
      case '0005':
        logger && logger.error('FlowC | ' + obj.message, { Response: obj, Model: Model });
        Service.mostrarError(Message.Error['GENERAL']);
        break;
      default:
        logger && logger.error('FlowC | No existe el codigo (' + obj.code + ')', { Response: obj, Model: Model });
        throw new Error("No existe el tipo de flow");
    }
  };

  Handler.flowD = function (obj, status, xhr, options) {
    console.log('FlowD | ' + obj.code);
    switch (obj.code) {
      case '07':
        // Tiene deuda
        View.tieneDeuda();
        break;
      case '11':
        Model.Cliente.mailOfuscado = obj.message;
        Controller.ingresarDni_OtroUsuario();
        LN.AppEvent.sendEvent('DNI-ASOCIADO-A-OTRO');
        break;

      case '25':
      case '28':
        // Es black o premium activo
        // TODO : asociar credencial . 
        Handler.obtenerDatosClubHandler({ code: '2', response: [] });
        break;

      case '10':
      case '13':
      case '14':
      case '26':
      case '30':
      case '31':
        // Cliente nuevo: Compra
        //Controller.formularioDatosPersonalesClienteNuevo();
        Controller.formularioDatosPersonales();
        break;
      case '0001':
        logger && logger.fatal('FlowD | ' + obj.message, { Response: obj, Model: Model });
        Service.mostrarError(Message.Error['GENERAL']);
        break;
      case '0005':
        logger && logger.error('FlowD | ' + obj.message, { Response: obj, Model: Model });
        Service.mostrarError(Message.Error['GENERAL']);
        break;
      default:
        logger && logger.error('FlowD | No existe el codigo  (' + obj.code + ')', { Response: obj, Model: Model });
        throw new Error("No existe el tipo de flow");
    }
  };

  Handler.flowE = function (obj, status, xhr, options) {
    console.log('FlowE | ' + obj.code);
    switch (obj.code) {
      case '07':
        // Tiene deuda
        View.tieneDeuda();
        break;
      case '13':
        // Es Classic activo
        View.planInsuficiente();
        break;
      case '14':
        // No es Classic activo
        View.planInsuficiente();
        break;
      case '25':
        // Es black o premium activo
        View.primerAcceso();
        break;
      case '26':
        // Es Premium adicional
        View.planInsuficiente();
        break;
      case '28':
        // Es black o premium activo
        View.primerAcceso();
        break;
      case '30':
        View.mostrarMensajeUno();
        break;
      case '31':
        View.mostrarMensajeTribuno();
        break;
      case '0001':
        logger && logger.fatal('FlowE | ' + obj.message, { Response: obj, Model: Model });
        Service.mostrarError(Message.Error['GENERAL']);
        break;
      case '0005':
        logger && logger.error('FlowE | ' + obj.message, { Response: obj, Model: Model });
        Service.mostrarError(Message.Error['GENERAL']);
        break;
      default:
        logger && logger.error('FlowE | No existe el codigo (' + obj.code + ')', { Response: obj, Model: Model });
        throw new Error("No existe el tipo de flow");

    }
  };

  Handler.flowF = function (obj, status, xhr, options) {
    console.log('FlowF | ' + obj.code);
    switch (obj.code) {
      case '07':
        // Tiene deuda
        View.tieneDeuda();
        break;
      case '13':
        // Es Classic activo
        View.planInsuficiente();
        break;
      case '14':
        // No es Classic activo
        View.planInsuficiente();
        break;
      case '17':
      // Form corto . (dos ultimos numero de credencial)
      case '19':
      // Form corto . (credencial completa)
      case '20':
        // Form largo . 
        Controller.validarTipoAsociacionClub();
        break;
      case '21':
        Controller.yaCompro();
        break;
      case '25':
        // Acepta TyC
        View.primerAcceso();
        break;
      case '26':
        // Es Premium adicional
        View.planInsuficiente();
        break;
      case '28':
        // Acepta TyC
        View.primerAcceso();
        break;
      case '30':
        View.mostrarMensajeUno();
        break;
      case '31':
        View.mostrarMensajeTribuno();
        break;
      case '0001':
        logger && logger.fatal('FlowF | ' + obj.message, { Response: obj, Model: Model });
        Service.mostrarError(Message.Error['GENERAL']);
        break;
      case '0005':
        logger && logger.error('FlowF | ' + obj.message, { Response: obj, Model: Model });
        Service.mostrarError(Message.Error['GENERAL']);
        break;
      default:
        logger && logger.error('FlowF | No existe el codigo: ' + obj.code, { Response: obj, Model: Model });
        throw new Error("No existe el tipo de flow");

    }
  };
})(LN.App, LN.View, LN.Handler, LN.Service, LN.Controller, LN.Config, LN.Helper, LN.Message, LN.Model, jQuery);

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    if (!LN.Core) throw new Error("LN.Core missing");
})();
(function (App, View, Handler, Service, Controller, Config, Helper, Message, Model, Analytics, $, Promises) {
    'use strict';

    var iniciarVentaRecurrente = function iniciarVentaRecurrente(obj, status, xhr) {
        console.log('iniciarVentaRecurrente | ' + obj);
        if (obj.code == '0000') {
            Model.setPago(obj.response.formularioWondersoft);
            View.formularioPago(Message.Pago.ERROR_GENERAL);
        } else {
            View.formularioPago(Message.Pago.ERROR_GENERAL, true);
        }
    };

    // ==================================================
    // Manejador de respustas ajax
    // ================================================== 
    Handler.clienteObtener = function (obj, status, xhr) {
        console.log('ClienteObtenerHandler | ' + obj.code);
        switch (obj.code) {
            case '0000':
                // OK
                Model.setCliente(obj);
                View.formularioDatosPersonales();
                break;
            case '1010':
                // Informacion del contacto no encontrada
                break;
            case '0001':
                logger && logger.fatal('ClienteObtenerHandler | ' + obj.message, { Response: obj, Model: Model });
                Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']);
                break;
            default:
                logger && logger.error('ClienteObtenerHandler | No existe el codigo (' + obj.code + ')', { Response: obj, Model: Model });
                throw new Error("No existe el tipo de estado");
        }
    };

    // ==================================================
    // Manejador de respustas ajax
    // ================================================== 
    Handler.iniciarVenta = function (obj, status, xhr) {
        switch (obj.code) {
            case '0000':
                var residencia = Model.getInputsBy("datos_personales", 'residencia').get().value;
                Model.Venta.Domicilio = obj.response.domicilioResponse;
                Model.Venta.esExtranjero = residencia == 'true' ? true : false;
                Model.setPago(obj.response.formularioWondersoft);
                View.formularioPago();
                break;
            case "4001":
                // Usuario no logeado
                Helper.showBlockMessageError("form-datos-personales-error");
                break;
            case "4011":
                // Debes especificar un numero de documento
                Helper.showBlockMessageError("form-datos-personales-error");
                break;
            case '4040':
                // Error de duplicidad de tipo-nro de documento 
                var text = Helper.readCookie("usuario%5Fid") + ' -- Ya existe más de un cliente con este tipo y número de documento.';
                Analytics.error(text);
                logger && logger.error('ClienteGuardarHandler | ' + obj.message, { Response: obj, Model: Model });
                Helper.showBlockMessageError("form-datos-personales-error");
                break;
            case '0001':
                logger && logger.fatal('ClienteGuardarHandler | ' + obj.message, { Response: obj, Model: Model });
                Helper.showBlockMessageError("form-datos-personales-error");
                break;
            default:
                logger && logger.error('ClienteGuardarHandler | No existe el codigo (' + obj.code + ')', { Response: obj, Model: Model });
                throw new Error("No existe el tipo de estado");
        }
    };
    // ==================================================
    // Manejador de respustas ajax
    // ================================================== 
    Handler.clienteGuardar = function (obj, status, xhr) {
        console.log('ClienteGuardarHandler | ' + obj.code);
        switch (obj.code) {
            case '0000':
                var residencia = Model.getInputsBy("datos_personales", 'residencia').get().value;
                Model.Venta.Domicilio = obj.response.domicilio;
                Model.Venta.esExtranjero = residencia == 'true' ? true : false;
                Model.setPago(obj.response.venta);
                View.formularioPago();
                break;
            case "4001":
                // Usuario no logeado
                Helper.showBlockMessageError("form-datos-personales-error");
                break;
            case "4011":
                // Debes especificar un numero de documento
                Helper.showBlockMessageError("form-datos-personales-error");
                break;
            case '4040':
                // Error de duplicidad de tipo-nro de documento 
                var text = Helper.readCookie("usuario%5Fid") + ' -- Ya existe más de un cliente con este tipo y número de documento.';
                Analytics.error(text);
                logger && logger.error('ClienteGuardarHandler | ' + obj.message, { Response: obj, Model: Model });
                Helper.showBlockMessageError("form-datos-personales-error");
                break;
            case '0001':
                logger && logger.fatal('ClienteGuardarHandler | ' + obj.message, { Response: obj, Model: Model });
                Helper.showBlockMessageError("form-datos-personales-error");
                break;
            default:
                logger && logger.error('ClienteGuardarHandler | No existe el codigo (' + obj.code + ')', { Response: obj, Model: Model });
                throw new Error("No existe el tipo de estado");
        }
    };

    // ==================================================
    // Manejador de respustas ajax
    // ================================================== 
    Handler.clienteObtenerCrmId = function (obj, status, xhr) {
        console.log('ClienteCrmHandler | ' + obj.code);
        switch (obj.code) {
            case '0000':
                // OK
                break;
            case '0001':
                logger && logger.fatal('ClienteCrmHandler | ' + obj.message, { Response: obj, Model: Model });
                Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']);
                break;
            default:
                logger && logger.error('ClienteCrmHandler | No existe el codigo (' + obj.code + ')', { Response: obj, Model: Model });
                throw new Error("No existe el tipo de estado");
        }
    };

    // ==================================================
    // Manejador de respustas ajax
    // ================================================== 
    Handler.obtenerDatosFiliatorios = function (obj, status, xhr) {
        console.log('FiliatoriosHandler | ' + obj.code);
        switch (obj.code) {
            case '0000':
                // OK
                Model.setCliente(obj);
                //Controller.obtenerMontoACobrar(function () {
                View.formularioDatosPersonales();
                //});
                break;
            case '4010':
                // Informacion del contacto no encontrada                
                Service.mostrarError(Message.Usuario['INFORMACION_NO_ENCONTRADA'], Message.Analytics.Usuario['INFORMACION_NO_ENCONTRADA']);
                break;
            case '0001':
                logger && logger.fatal('FiliatoriosHandler |' + obj.message, { Response: obj, Model: Model });
                Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']);
                break;
            default:
                logger && logger.error('FiliatoriosHandler | No existe el codigo (' + obj.code + ')', { Response: obj, Model: Model });
                throw new Error("No existe el tipo de estado");
        }
    };

    // ==================================================
    // Manejador de respustas ajax
    // ================================================== 
    Handler.obtenerDatosFiliatoriosFormularioEnvio = function (obj, status, xhr) {
        console.log('FiliatoriosHandler | ' + obj.code);
        switch (obj.code) {
            case '0000':
                // OK
                //Model.setCliente(obj);
                //View.formularioDatosPersonales();
                Model.setCliente(obj);
                Model.setDomicilios(obj);

                //Model.setPlanAssets();

                View.formularioPosdatado(null, function () {
                    /* Seteo el primer domicilio como checked */
                    if (Model.getFirstDomicilio() !== false) {
                        Model.getInputsBy('datos_envio', 'id').set(Model.getFirstDomicilio().id);
                    }
                    Helper.eventosDatosEnvios();
                    Helper.carrito();
                    Helper.yaCompraste();
                });

                break;
            case '4010':
                // Informacion del contacto no encontrada                
                Service.mostrarError(Message.Usuario['INFORMACION_NO_ENCONTRADA'], Message.Analytics.Usuario['INFORMACION_NO_ENCONTRADA']);
                break;
            case '0001':
                logger && logger.fatal('FiliatoriosHandler | ' + obj.message, { Response: obj, Model: Model });
                Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']);
                break;
            default:
                logger && logger.error('FiliatoriosHandler | No existe el codigo  (' + obj.code + ')', { Response: obj, Model: Model });
                throw new Error("No existe el tipo de estado");
        }
    };

    // ==================================================
    // Manejador de respustas ajax
    // ================================================== 
    Handler.obtenerMontoACobrar = function (obj, status, xhr) {
        switch (obj.code) {
            case '0000':
                Model.setPlanMonto(obj.response);
                break;
            case '0001':
                logger && logger.fatal('CampanaHandler |' + obj.message, { Response: obj, Model: Model });
                Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']);
                break;
            default:
                logger && logger.error('CampanaHandler | No existe el codigo (' + obj.code + ')', { Response: obj, Model: Model });
                throw new Error("No existe el tipo de estado");
        }
    };

    // ==================================================
    // Manejador de respustas ajax
    // ================================================== 
    Handler.campaniaObtener = function (obj, status, xhr) {
        console.log('CampanaHandler | ' + obj.code);
        switch (obj.code) {
            case '0000':
                // OK
                break;
            case '0001':
                logger && logger.fatal('CampanaHandler |' + obj.message, { Response: obj, Model: Model });
                Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']);
                break;
            default:
                logger && logger.error('CampanaHandler | No existe el codigo (' + obj.code + ')', { Response: obj, Model: Model });
                throw new Error("No existe el tipo de estado");
        }
    };

    // ==================================================
    // Manejador de respustas ajax
    // ================================================== 
    Handler.existeMailUsuarioResponseHandler = function (obj, status, xhr) {
        console.log('MailHandler | ' + obj.code);
        switch (obj.code) {
            case '0000':
                //
                break;
            case '0001':
                logger && logger.fatal('MailHandler | ' + obj.message, { Response: obj, Model: Model });
                Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']);
                break;
            default:
                logger && logger.error('MailHandler | No existe el codigo (' + obj.code + ')', { Response: obj, Model: Model });
                throw new Error("No existe el tipo de estado");
        }
    };

    // ==================================================
    // Manejador de respustas ajax
    // ================================================== 
    Handler.domicilioNormalizar = function (obj, status, xhr) {
        console.log('NormalizarHandler | ' + obj.code);
        switch (obj.code) {
            case '0000':
                //
                break;
            case '0005':
                Analytics.formError('NormalizarHandler | ' + obj.message, { Response: obj, Model: Model });
                // Parametros invalidos
                break;
            case '0011':
                Analytics.formError('NormalizarHandler | ' + obj.message, { Response: obj, Model: Model });
                // Informacion del domicilio no encontrada
                break;
            case '0001':
                logger && logger.fatal('NormalizarHandler | ' + obj.message, { Response: obj, Model: Model });
                Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']);
                break;
            case '3022':
            case '3023':
            case '3024':
            case '3025':
                Analytics.formError('Paywall | domicilioNormalizar | ' + obj.message, 'Respuesta: ' + JSON.stringify(obj) + ' | Cliente: ' + JSON.stringify(Model.Usuario));
                Service.mostrarError(obj.message);
                break;
            default:
                logger && logger.error('NormalizarHandler | No existe el codigo (' + obj.code + ')', { Response: obj, Model: Model });
                //throw new Error("No existe el tipo de estado");
                Service.mostrarError(obj.message);
        }
    };

    // ==================================================
    // Manejador de respustas ajax
    // ================================================== 
    Handler.ventaGuardar = function (obj, status, xhr) {
        console.log('VentaHandler | ' + obj.code);
        switch (obj.code) {
            case '0000':
                if (!Helper.isEmpty(Model.PlanElegido)) Analytics.transaccionExitosa(Model.PlanElegido.nombre, Model.PlanElegido.precio, Model.Window.lastFlow);

                // Agregar aca el Pin
                if (!Helper.isEmpty(obj.response.pin)) {
                    Model.pin = obj.response.pin;
                    Model.pinUrl = obj.response.pinUrl;
                    Model.pinDesc = obj.response.pinDesc;
                }

                switch (Model.Cliente.comboElegido) {
                    case Config.COMBO_ACCESO_DIGITAL:
                        Service.actualizarCookies(View.confirmacionCombo1);
                        break;
                    case Config.COMBO_ACCESO_DIGITAL_CREDENCIAL:
                    case Config.COMBO_NYT:
                    case Config.COMBO_PROMO_ACCESO_DIGITAL_CREDENCIAL:
                        //case Config.COMBO_CALL_ACCESO_Y_CLUB:
                        //case Config.COMBO_CALL_ACCESO_Y_CLUB_50_OFF:
                        //case Config.COMBO_CALL_ACCESO_Y_CLUB_5_DESCUENTO:
                        Service.actualizarCookies(View.confirmacionCombo2);
                        break;
                    case Config.COMBO_BONIFICADO:
                        Service.actualizarCookies(Controller.postVentaBonificada);
                        break;
                }
                LN.AppEvent.sendEvent('VENTA-OK');
                break;
            case '0005':
                Analytics.formError('Paywall | domicilioNormalizar | Ingrese una tarjeta valida. | ' + obj.message, 'Respuesta: ' + JSON.stringify(obj) + ' | Cliente: ' + JSON.stringify(Model.Usuario));
                Helper.showBlockMessageError('error-tarjeta');
                break;
            case '0011':
                // Informacion del domicilio no encontrada
                Analytics.formError('Paywall | domicilioNormalizar | Información del domicilio no encontrada. | ' + obj.message, 'Respuesta: ' + JSON.stringify(obj) + ' | Cliente: ' + JSON.stringify(Model.Usuario));
                break;
            case '6001':
                // No se ha podido validar la tarjeta                
                Analytics.formError('Paywall | domicilioNormalizar | No se ha podido validar la tarjeta. | ' + obj.message, 'Respuesta: ' + JSON.stringify(obj) + ' | Cliente: ' + JSON.stringify(Model.Usuario));
                Helper.showBlockMessageError('error-tarjeta');
                break;
            case "6002":
                // No se ha podido generar la venta.
                Analytics.formError('Paywall | domicilioNormalizar | No se ha podido generar la venta. | ' + obj.message, 'Respuesta: ' + JSON.stringify(obj) + ' | Cliente: ' + JSON.stringify(Model.Usuario));
                break;
            case "6003":
                // No se ha podido encontrar el domicilio.
                Analytics.formError('Paywall | domicilioNormalizar | No se ha podido encontrar el domicilio. | ' + obj.message, 'Respuesta: ' + JSON.stringify(obj) + ' | Cliente: ' + JSON.stringify(Model.Usuario));
                View.domicilioNoExiste();
                break;
            case '0001':
                // No se ha podido generar la venta.
                logger && logger.fatal('VentaHandler | Error inesperado', { Response: obj, Model: Model });
                Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']);
                break;
            case '6007':
                logger && logger.error('VentaHandler | Error en wondersoft', { Response: obj, Model: Model });
                Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']);
                break;
            default:
                logger && logger.error('VentaHandler | No existe el codigo (' + obj.code + ')', { Response: obj, Model: Model });
                throw new Error("No existe el tipo de estado");
        }
    };

    // ==================================================
    // Manejador de respustas ajax
    // ================================================== 
    Handler.pagoObtenerTarjetasYBancos = function (obj, status, xhr) {
        console.log('BancoTarjetaHandler | ' + obj.code);
        switch (obj.code) {
            case '0000':
                //
                break;
            case '0005':
                // Parametros invalidos
                break;
            case '0001':
                logger && logger.fatal('BancoTarjetaHandler | ' + obj.message, { Response: obj, Model: Model });
                Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']);
                break;
            default:
                logger && logger.error('BancoTarjetaHandler | No existe el codigo (' + obj.code + ')', { Response: obj, Model: Model });
                throw new Error("No existe el tipo de estado");
        }
    };

    // ==================================================
    // Manejador de respustas ajax
    // ================================================== 
    Handler.pagoValidar = function (obj, status, xhr) {
        console.log('PagoHandler | ' + obj.code);
        switch (obj.code) {
            case '0000':
                //
                break;
            case '0005':
                // Parametros invalidos
                break;
            case '0001':
                logger && logger.fatal('PagoHandler | ' + obj.message, { Response: obj, Model: Model });
                Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']);
                break;
            default:
                logger && logger.error('PagoHandler | No existe el codigo (' + obj.code + ')', { Response: obj, Model: Model });
                throw new Error("No existe el tipo de estado");
        }
    };

    // ==================================================
    // Manejador de errores http
    // ================================================== 
    Handler.failHandler = function (code) {
        console.log('FalloHandler | ' + code);
        switch (code) {
            case 500:
                Service.mostrarError(Message.Error['500'], Message.Analytics.Error['500']);
                break;
            case 400:
                Service.mostrarError(Message.Error['400'], Message.Analytics.Error['400']);
                break;
            case 401:
                Service.mostrarError(Message.Error['401'], Message.Analytics.Error['401']);
                break;
            case 402:
                Service.mostrarError(Message.Error['402'], Message.Analytics.Error['402']);
                break;
            case 403:
                Service.mostrarError(Message.Error['403'], Message.Analytics.Error['403']);
                break;
            case 200:
                ///
                break;
            case 'parsererror':
                Service.mostrarError(Message.Error['PARSER_ERROR'], Message.Analytics.Error['PARSER_ERROR']);
                break;
            case 'timeout':
                Service.mostrarError(Message.Error['TIMEOUT'], Message.Analytics.Error['TIMEOUT']);
                break;
            case 'abort':
                Service.mostrarError(Message.Error['ABORT'], Message.Analytics.Error['ABORT']);
                break;
            case 0:
                break;
            default:
                logger && logger.error('FalloHandler | No existe el error ( ' + code + ')');
            //throw new Error("No existe el error");
        }
    };

    // ==================================================
    // Manejador de errores Terminos y Condiciones
    // ================================================== 
    Handler.aceptaTyCErrores = function (code) {
        console.log('AceptaTCHandler | ' + code);
        //Service.mostrarError(Message.Error['GENERAL']);
        switch (Model.Window.currentStep) {
            case 'primer_acceso':
                if (code == "6003") View.domicilioNoExiste();else View.primerAcceso(Message.Error['GENERAL']);
                break;
            case 'ya_tiene_cuenta':
                View.yaTieneCuenta(Message.Error['GENERAL']);
                break;
            default:
                Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']);
        }
    };

    // ==================================================
    // Manejador de errores Validar Pines
    // ================================================== 
    Handler.validarPin = function (response) {
        console.log('ValidarPinHandler | ' + response.code);
        var credencialCat = void 0;
        var msj;
        switch (response.code) {

            case '0000':
                // Validacion del PIN OK
                Service.actualizarCookies(function () {
                    Analytics.clickValidarPin('Activación exitosa');
                    View.validarPinGracias();
                });
                break;
            case '6008':
            case '6011':
                // PIN NO EXISTE
                Analytics.clickValidarPin('Código de activación inválido');
                Helper.changeStatus($('#pin'), false, Message.Pines['PIN_INEXISTENTE']);
                break;
            case '6009':
                // PIN USADO
                Analytics.clickValidarPin('El código de activación que ingresaste ya ha sido utilizado');
                Helper.changeStatus($('#pin'), false, Message.Pines['PIN_USADO']);
                //View.validarPin(Message.Pines['PIN_USADO']);
                break;
            case '6010':
                // PIN VENCIDO
                Analytics.clickValidarPin('El código de activación ha vencido');
                View.validarPin(Message.Pines['PIN_VENCIDO']);
                break;
            case '0002':
                //Usuario no logeado, pide login/crear usuario.

                Helper.redirectToLoginWReturnAction('/validar-pin/' + Model.pin, 'vp');
                break;
            case '0201':
                // PIN ASOCIOADO A OTRO CRM
                Analytics.clickValidarPin('El código tiene asociado un CRM, que está asociado a otro usuario');
                View.validarPin(Message.Pines['PIN_ASOCIADO_A_OTRO_CRM']);
                break;
            case '07':
            case '08':
                // Ya tiene suscripcion
                Analytics.clickValidarPin('Tu cuenta de LA NACION ya tiene una suscripción digital activa');
                View.validarPin(Message.Pines['PIN_SUSCRIPCION_ACTIVA']);
                logger && logger.error('ValidarPinHandler | Ya tiene suscripcion digital activa', { Response: response, Model: Model });
                break;
            case '13':
            case '14':
            case '26':
            case '30':
            case '31':
                // Tarjeta asociada sin permisos, necesita desasociar.
                Analytics.clickValidarPin('Tu cuenta de LA NACION ya tiene una tarjeta asociada. Para continuar, es necesario que desvincules esa tarjeta desde Mi Cuenta');
                View.validarPin(Message.Pines['PIN_ASOCIADA']);
                logger && logger.error('ValidarPinHandler | El usuario ya tiene credencial asociada Classic', { Response: response, Model: Model });
                break;
            case '25':
                // Premium
                credencialCat = 'Premium';
            case '28':
                // Tarjeta Black o Premium Titular, mensaje de acceso digital bonificado.
                Analytics.clickValidarPin('Tenes una tarjeta asociada en tu cuenta de LA NACION que te permite tener acceso digital bonificado');
                credencialCat = 'Black';
                msj = Message.Pines['PIN_ASOCIADA_BONIFICADO'];
                msj = msj.replace('{credencial}', credencialCat);
                View.validarPin(msj);
                logger && logger.error('ValidarPinHandler | El usuario ya tiene credencial Black o Premium', { Response: response, Model: Model });
                break;
            case '0001':
                logger && logger.fatal('ValidarPinHandler | ' + obj.message || '', { Response: obj, Model: Model });
                Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']);
                break;
            default:
                logger && logger.fatal('ValidarPinHandler | El codigo de respuesta no existe (' + obj.code || '' + ')', { Response: obj, Model: Model });
                throw new Error("No existe el tipo de estado");
                // Service.mostrarError(Message.Error['GENERAL']);
                break;
        }
    };

    // ==================================================
    // Manejador de errores Validar Pines Reenviar codigo
    // ================================================== 
    Handler.validarPinReenviar = function (response) {
        switch (response.code) {
            case '0000':

                break;
            default:
                Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']);
                break;
        }
    };

    Handler.posdatarDomicilio = function (response) {
        console.log('posdatarDomicilio | ' + response.code);

        switch (response.code) {
            case '0000':

                Model.Venta.Credencial = response.response;
                View.confirmacionCombo2();

                break;
            case '0005':
                // Parametros invalidos
                Analytics.formError('Paywall | domicilioCrear | ' + obj.message, 'Respuesta: ' + JSON.stringify(obj) + ' | Cliente: ' + JSON.stringify(Model.Usuario));
                break;
            case '0011':
                // Informacion del domicilio no encontrada
                Analytics.formError('Paywall | domicilioCrear | ' + obj.message, 'Respuesta: ' + JSON.stringify(obj) + ' | Cliente: ' + JSON.stringify(Model.Usuario));
                break;
            case '3012':
            case '3013':
            case '3014':
            case '3015':
            case '3016':
            case '3017':
            case '3018':
            case '3019':
            case '3020':
            case '3021':
                Analytics.formError('Paywall | domicilioCrear | ' + obj.message, 'Respuesta: ' + JSON.stringify(obj) + ' | Cliente: ' + JSON.stringify(Model.Usuario));
                Service.mostrarError(obj.message);
                break;
            case '0001':
            default:
                logger && logger.fatal('posdatarDomicilio | ' + response.message, { Response: response, Model: Model });
                //Helper.cleanStatusInputs();
                //Helper.cleanInputs();
                Helper.enableNextButton();
                $('.atencion, .error-tarjeta').css('display', 'block');
                View.formularioEnvio();

                break;
        }
    };

    Handler.procesarPago = function (obj, status, xhr) {
        console.log('procesarPago | ' + obj.code);
        switch (obj.code) {
            case '0000':
                // Asigno el pin al modelo para mostrar en el gracias
                if (!Helper.isEmpty(obj.response.pin)) {
                    Model.pin = obj.response.pin;
                    Model.pinUrl = obj.response.pinUrl;
                    Model.pinDesc = obj.response.pinDesc;
                }
                Controller.postVenta();
                break;
            default:
                Controller.iniciarVenta(Model.Venta.Domicilio, null, iniciarVentaRecurrente);
        }
    };
})(LN.App, LN.View, LN.Handler, LN.Service, LN.Controller, LN.Config, LN.Helper, LN.Message, LN.Model, LN.Analytics, jQuery, LN.Promises);

/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    if (!LN.Core) throw new Error("LN.Core missing");
})();
(function (App, View, Handler, Service, Controller, Config, Helper, Message, Model, Analytics, $) {
    'use strict';
    // ==================================================
    // Manejador de eventos step
    // ==================================================  

    Handler.stepHandler = function (step, o) {
        switch (step) {
            case 'combo_procesar':
                /* Stats */
                Model.setCombo(o.data('combo'));
                if (!Helper.isEmpty(Model.PlanElegido) && o.data('combo') != Config.COMBO_BONIFICADO) {
                    Analytics.clickCombo(Model.PlanElegido.nombre, Model.PlanElegido.precio, Helper.getSource());
                }
                if (o.data('combo') == Config.COMBO_BONIFICADO) {
                    Analytics.clickCombo3(Helper.getSource());
                }
                /* /Stats */
                Controller.inicio(o.data('combo'));
                break;
            case 'ingresar_dni':
                Controller.ingresarDni();
                break;
            case 'formulario_datos_personales':
                //Controller.formularioDatosPersonales();
                Controller.ingresarDni();
                break;
            case 'formulario_envio':
                //Controller.formularioEnvio();
                Controller.posdatarDomicilio();
                break;
            case 'formulario_pago':
                Controller.formularioPago();
                break;

            case 'aceptar_terminos':
                LN.AppEvent.sendEvent('CERRO');
                Controller.aceptaTyC(); // Ejecuta compra impl�cita de Combo 3 
                break;
            case 'agregar_domicilio':
                Controller.agregarDomicilio();
                break;
            case 'logout':
                Service.logout();
                LN.AppEvent.sendEvent('LOGINTO');
                break;
            case 'volver_inicio':
                Analytics.otrosEnlaces(Helper.getSource(), 'volver');
                if (Helper.getSource() == 'wall' || Helper.getSource() == 'suscripcion') {
                    if (Model.Window.modo == 'V' && Model.Window.combo == 2) View.pdfSinSuscripcion();else View.wall();
                } else {
                    if (Helper.getSource() == 'wall_suscribirme') View.wallSuscribime();else View.landing();
                }
                break;
            case 'volver_edicion_impresa':
                Analytics.otrosEnlaces(Helper.getSource(), 'volver');
                Helper.returnBack({
                    url: Config.urlEdicionImpresa
                });
                break;
            case 'volver_formulario_datos_personales':
                Analytics.otrosEnlaces(Helper.getSource(), 'volver');
                View.formularioDatosPersonales();
                break;
            case 'domicilio_usar_nuevo':
                Helper.hideModalAddress();
                break;
            case 'domicilio_usar_seleccionado':
                Model.DomicilioElegido.id = Helper.checkIfAddressExist(Model.DomicilioTemp);
                Helper.selectAddressRadio(Model.DomicilioElegido.id);
                Helper.hideModalAddress();
                break;
            case 'volver_ingresar_dni':
                Analytics.otrosEnlaces(Helper.getSource(), 'volver');
                Controller.flowC();
                break;
            case 'quick_view':
                // Solo con propositos de testing
                eval("LN.View." + o.data('view') + "()");
                break;
            case 'asociar_tarjeta_corto':
                Controller.asociarCredencialCorto(); // Asociar corto
                break;
            case 'asociar_tarjeta_largo':
                Controller.asociarCredencialLargo(); // Asociar largo
                break;
            case 'ya_tenes_suscripcion':
                Analytics.clickYaTengoSuscripcion();
                Model.ComboAccesoSuscripcion = true;
                Service.isLogged(function () {
                    Controller.flowA(Config.defaultModo, Config.defaultCombo);
                }, function () {
                    Helper.redirectToLoginWAction(Config.ACCION_YA_TIENE_SUSCRIPCION);
                });
                break;
            case 'return_back':
                Analytics.otrosEnlaces(Helper.getSource(), 'volver');
                Helper.returnBack();
                LN.AppEvent.sendEvent('CERRO');
                break;
            case 'return_back_front':
                Analytics.otrosEnlaces(Helper.getSource(), 'volver');
                Helper.returnBack({
                    url: Config.defaultRedirectUrl
                });
                break;
            case 'volver':
                Analytics.otrosEnlaces(Helper.getSource(), 'volver');
                Helper.returnBack({
                    url: document.referrer
                });
                break;
            case 'validar_pines_activar':
                Controller.validarPinesProcesar();
                break;
            case 'validar_pines_tyc':
                Controller.validarPinesTyC();
                break;
            case 'validar_pines_miclub':
                Controller.validarPinesMiClub();
            case 'validar_pines_reenviar':
                Controller.validarPinesReenviar();
                break;
            case 'redirect':
                Helper.redirectUrl(o.data('url'));
            case 'callback-mobile':
                LN.AppEvent.sendEvent(o.data('callback'), o.attr('href'));
            default:
        }
    };
})(LN.App, LN.View, LN.Handler, LN.Service, LN.Controller, LN.Config, LN.Helper, LN.Message, LN.Model, LN.Analytics, jQuery);

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _registracionlibs = __webpack_require__(173);

var _registracionlibs2 = _interopRequireDefault(_registracionlibs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  if (!LN.Core || !LN.Config) throw new Error("LN.Core || LN.Config missing");
})();

(function (View, Helper, Service, Model, Config, Controller, Hotjar, SWG) {
  'use strict';

  View.wall = function (error) {
    Service.campanaObtener(Config.campaniaPaga, function (res, status, xhr) {
      Helper.callView('WALL', {
        Error: error
      }, function () {
        Helper.eventosInicio();
        Helper.eventosInicioMuroNuevo();
        Helper.eventosInicioWall();
        Helper.trackPaywallView();
        _registracionlibs2.default.init();
        GoogleSubscribe.start(function () {
          Helper.BtnGoogle();
        });
        LN.Wcentrix && LN.Wcentrix.initChat();
        Hotjar.callTrigger(Config.HotjarHeatmapWall);
      });
    });
  };

  View.wallSuscribime = function (error) {
    Service.campanaObtener(Config.campaniaPaga, function (res, status, xhr) {
      console.log('call-wsusc');
      Helper.callView('WALL_SUSCRIBIME', {
        Error: error
      }, function () {
        Helper.eventosInicio();
        Helper.eventosInicioMuroNuevo();
        Helper.eventosInicioSuscribirme();
        _registracionlibs2.default.init();
        GoogleSubscribe.start(function () {
          Helper.BtnGoogle();
        });
        LN.Wcentrix && LN.Wcentrix.initChat();
      });
    });
  };

  View.wallDinamico = function (error) {
    console.log('/landings/' + Model.Window.landingUrl);
    Service.landingObtener(Model.Window.landingUrl, function (res, status, xhr) {
      Helper.callView('WALL_DINAMICO', {
        Error: error
      }, function () {
        Helper.eventosInicio();
        Helper.setIframeHeight();
        Helper.eventosInicioSuscribirme();
        LN.Wcentrix && LN.Wcentrix.initChat();
      });
    });
  };

  View.procesarPago = function (error) {
    Helper.callView('PROCESAR_PAGO', {
      Error: error
    }, function () {});
  };

  View.pdfSuscriptoSinAcceso = function (error) {
    Service.campanaObtener(Config.campaniaPaga, function (res, status, xhr) {
      Helper.callView('PDF_SUSCRIPTO_SIN_ACCESO', {
        Error: error
      }, function () {
        //        Helper.eventosInicio();
      });
    });
  };

  View.pdfSinSuscripcion = function (error) {
    Service.campanaObtener(Config.campaniaPaga, function (res, status, xhr) {
      Helper.callView('PDF_SIN_SUSCRIPCION', {
        Error: error
      }, function () {
        Helper.eventosInicio();
        Helper.eventosInicioMuroNuevo();
      });
    });
  };

  View.ingresarDni = function (error) {
    Helper.callView('INGRESAR_DNI', {
      Error: error
    }, function () {
      //Model.Window.lastFlow = "";                 // Limpio el ultimo flow ejecutado
      //Helper.eventosInicioIngresarDNI();
      //Helper.carrito();
      //Hotjar.callTrigger(Config.HotjarHeatmapFormDocumento);
    });
  };

  View.formularioDatosPersonales = function (error) {
    Helper.callView('FORMULARIO_DATOS_PERSONALES', {
      Error: error
    }, function () {
      Model.Window.lastFlow = "";
      Helper.eventosInputIngresarDocumento('datos_personales[numeroDocumento]');
      Helper.eventosDatosPersonales();
      Helper.carrito();
      Hotjar.callTrigger(Config.HotjarHeatmapFormPersonales);
    });
  };

  View.formularioPosdatado = function (error, cb) {
    Helper.callView('FORMULARIO_ENVIO', { Error: error }, function () {
      Hotjar.callTrigger(Config.HotjarHeatmapFormDomicilio);
      cb && cb();
    });
  };

  View.formularioEnvio = function () {
    /*Ya tengo los datos de dom cargados del paso anterior*/
    Controller.obtenerDatosPersonalesFormularioEnvio();
  };

  View.formularioPago = function (error, hideForm) {
    Helper.callView('FORMULARIO_PAGO', {
      Error: error,
      Pago: Model.Venta.Pago,
      HideForm: hideForm
    }, function () {
      Helper.eventosPago();
      Helper.setIframeHeight();
      Helper.carrito();
      Hotjar.callTrigger(Config.HotjarHeatmapFormPago);
    }, true);
  };

  View.confirmacionCombo1 = function (error) {
    Helper.callView('CONFIRMACION_COMBO_1', {
      Error: error
    }, function () {
      LN.AppEvent.sendEvent('FLOW_OK');
      //
    });
  };

  View.confirmacionCombo2 = function (error) {
    Helper.callView('CONFIRMACION_COMBO_2', {
      Error: error
    }, function () {
      LN.AppEvent.sendEvent('FLOW_OK');
      //
    });
  };

  View.faltaDePago = function (error) {
    Helper.callView('FALTA_DE_PAGO', {
      Error: error
    }, function () {
      //
    });
  };

  View.yaTieneCuenta = function (error) {
    Helper.callView('YA_TIENE_CUENTA', {
      Error: error
    }, function () {
      /* hardcoding de prueba*/
      /*const FacebookIA = new Promise(Controller.FbInstantArticlesVentaPromise);
      FacebookIA.then(() => {
          if (Model.Embed.Article === true && Model.Embed.Name === "FacebookInstantArticles") {
              Helper.resetImg('externalPaywallToken', Model.ExternalPaywall.AutorizationToken, () => {
                  console.log('resolve externalPaywallToken');
              })
          }
      })*/
      LN.AppEvent.sendEvent('FLOW_OK');
      LN.AppEvent.sendEvent('VENTA-OK');
      $("body").addClass("custom-bg-mobile"); // Agrego class para que levanta el background-image
    }, true);
  };

  View.primerAcceso = function (error) {
    Helper.callView('PRIMER_ACCESO', {
      Error: error
    }, function () {

      LN.AppEvent.sendEvent('FLOW_OK');
      LN.AppEvent.sendEvent('VENTA-OK');
      Model.Window.lastFlow = ""; // Limpio el ultimo flow ejecutado
      $("body").addClass("custom-bg-mobile"); // Agrego class para que levanta el background-image
    }, true);
  };

  View.planInsuficiente = function (error) {
    Service.campanaObtener(Config.campaniaPaga, function (res, status, xhr) {
      Helper.callView('PLAN_INSUFICIENTE', {
        Error: error,
        ClubNacion: Model.Me.Usuario.ClubNacion || Helper.readCookie('usuarioDetalleClubNacion')
      }, function () {
        Model.Window.lastFlow = ""; // Limpio el ultimo flow ejecutado
        Helper.eventosInicio();
        Helper.eventosInicioMuroNuevo();
        _registracionlibs2.default.init();
        GoogleSubscribe.start(function () {
          Helper.BtnGoogle();
        });
        LN.AppEvent.sendEvent('PLAN-INSUFICENTE');
      });
    });
  };

  View.tieneDeuda = function (error) {
    Helper.callView('TIENE_DEUDA', {
      Error: error
    }, function () {
      Model.Window.lastFlow = ""; // Limpio el ultimo flow ejecutado
      LN.AppEvent.sendEvent('TIENE_DEUDA');
    });
  };

  View.domicilioNoExiste = function (error) {
    Helper.callView('DOMICILIO_NO_EXISTE', {
      Error: error
    }, function () {
      //
    });
  };

  View.yaCompro = function () {
    Helper.callView('YA_COMPRO', null, function () {
      LN.AppEvent.sendEvent('FLOW_OK');
      LN.AppEvent.sendEvent('VENTA-OK');
      Model.Window.lastFlow = ""; // Limpio el ultimo flow ejecutado
    });
  };

  View.noTieneSuscripcion = function () {
    Service.campanaObtener(Config.campaniaPaga, function (res, status, xhr) {
      Helper.callView('NO_TIENE_SUSCRIPCION', null, function () {
        Helper.eventosInicio();
        Helper.eventosInicioMuroNuevo();
        Helper.trackPaywallView();
        _registracionlibs2.default.init();
        GoogleSubscribe.start(function () {
          Helper.BtnGoogle();
        });
        LN.Wcentrix && LN.Wcentrix.initChat();
        Hotjar.callTrigger(Config.HotjarHeatmapWall);
      });
    });
  };

  View.landing = function () {
    Service.campanaObtener(Config.campaniaPaga, function (res, status, xhr) {
      Helper.callView('LANDING', null, function () {
        Helper.eventosLanding();
        Helper.eventosInicio();
      });
    });
  };

  View.validarPin = function (error, cb) {
    Helper.callView('VALIDAR_PINES', {
      Error: error
    }, function () {
      LN.Wcentrix && LN.Wcentrix.initChat();
      // do something
      cb && cb();
    }, true);
  };

  View.validarPinGracias = function (error) {
    Helper.callView('VALIDAR_PINES_GRACIAS', {
      Error: error
    }, function () {
      // do something
    });
  };

  View.asociarTarjeta = function (error, tipoError, cb) {
    Helper.callView('ASOCIAR_TARJETA', {
      Code: Model.Usuario.TipoAsociarCredencial,
      Unico: Model.Usuario.Credenciales.length == 1,
      Error: error,
      TipoError: tipoError
    }, function () {
      Helper.asociarCredencialBindings();
      cb && cb();
    }, true);
  };

  View.mostrarMensajeTribuno = function (error) {
    Helper.callView('MOSTRAR_TRIBUNO', {
      Error: error
    }, function () {
      LN.AppEvent.sendEvent('PLAN-INSUFICENTE');
    });
  };

  View.mostrarMensajeUno = function (error) {
    Helper.callView('MOSTRAR_UNO', {
      Error: error
    }, function () {
      LN.AppEvent.sendEvent('PLAN-INSUFICENTE');
    });
  };

  View.yaTieneCuentaFacebook = function (error) {
    Helper.callView('YA_TIENE_FACEBOOK', {
      Error: error
    });
  };

  View.confirmacionBonificadoFacebook = function (error) {
    Helper.callView('CONFIRMACION_BONIFICADO_FACEBOOK', {
      Error: error
    });
  };
})(LN.View, LN.Helper, LN.Service, LN.Model, LN.Config, LN.Controller, LN.Hotjar, LN.SWG);

/***/ }),

/***/ 162:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(106);

var _core2 = _interopRequireDefault(_core);

var _config = __webpack_require__(42);

var _config2 = _interopRequireDefault(_config);

var _frameEvent = __webpack_require__(97);

var _frameEvent2 = _interopRequireDefault(_frameEvent);

var _config3 = __webpack_require__(105);

var _config4 = _interopRequireDefault(_config3);

var _smartlock = __webpack_require__(60);

var _smartlock2 = _interopRequireDefault(_smartlock);

var _localstorage = __webpack_require__(59);

var _localstorage2 = _interopRequireDefault(_localstorage);

var _customDimension = __webpack_require__(58);

var _customDimension2 = _interopRequireDefault(_customDimension);

var _analytics = __webpack_require__(103);

var _analytics2 = _interopRequireDefault(_analytics);

var _message = __webpack_require__(111);

var _message2 = _interopRequireDefault(_message);

var _router = __webpack_require__(113);

var _router2 = _interopRequireDefault(_router);

var _helper = __webpack_require__(107);

var _helper2 = _interopRequireDefault(_helper);

var _service = __webpack_require__(114);

var _service2 = _interopRequireDefault(_service);

var _iframe = __webpack_require__(109);

var _iframe2 = _interopRequireDefault(_iframe);

var _model = __webpack_require__(112);

var _model2 = _interopRequireDefault(_model);

var _appEvent = __webpack_require__(104);

var _appEvent2 = _interopRequireDefault(_appEvent);

var _hotjar = __webpack_require__(108);

var _hotjar2 = _interopRequireDefault(_hotjar);

var _wcentrix = __webpack_require__(61);

var _wcentrix2 = _interopRequireDefault(_wcentrix);

var _logger = __webpack_require__(110);

var _logger2 = _interopRequireDefault(_logger);

var _validation = __webpack_require__(115);

var _validation2 = _interopRequireDefault(_validation);

var _credencialHandler = __webpack_require__(116);

var _credencialHandler2 = _interopRequireDefault(_credencialHandler);

var _flowHandler = __webpack_require__(117);

var _flowHandler2 = _interopRequireDefault(_flowHandler);

var _paywallHandler = __webpack_require__(118);

var _paywallHandler2 = _interopRequireDefault(_paywallHandler);

var _stepHandler = __webpack_require__(119);

var _stepHandler2 = _interopRequireDefault(_stepHandler);

var _credencialController = __webpack_require__(100);

var _credencialController2 = _interopRequireDefault(_credencialController);

var _flowController = __webpack_require__(101);

var _flowController2 = _interopRequireDefault(_flowController);

var _paywallController = __webpack_require__(102);

var _paywallController2 = _interopRequireDefault(_paywallController);

var _fbInstantArticlesController = __webpack_require__(240);

var _fbInstantArticlesController2 = _interopRequireDefault(_fbInstantArticlesController);

var _swgController = __webpack_require__(241);

var _swgController2 = _interopRequireDefault(_swgController);

var _paywallView = __webpack_require__(120);

var _paywallView2 = _interopRequireDefault(_paywallView);

var _partials = __webpack_require__(242);

var _partials2 = _interopRequireDefault(_partials);

var _app = __webpack_require__(99);

var _app2 = _interopRequireDefault(_app);

var _jquery = __webpack_require__(63);

var _jquery2 = _interopRequireDefault(_jquery);

var _jquery3 = __webpack_require__(62);

var _jquery4 = _interopRequireDefault(_jquery3);

__webpack_require__(69);

__webpack_require__(71);

__webpack_require__(162);

__webpack_require__(509);

__webpack_require__(510);

__webpack_require__(507);

__webpack_require__(70);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    if (!LN.Core || !LN.Model) throw new Error("LN.Core || LN.Model missing");
})();

(function (Controller, Model, Service, Helper) {
    'use strict';

    Controller.FbInstantArticlesVentaPromise = function (resolve, reject) {
        if (Model.IsInstantArticles()) {
            Service.ventaFacebook({
                "cd": {
                    "value": Model.PlanElegido.precio,
                    "currency": "ARS"
                }
            }, function (obj) {
                if (obj.code === "0000") {
                    Model.ExternalPaywall.AutorizationToken = obj.response;
                    resolve("OK");
                } else {
                    reject("Not OK");
                }
            });
        } else {
            resolve("Not OK");
        }
    };

    Controller.FbInstantArticlesYaTengoPromise = function (resolve, reject) {
        var closeWindow = function closeWindow() {
            window.open('', '_self').close();
        };
        if (Model.IsInstantArticles()) {
            Service.ventaFacebookYaTenia({
                "cd": {
                    "is_subscriber": "true"
                }
            }, function (obj) {
                if (obj.code === "0000") {
                    Model.ExternalPaywall.AutorizationToken = obj.response;
                    Helper.resetImg('externalPaywallToken', Model.ExternalPaywall.AutorizationToken, function () {
                        console.log('resolve externalPaywallToken');
                        resolve(closeWindow);
                    });
                } else {
                    reject("Not OK");
                }
            });
        } else {
            resolve("Not OK");
        }
    };
})(LN.Controller, LN.Model, LN.Service, LN.Helper);

/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  if (!LN.Core || !LN.Config) throw new Error("LN.Core || LN.Config missing");
})();

(function (SWG) {

  SWG.ctor = function (subscriptions) {
    this.subscriptions = subscriptions;
    this.subscriptions.init('lanacion.com.ar:acceso_digital');
    this.subscriptions.setOnSubscribeResponse(this.subscribeResponse_.bind(this));

    this.subscriptions.setOnEntitlementsResponse(function () {
      console.log('setOnEntitlementsResponse Event');
    });
    this.subscriptions.setOnLoginRequest(function () {
      console.log('setOnLoginRequest Event');
    });
    this.subscriptions.setOnLinkComplete(function () {
      console.log('setOnLinkComplete Event');
    });

    this.entitlements = null;
  };

  SWG.start = function (callback) {
    (window.SWG = window.SWG || []).push(function (subscriptions) {
      SWG.ctor(subscriptions);
      callback();
    });
  };

  SWG.drawButton = function (containerId, sku) {
    if (!this || !this.subscriptions) throw 'SWG is not initialized';
    var currentSubscriptions = this.subscriptions;
    document.getElementById(containerId).appendChild(currentSubscriptions.createButton(function () {
      currentSubscriptions.subscribe(sku);
    }));
  };

  SWG.subscribeResponse_ = function (promise) {
    promise.then(function (response) {
      // TODO: Start account creation flow.
      console.log('got subscription response', response);
      // TODO: wait for account creation to be complete.
      setTimeout(function () {
        response.complete().then(function () {
          console.log('subscription has been confirmed');
        }.bind(this));
      }.bind(this), 8000);
    }.bind(this), function (reason) {
      console.log('subscription response failed: ', reason);
      throw reason;
    });
  };

  SWG.setOnEntitlementsResponse = function (entitlementsPromise) {
    entitlementsPromise.then(function (entitlements) {

      if (!entitlements.enablesThis()) {
        return;
      }

      log('got entitlements: ', entitlements, entitlements.enablesThis());
      if (this.completeDeferredAccountCreation_(entitlements)) {
        return;
      }
      if (entitlements && entitlements.enablesThis()) {
        // Entitlements available: open access.
        this.openPaywall_();
        entitlements.ack();
      } else {
        // In a simplest case, just launch offers flow.
        this.subscriptions.showOffers();
      }
    }.bind(this), function (reason) {
      log('entitlements failed: ', reason);
      throw reason;
    });
  };
})(LN.SWG, LN.View, LN.Config, LN.Helper, LN.Service, LN.Handler, LN.Model, LN.Message, LN.Validation, LN.Analytics, LN.Hotjar, jQuery);

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var nav = __webpack_require__(527);
var navEmbed = __webpack_require__(528);
var logo = __webpack_require__(525);
var logoEmbed = __webpack_require__(526);
var preloader = __webpack_require__(530);
var contacto = __webpack_require__(517);
var dataFiscal = __webpack_require__(518);
var comboDigital = __webpack_require__(513);
var comboDigitalCredencial = __webpack_require__(514);
var comboNYT = __webpack_require__(515);
var comboTengoClub = __webpack_require__(516);
var headerLimiteNotas = __webpack_require__(519);
var headerSuscribite = __webpack_require__(524);
var headerPlanInsuficiente = __webpack_require__(521);
var headerSinSuscripcion = __webpack_require__(523);
var headerSinAccesoPDF = __webpack_require__(522);
var headerPDFSinSuscripcion = __webpack_require__(520);
var footerPreguntasFrecuentes = __webpack_require__(529);
var suscripcionDiario = __webpack_require__(531);
var actualizarSuscripcion = __webpack_require__(512);

(function () {
    if (!LN.Core || !LN.Config) throw new Error("LN.Core || LN.Config missing");
})();

(function (Handlebars) {
    'use strict';

    //todos los encodings
    //http://www.thesauruslex.com/typo/eng/enghtml.htm

    Handlebars.registerPartial('Wall.Nav', nav);

    Handlebars.registerPartial('Wall.Nav.Embed', navEmbed);

    Handlebars.registerPartial('Header.Logo', logo);

    Handlebars.registerPartial('Header.Logo.Embed', logoEmbed);

    Handlebars.registerPartial('Preloader', preloader);

    Handlebars.registerPartial('Wall.Contacto', contacto);

    Handlebars.registerPartial('Wall.DataFiscal', dataFiscal);

    Handlebars.registerPartial('Wall.Combo.AccesoDigital', comboDigital);

    Handlebars.registerPartial('Wall.Combo.AccesoDigitalCredencial', comboDigitalCredencial);

    Handlebars.registerPartial('Wall.Combo.NYT', comboNYT);

    Handlebars.registerPartial('Wall.Combo.TengoClub', comboTengoClub);

    Handlebars.registerPartial('Wall.Header.LimiteNotas', headerLimiteNotas);

    Handlebars.registerPartial('Wall.Header.Suscribite', headerSuscribite);

    Handlebars.registerPartial('Wall.Header.PlanInsuficiente', headerPlanInsuficiente);

    Handlebars.registerPartial('Wall.Header.SinSuscripcion', headerSinSuscripcion);

    Handlebars.registerPartial('Wall.Header.SinAccesoPDF', headerSinAccesoPDF);

    Handlebars.registerPartial('Wall.Header.PDFSinSuscripcion', headerPDFSinSuscripcion);

    Handlebars.registerPartial('Wall.Footer.PreguntasFrecuentes', footerPreguntasFrecuentes);

    Handlebars.registerPartial('Wall.SuscripcionDiario', suscripcionDiario);

    Handlebars.registerPartial('Wall.ActualizarSuscripcion', actualizarSuscripcion);
})(Handlebars);

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (Config, Constantes) {

    Config.defaultSitioId = Constantes.defaultSitioId;
    Config.apiVersion = Constantes.apiVersion;
    Config.cookieExpirationTime = Constantes.TimeExpiration;
    Config.keyPressLimit = Constantes.keyPressLimit;
    Config.freezeTime = Constantes.freezeTime;
    Config.returnBackInterval = Constantes.returnBackInterval;
    Config.dominioCookie = Constantes.dominioCookie || 'localhost';

    Config.disableValidations = Constantes.disableValidations;
    Config.enableQuickView = Constantes.enableQuickView;
    Config.forceCreateNewAddress = Constantes.forceCreateNewAddress;
    Config.elmahLevel = Constantes.elmahLevel;

    // =================================================
    // Dominios
    // =================================================
    Config.apiLoginUrl = Constantes.Dominios.apiLogin;
    Config.apiPaywallUrl = Constantes.Dominios.apiPaywall;
    Config.urlStatic = Constantes.Dominios.static;
    Config.defaultRedirectUrl = Constantes.Dominios.lanacion;
    Config.urlImages = Constantes.Dominios.static + "/images";
    Config.dominioMiCuenta = Constantes.Dominios.micuenta;
    Config.dominioLaNacion = Constantes.Dominios.lanacion;
    Config.urlPassport = Constantes.Dominios.passport;
    Config.urlMiClub = Constantes.Dominios.miclub;
    Config.urlBucket = Constantes.Dominios.bucket + '/Club.LN/anexos/fotos/productos/';
    // =================================================
    // Api Keys
    // =================================================
    Config.wCentrixTime = Constantes.wCentrixTime;
    Config.idWcentrix = Constantes.idWcentrix;
    Config.hotjarId = Constantes.idHotjar;
    Config.fbId = Constantes.fbId;
    Config.gmId = Constantes.gmId;
    Config.gmRedirect = Constantes.gmRedirect;
    Config.rcId = Constantes.rcId;
    Config.gaId = Constantes.gaId;
    Config.gtmId = Constantes.gtmId;

    // ==================================================
    // Sitios Ids Asociar Tarjeta post-login
    // 6 - Club LN / 7 - Autogestión/MiClub
    // ==================================================  
    Config.SitiosAsociarCredencial = Object.values(Constantes.SitiosAsociarCredencial);

    // ==================================================
    // Sitios Ids Permitidos
    // 1 - webLN / 2 - webCLL / 3 - webOH / 4 - appLN / 6 - Club LN / 7 - Autogestión/MiClub / 8 - Experiencias Black
    // ==================================================
    Config.Sitios = Constantes.Sitios;

    // ==================================================
    // Dominios permitidos a redireccionar
    // ==================================================  
    Config.dominiosPermitidos = RegExp(Constantes.dominiosPermitidos);

    // ========================================================
    // Diccionario de keys de usuario para grabar en cookies
    // ========================================================
    Config.DiccionarioCookiesAGuardar = Object.values(Constantes.DiccionarioCookiesAGuardar);
})(LN.Config, window.config.Constantes);

/***/ }),

/***/ 507:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 509:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 510:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(9);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"caja-pdf\">\r\n    <h4> <strong>Para acceder tendrás que actualizar tu suscripción.</strong> </h4>\r\n    <hr>\r\n    <p>\r\n        Para cambiarla comunicate al: <strong>(011) 5199-4787</strong> <br>\r\n        O desde el exterior a:  <br>\r\n        <a href=\"mailto:accesodigital@lanacion.com.ar\">accesodigital@lanacion.com.ar</a>\r\n    </p>\r\n</div>";
},"useData":true});

/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(9);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, options, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3=container.escapeExpression, alias4="function", buffer = 
  "<article class=\"combo acc-digital\">\r\n    <header>\r\n        <ul class=\"items-mas\">\r\n            <li>\r\n                <span></span>\r\n                Acceso Digital\r\n            </li>\r\n        </ul>\r\n    </header>\r\n    <div class=\"combos__precio\">\r\n        <span>$</span>\r\n        "
    + ((stack1 = (helpers.ceil || (depth0 && depth0.ceil) || alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? depth0.planes : depth0)) != null ? stack1["0"] : stack1)) != null ? stack1.precio : stack1),{"name":"ceil","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\r\n        <span>/mes</span>\r\n    </div>\r\n    <p class=\"combos__descrip\">\r\n        POR "
    + alias3(container.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.planes : depth0)) != null ? stack1["0"] : stack1)) != null ? stack1.mesesDescuento : stack1), depth0))
    + " "
    + ((stack1 = (helpers["get-label-for-month"] || (depth0 && depth0["get-label-for-month"]) || alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? depth0.planes : depth0)) != null ? stack1["0"] : stack1)) != null ? stack1.mesesDescuento : stack1),{"name":"get-label-for-month","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "<br>\r\n        LUEGO $ "
    + ((stack1 = (helpers.ceil || (depth0 && depth0.ceil) || alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? depth0.planes : depth0)) != null ? stack1["0"] : stack1)) != null ? stack1.precioSinDescuento : stack1),{"name":"ceil","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\r\n    </p>\r\n    <button class=\"next-button btn-principal\" type=\"button\" data-step=\"combo_procesar\" data-combo=\""
    + alias3(((helper = (helper = helpers.combo || (depth0 != null ? depth0.combo : depth0)) != null ? helper : alias2),(typeof helper === alias4 ? helper.call(alias1,{"name":"combo","hash":{},"data":data}) : helper)))
    + "\" data-source=\"wall\">Suscribite</button>\r\n";
  stack1 = ((helper = (helper = helpers.ContextEmbedHide || (depth0 != null ? depth0.ContextEmbedHide : depth0)) != null ? helper : alias2),(options={"name":"ContextEmbedHide","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data}),(typeof helper === alias4 ? helper.call(alias1,options) : helper));
  if (!helpers.ContextEmbedHide) { stack1 = helpers.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + "    <div class=\"combo__detalles\">\r\n        <p class=\"combo__detalles__button ver-mas\">Mostrar detalles</p>\r\n        <ul>\r\n            <li class=\"icon-icons8-checkmark-filled\">Acceso <b>ilimitado</b> a <nobr>LA NACION</nobr> y Revistas digitales</li>\r\n        </ul>\r\n    </div>\r\n</article>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "";
},"4":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? depth0.planes : depth0)) != null ? stack1["0"] : stack1)) != null ? stack1.swgSKU : stack1),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.program(8, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "");
},"5":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "    <div class=\"googlepay "
    + ((stack1 = helpers.unless.call(alias1,((stack1 = (depths[1] != null ? depths[1].Constantes : depths[1])) != null ? stack1.MostrarBotonSWG : stack1),{"name":"unless","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" data-sku=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.planes : depth0)) != null ? stack1["0"] : stack1)) != null ? stack1.swgSKU : stack1), depth0))
    + "\"></div>\r\n"
    + ((stack1 = helpers.unless.call(alias1,((stack1 = (depths[1] != null ? depths[1].Constantes : depths[1])) != null ? stack1.MostrarBotonSWG : stack1),{"name":"unless","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\r\n";
},"6":function(container,depth0,helpers,partials,data) {
    return "hideswg";
},"8":function(container,depth0,helpers,partials,data) {
    return "    <div class=\"combo__img\"></div>\r\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = (helpers["get-plan-by-combo"] || (depth0 && depth0["get-plan-by-combo"]) || helpers.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? depth0.Config : depth0)) != null ? stack1.COMBO_ACCESO_DIGITAL : stack1),{"name":"get-plan-by-combo","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"useData":true,"useDepths":true});

/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(9);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3=container.escapeExpression;

  return "    <article class=\"combo  acc-con-club\">\r\n        <header>\r\n            <ul class=\"items-mas\">\r\n                <li>\r\n                    <span></span>\r\n                    Acceso Digital\r\n                </li>\r\n                <li>\r\n                    <span></span>\r\n                    Club LA NACION\r\n                </li>\r\n            </ul>\r\n        </header>\r\n        <div class=\"combos__precio\">\r\n            <span>$</span>\r\n            "
    + ((stack1 = (helpers.ceil || (depth0 && depth0.ceil) || alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? depth0.planes : depth0)) != null ? stack1["0"] : stack1)) != null ? stack1.precio : stack1),{"name":"ceil","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\r\n            <span>/mes</span>\r\n        </div>\r\n        <p class=\"combos__descrip\">\r\n            POR "
    + alias3(container.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.planes : depth0)) != null ? stack1["0"] : stack1)) != null ? stack1.mesesDescuento : stack1), depth0))
    + " "
    + ((stack1 = (helpers["get-label-for-month"] || (depth0 && depth0["get-label-for-month"]) || alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? depth0.planes : depth0)) != null ? stack1["0"] : stack1)) != null ? stack1.mesesDescuento : stack1),{"name":"get-label-for-month","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " <br>\r\n            LUEGO $"
    + ((stack1 = (helpers.ceil || (depth0 && depth0.ceil) || alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? depth0.planes : depth0)) != null ? stack1["0"] : stack1)) != null ? stack1.precioSinDescuento : stack1),{"name":"ceil","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\r\n        </p>\r\n        <button class=\"next-button btn-principal\" type=\"button\" data-step=\"combo_procesar\" data-combo=\""
    + alias3(((helper = (helper = helpers.combo || (depth0 != null ? depth0.combo : depth0)) != null ? helper : alias2),(typeof helper === "function" ? helper.call(alias1,{"name":"combo","hash":{},"data":data}) : helper)))
    + "\" data-source=\"wall\">Suscribite</button>\r\n        <div class=\"combo__img\"></div>\r\n        <div class=\"combo__detalles\">\r\n            <p class=\"combo__detalles__button ver-mas\">Mostrar detalles</p>\r\n            <ul>\r\n                <li class=\"icon-icons8-checkmark-filled\">Acceso <b>ilimitado</b> a <nobr>LA NACION</nobr> y Revistas digitales</li>\r\n                <li class=\"icon-icons8-checkmark-filled\">Beneficios <b>Club LA NACION Premium</b> </li>\r\n                <li class=\"icon-icons8-checkmark-filled\">Acceso a edición impresa en pdf </li>\r\n                <li class=\"icon-icons8-checkmark-filled\">Sin publicidad emergente </li>\r\n            </ul>\r\n        </div>\r\n    </article>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = (helpers["get-plan-by-combo"] || (depth0 && depth0["get-plan-by-combo"]) || helpers.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? depth0.Config : depth0)) != null ? stack1.COMBO_ACCESO_DIGITAL_CREDENCIAL : stack1),{"name":"get-plan-by-combo","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"useData":true});

/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(9);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3=container.escapeExpression;

  return "    <article class=\"combo acc-nyt\">\r\n        <header>\r\n            <ul class=\"items-mas\">\r\n                <li>\r\n                    <span></span>\r\n                    Acceso Digital\r\n                </li>\r\n                <li>\r\n                    <span></span>\r\n                    Club LA NACION\r\n                </li>\r\n                <li>\r\n                    <span></span>\r\n                    The New York Times\r\n                </li>\r\n            </ul>\r\n        </header>\r\n        <div class=\"combos__precio\">\r\n            <span>$</span>\r\n            "
    + ((stack1 = (helpers.ceil || (depth0 && depth0.ceil) || alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? depth0.planes : depth0)) != null ? stack1["0"] : stack1)) != null ? stack1.precio : stack1),{"name":"ceil","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\r\n            <span>/mes</span>\r\n        </div>\r\n        <p class=\"combos__descrip\">\r\n            POR "
    + alias3(container.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.planes : depth0)) != null ? stack1["0"] : stack1)) != null ? stack1.mesesDescuento : stack1), depth0))
    + " "
    + ((stack1 = (helpers["get-label-for-month"] || (depth0 && depth0["get-label-for-month"]) || alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? depth0.planes : depth0)) != null ? stack1["0"] : stack1)) != null ? stack1.mesesDescuento : stack1),{"name":"get-label-for-month","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " <br>\r\n            LUEGO $"
    + ((stack1 = (helpers.ceil || (depth0 && depth0.ceil) || alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? depth0.planes : depth0)) != null ? stack1["0"] : stack1)) != null ? stack1.precioSinDescuento : stack1),{"name":"ceil","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\r\n        </p>\r\n        <button class=\"next-button btn-principal\" type=\"button\" data-step=\"combo_procesar\" data-combo=\""
    + alias3(((helper = (helper = helpers.combo || (depth0 != null ? depth0.combo : depth0)) != null ? helper : alias2),(typeof helper === "function" ? helper.call(alias1,{"name":"combo","hash":{},"data":data}) : helper)))
    + "\" data-source=\"wall\">Suscribite</button>\r\n        <div class=\"combo__img\"></div>\r\n        <div class=\"combo__detalles\">\r\n            <p class=\"combo__detalles__button ver-mas\">Mostrar detalles</p>\r\n            <ul>\r\n                <li class=\"icon-icons8-checkmark-filled\">Acceso <b>ilimitado</b> a <nobr>LA NACION</nobr> y Revistas digitales</li>\r\n                <li class=\"icon-icons8-checkmark-filled\">Beneficios <b>Club LA NACION Premium</b> </li>\r\n                <li class=\"icon-icons8-checkmark-filled\">Acceso a edición impresa en pdf </li>\r\n                <li class=\"icon-icons8-checkmark-filled\">Sin publicidad emergente </li>\r\n                <li class=\"icon-icons8-checkmark-filled\">Acceso Digital a <b>The New York Times</b></li>\r\n            </ul>\r\n        </div>\r\n    </article>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = (helpers["get-plan-by-combo"] || (depth0 && depth0["get-plan-by-combo"]) || helpers.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? depth0.Config : depth0)) != null ? stack1.COMBO_NYT : stack1),{"name":"get-plan-by-combo","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"useData":true});

/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(9);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<article class=\"combo tengo-club\">\r\n    <header>\r\n        <h4>\r\n            ¿Tenés Club LA NACION\r\n            Black o Premium?\r\n        </h4>\r\n        <hr>\r\n        <p>No hace falta que compres</p>\r\n    </header>\r\n    <p class=\"tengo-club__descrip\">\r\n        Ingresá los datos de tu tarjeta y continuá\r\n        <strong>Sin cargo</strong>\r\n    </p>\r\n    <button class=\"next-button\" type=\"button\" data-step=\"combo_procesar\" data-combo=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.Config : depth0)) != null ? stack1.COMBO_BONIFICADO : stack1), depth0))
    + "\" data-source=\"wall\">Tengo Club</button>\r\n    <div class=\"combo__img\"></div>\r\n</article>";
},"useData":true});

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(9);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"contacto\">\r\n    <h6>\r\n        Atenci&oacute;n al cliente: desde la Argentina: <strong>5199-4787</strong> | Desde el exterior <a href=\"mailto:accesodigital@lanacion.com.ar\">accesodigital@lanacion.com.ar</a>\r\n    </h6>\r\n    <hr class=\"separador-gris\">\r\n</div>";
},"useData":true});

/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(9);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"data-fiscal\">\r\n    <hr class=\"separador-gris\">\r\n    <a href=\"http://qr.afip.gob.ar/?qr=HJMakbCpenWNdXYfqXtEDQ,,\" target=\"_F960AFIPInfo\">\r\n    </a>\r\n</div>";
},"useData":true});

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(9);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"titulo\">\r\n    <h2> <strong>Llegaste al límite de notas sin cargo.</strong> Suscribite para seguir leyendo. </h2>\r\n    <p class=\"titulo__bajada\">Valorás el periodismo confiable. Te queremos en LA NACION.</p>\r\n</div>";
},"useData":true});

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(9);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"titulo insuficiente\">\r\n    <h2> <strong>Tu cuenta no tiene Acceso Digital.</strong>Suscribite y accedé a la edición impresa en PDF.</h2>\r\n</div>  ";
},"useData":true});

/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(9);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"titulo insuficiente\">\r\n    <h2> <strong>Tu tarjeta no es Black o Premium titular.</strong> Suscribite para tener Acceso Digital. </h2>\r\n</div>   ";
},"useData":true});

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(9);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"titulo insuficiente\">\r\n    <h2> <strong>Tu cuenta no tiene acceso a la edición impresa en PDF.</strong></h2>\r\n</div>";
},"useData":true});

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(9);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"titulo insuficiente\">\r\n    <h2> <strong>Tu cuenta no tiene Acceso Digital.</strong>Suscribite y leé LA NACION sin límite de notas.</h2>\r\n</div>   ";
},"useData":true});

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(9);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"titulo\">\r\n    <h2> <strong>Suscribite al Acceso Digital.</strong> Leé LA NACION sin límite de notas. </h2>            \r\n</div>   ";
},"useData":true});

/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(9);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<a class=\"event-track nav__logo\" data-label=\"logo header\" href=\"http://www.lanacion.com.ar\">\r\n<svg class=\"nav__logo__desktop\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"718px\" height=\"77px\" viewBox=\"0 0 718 77\" enable-background=\"new 0 0 718 77\" xml:space=\"preserve\">\r\n<g>\r\n<path d=\"M65.001,49.539c0,16.418-12.178,20.676-27.445,20.676h-2.734V7.918h12.803V2.959H1.15v4.959h11.623v62.297H1.15v4.964\r\n                                h69.598V46.427h-5.746V49.539z\"></path>\r\n<path d=\"M125.537,3.069h-8.705L87.087,64.1c-1.721,3.392-4.396,6.115-9.939,6.115h-2.351v4.964h27.898v-4.964H97.65\r\n                                c-2.926,0-5.469-0.372-5.469-3.757c0-1.146,0.598-2.252,1.025-3.078l3.98-8.318h30.166l7.572,15.153h-11.139v4.964h45.971v-4.964\r\n                                h-9.664L125.537,3.069z M99.599,50.14l12.163-24.51h0.991l12.18,24.51H99.599z\"></path>\r\n<path d=\"M301.664,2.959h-28.69v4.959h3.466c5.786,0,8.93,1.896,8.93,5.83v31.88h-0.266L248.087,2.959h-33.571v4.959h1.982\r\n                                c4.362,0,8.819,3.177,8.819,8.075v46.852c0,6.247-3.797,7.37-7.838,7.37h-1.445h-1.921v4.964h28.634v-4.964h-2.246\r\n                                c-7.264,0-10.153-0.991-10.153-6.835V17.021h0.263l50.272,58.158h9.585V13.43c0-2.574,2.439-5.512,8.377-5.512h2.818V2.959z\"></path>\r\n\r\n<path d=\"M351.055,3.069h-8.732L312.548,64.1c-1.684,3.392-4.377,6.115-9.937,6.115h-2.36v4.964h27.988v-4.964h-5.146\r\n                                c-2.899,0-5.433-0.372-5.433-3.757c0-1.146,0.609-2.252,1.008-3.078l4.005-8.318h30.209l7.507,15.153h-11.137v4.964h45.954v-4.964\r\n                                h-9.646L351.055,3.069z M325.123,50.14l12.114-24.51h1.04l12.125,24.51H325.123z\"></path>\r\n\r\n<path d=\"M439.029,71.773c-17.453,0-20.705-15.069-20.705-32.594c0-18.248,3.611-33.132,21.137-33.132\r\n                                c14.004,0,19.795,12.213,21.924,22.639h5.701V3.069h-3.787c-0.117,2.191-0.748,4.151-3.625,4.151c-2.824,0-8.229-6.1-23.582-6.1\r\n                                c-20.635,0-41.961,17.326-41.961,38.059c0,21.049,22.047,37.82,43.729,37.82c16.932,0,30.016-9.829,30.016-27.461h-6.002\r\n                                C461.873,62.377,452.666,71.773,439.029,71.773z\"></path>\r\n\r\n<polygon points=\"478.668,7.918 490.299,7.918 490.299,70.215 478.668,70.215 478.668,75.179 523.994,75.179 523.994,70.215\r\n                                512.311,70.215 512.311,7.918 523.994,7.918 523.994,2.959 478.668,2.959 	\"></polygon>\r\n\r\n<path d=\"M576.51,1.121c-21.391,0-43.041,16.622-43.041,37.949c0,21.344,21.65,37.93,43.041,37.93\r\n                                c21.273,0,43.301-16.586,43.301-37.93C619.811,17.743,597.783,1.121,576.51,1.121z M576.611,72.093\r\n                                c-16.943,0-19.162-16.312-19.162-33.022c0-16.804,2.293-33.022,19.162-33.022c17.004,0,19.193,16.087,19.193,33.022\r\n                                C595.805,55.891,593.615,72.093,576.611,72.093z\"></path>\r\n\r\n<path d=\"M685.438,2.959v4.959h3.512c5.76,0,8.898,1.896,8.898,5.83v31.88h-0.33L660.529,2.959h-33.568v4.959h1.986\r\n                                c4.385,0,8.859,3.177,8.859,8.075v46.852c0,6.247-3.795,7.37-7.816,7.37h-1.428h-1.957v4.964h28.592v-4.964h-2.254\r\n                                c-7.316,0-10.15-0.991-10.15-6.835V17.021h0.238l50.281,58.158h9.588V13.43c0-2.574,2.508-5.512,8.404-5.512h2.846V2.959H685.438z\"></path>\r\n\r\n</g>\r\n</svg>\r\n<svg class=\"nav__logo__mobile\" width=\"34\" height=\"33\" viewBox=\"0 0 34 33\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:figma=\"http://www.figma.com/figma/ns\"><title>Group</title><desc>Created using Figma</desc><g id=\"Canvas\" transform=\"translate(275 -714)\" figma:type=\"canvas\"><g id=\"Group\" style=\"mix-blend-mode:normal;\" figma:type=\"frame\"><g id=\"Group\" style=\"mix-blend-mode:normal;\" figma:type=\"frame\"><g id=\"Vector\" style=\"mix-blend-mode:normal;\" figma:type=\"vector\"><use xlink:href=\"#path0_fill\" transform=\"translate(-274.068 714)\" fill=\"#006998\" style=\"mix-blend-mode:normal;\"></use></g><g id=\"Vector\" style=\"mix-blend-mode:normal;\" figma:type=\"vector\"><use xlink:href=\"#path1_fill\" transform=\"translate(-267.623 725.617)\" fill=\"#FFFFFF\" style=\"mix-blend-mode:normal;\"></use></g></g></g></g><defs><path id=\"path0_fill\" d=\"M 16.5 33C 25.6094 33 33 25.5997 33 16.4785C 32.957 7.40026 25.5664 0 16.5 0C 7.39062 0 0 7.40026 0 16.5215C 0 25.5997 7.39062 33 16.5 33Z\"></path><path id=\"path1_fill\" d=\"M 20.4531 0.688397L 20.4531 0L 16.8438 0L 16.8438 0.688397L 17.1016 0.688397C 17.832 0.688397 18.2188 0.946545 18.2188 1.46284L 18.2188 5.76532L 18.3477 5.76532L 13.75 0L 9.53906 0L 9.53906 0.688397L 9.625 0.688397C 10.1836 0.688397 10.7422 1.11864 10.7422 1.76402L 10.7422 8.08866C 10.7422 8.94915 10.2695 9.07823 9.75391 9.07823L 9.49609 9.07823L 9.49609 9.7236L 13.1055 9.7236L 13.0625 9.0352L 12.9766 9.0352C 12.0742 9.0352 11.6875 8.90613 11.6875 8.13168L 11.6875 1.89309L 11.5586 1.89309L 17.875 9.7236L 19.25 9.7236L 19.25 1.41982C 19.25 1.07562 19.5508 0.688397 20.2812 0.688397L 20.4531 0.688397ZM 0 9.76662L 8.72266 9.76662L 8.72266 5.89439L 7.99219 5.89439L 7.99219 6.32464C 7.99219 8.5189 6.48828 9.12125 4.55469 9.12125L 4.21094 9.12125L 4.21094 0.688397L 5.80078 0.688397L 5.80078 0L 0 0L 0 0.688397L 1.46094 0.688397L 1.46094 9.07823L 0 9.07823L 0 9.76662Z\"></path></defs></svg>\r\n</a>";
},"useData":true});

/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(9);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<svg class=\"nav__logo__mobile\" width=\"34\" height=\"33\" viewBox=\"0 0 34 33\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:figma=\"http://www.figma.com/figma/ns\"><title>Group</title><desc>Created using Figma</desc><g id=\"Canvas\" transform=\"translate(275 -714)\" figma:type=\"canvas\"><g id=\"Group\" style=\"mix-blend-mode:normal;\" figma:type=\"frame\"><g id=\"Group\" style=\"mix-blend-mode:normal;\" figma:type=\"frame\"><g id=\"Vector\" style=\"mix-blend-mode:normal;\" figma:type=\"vector\"><use xlink:href=\"#path0_fill\" transform=\"translate(-274.068 714)\" fill=\"#006998\" style=\"mix-blend-mode:normal;\"></use></g><g id=\"Vector\" style=\"mix-blend-mode:normal;\" figma:type=\"vector\"><use xlink:href=\"#path1_fill\" transform=\"translate(-267.623 725.617)\" fill=\"#FFFFFF\" style=\"mix-blend-mode:normal;\"></use></g></g></g></g><defs><path id=\"path0_fill\" d=\"M 16.5 33C 25.6094 33 33 25.5997 33 16.4785C 32.957 7.40026 25.5664 0 16.5 0C 7.39062 0 0 7.40026 0 16.5215C 0 25.5997 7.39062 33 16.5 33Z\"></path><path id=\"path1_fill\" d=\"M 20.4531 0.688397L 20.4531 0L 16.8438 0L 16.8438 0.688397L 17.1016 0.688397C 17.832 0.688397 18.2188 0.946545 18.2188 1.46284L 18.2188 5.76532L 18.3477 5.76532L 13.75 0L 9.53906 0L 9.53906 0.688397L 9.625 0.688397C 10.1836 0.688397 10.7422 1.11864 10.7422 1.76402L 10.7422 8.08866C 10.7422 8.94915 10.2695 9.07823 9.75391 9.07823L 9.49609 9.07823L 9.49609 9.7236L 13.1055 9.7236L 13.0625 9.0352L 12.9766 9.0352C 12.0742 9.0352 11.6875 8.90613 11.6875 8.13168L 11.6875 1.89309L 11.5586 1.89309L 17.875 9.7236L 19.25 9.7236L 19.25 1.41982C 19.25 1.07562 19.5508 0.688397 20.2812 0.688397L 20.4531 0.688397ZM 0 9.76662L 8.72266 9.76662L 8.72266 5.89439L 7.99219 5.89439L 7.99219 6.32464C 7.99219 8.5189 6.48828 9.12125 4.55469 9.12125L 4.21094 9.12125L 4.21094 0.688397L 5.80078 0.688397L 5.80078 0L 0 0L 0 0.688397L 1.46094 0.688397L 1.46094 9.07823L 0 9.07823L 0 9.76662Z\"></path></defs></svg>";
},"useData":true});

/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(9);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, options, alias1=container.lambda, alias2=container.escapeExpression, buffer = 
  "     <p>\r\n         <a href=\""
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.Constantes : depth0)) != null ? stack1.Dominios : stack1)) != null ? stack1.micuenta : stack1), depth0))
    + "\">"
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.Model : depth0)) != null ? stack1.Usuario : stack1)) != null ? stack1.Email : stack1), depth0))
    + "</a>\r\n";
  stack1 = ((helper = (helper = helpers.NotProductPremium || (depth0 != null ? depth0.NotProductPremium : depth0)) != null ? helper : helpers.helperMissing),(options={"name":"NotProductPremium","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data}),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),options) : helper));
  if (!helpers.NotProductPremium) { stack1 = helpers.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + "         <a href=\"#\" class=\"next-button nav-login__cambiar\" data-step=\"logout\">Cambiar cuenta</a>\r\n     </p>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "         \r\n";
},"4":function(container,depth0,helpers,partials,data) {
    return "    <p>&iquest;Ya sos suscriptor digital? <a href=\"#\" class=\"next-button\" data-step=\"ya_tenes_suscripcion\">Ingres&aacute;</a></p>\r\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return " <div class=\"nav-login\">\r\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? depth0.Model : depth0)) != null ? stack1.Usuario : stack1)) != null ? stack1.UsuarioUsuario : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(4, data, 0),"data":data})) != null ? stack1 : "")
    + "</div>";
},"useData":true});

/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(9);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, options, buffer = 
  "    <p>\r\n        <span>"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.Model : depth0)) != null ? stack1.Usuario : stack1)) != null ? stack1.Email : stack1), depth0))
    + "</span>\r\n";
  stack1 = ((helper = (helper = helpers.NotProductPremium || (depth0 != null ? depth0.NotProductPremium : depth0)) != null ? helper : helpers.helperMissing),(options={"name":"NotProductPremium","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data}),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),options) : helper));
  if (!helpers.NotProductPremium) { stack1 = helpers.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + "    </p>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    return "    <p>&iquest;Ya sos suscriptor digital? <a href=\"#\" class=\"next-button\" data-step=\"ya_tenes_suscripcion\">Ingres&aacute;</a></p>\r\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return " <div class=\"nav-login\">\r\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? depth0.Model : depth0)) != null ? stack1.Usuario : stack1)) != null ? stack1.UsuarioUsuario : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(4, data, 0),"data":data})) != null ? stack1 : "")
    + "</div>";
},"useData":true});

/***/ }),

/***/ 529:
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(9);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"preg-frecuentes\">\r\n    <div class=\"preg-frecuentes__imgs\">\r\n        <div></div>\r\n    </div>\r\n    <div class=\"preg-frecuentes__descrip\">\r\n        <article>\r\n            <h4>¿Qué es el Acceso Digital?</h4>\r\n            <p>\r\n                Es la opción que te ofrece LA NACION para seguir informándote sin límites.\r\n                Tenés acceso a las revistas digitales: OHLALA!, ¡HOLA!, ROLLINGSTONE, LUGARES, LIVING, BRANDO, JARDIN.\r\n                Además, según la suscripción que elijas, podés tener tu tarjeta Club LA NACION, acceder a la edición impresa en formato PDF y navegar sin publicidad emergente.\r\n            </p>\r\n        </article>\r\n        <article>\r\n            <h4>¿Cómo funciona?</h4>\r\n            <p>\r\n                Sin suscripción podés leer hasta 15 notas de LA NACION o revistas en un rango de 30 días.\r\n                A partir de la nota 16 te pedimos que te suscribas para seguir leyendo de manera ilimitada. Para usar tu suscripción tenés que ingresar con tu cuenta de Acceso Digital.\r\n            </p>\r\n        </article>\r\n        <article>\r\n            <h4>¿Si no me suscribo, puedo seguir leyendo LA NACION?</h4>\r\n            <p>\r\n                Si. Podés seguir accediendo a la página principal de LA NACION, de las secciones y revistas, y a toda la información de servicios.\r\n            </p>\r\n        </article>\r\n        <article>\r\n            <h4>¿Cuáles son los medios de pago?</h4>\r\n            <p>\r\n                Podés pagar con tarjeta de crédito a través del débito automático, o con tarjeta de débito.\r\n            </p>\r\n        </article>\r\n        <article>\r\n            <p>¿Dudas? <a href=\"https://micuenta.lanacion.com.ar/ayuda\">Consultá las Preguntas Frecuentes</a></p>\r\n        </article>\r\n    </div>\r\n</div>";
},"useData":true});

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(9);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"preloader\" style=\"display: none;\">\r\n    <span class=\"preloader-gif\"></span>\r\n</div>";
},"useData":true});

/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(9);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"suscrip-diarios\">\r\n    <div class=\"suscrip-diarios__titulo\">\r\n        <hr>\r\n        <h3>O bien al diario y las revistas impresas</h3>\r\n        <hr>\r\n    </div>\r\n    <div class=\"suscrip-diarios__caja\">\r\n        <div class=\"suscrip-diarios__caja__img\"></div>\r\n        <h4><strong>SUSCRIBITE A DIARIOS Y REVISTAS.</strong> Recibí los productos en tu casa.</h4>        \r\n        <button class=\"btn-principal next-button\" type=\"button\" data-step=\"redirect\" data-url=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.Constantes : depth0)) != null ? stack1.Dominios : stack1)) != null ? stack1.miclub : stack1), depth0))
    + "\">Suscribite</button>\r\n    </div>\r\n</div>\r\n\r\n";
},"useData":true});

/***/ }),

/***/ 554:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(229);


/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


LN.CustomDimension = new function (LocalStorage) {
    var self = this;
    var key = 'CustomDimension';
    var objCustomDimension = {};
    this.get = function () {
        objCustomDimension = LocalStorage.getItem(key);
        return objCustomDimension;
    };

    this.clear = function () {
        objCustomDimension = {};
        LocalStorage.removeItem(key);
    };

    this.set = function (prop, value) {
        if (!objCustomDimension) objCustomDimension = {};
        objCustomDimension[prop] = value;
        return objCustomDimension;
    };

    this.save = function () {
        LocalStorage.setItem(key, objCustomDimension);
    };

    this.exist = function () {
        return this.get() !== null;
    };

    this.setSuscriptorType = function (value) {
        this.set('suscriptorType', value);
    };
    this.setRegistrado = function (value) {
        this.set('usuarioRegistrado', value);
    };
    this.setUserId = function (value) {
        this.set('userId', value);
    };
}(LN.LocalStorage);

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


LN.LocalStorage = new function (Config) {
    var self = this;

    self.removeItem = function (key) {
        localStorage.removeItem(key);
    };

    self.setExpiredItem = function (key, value) {
        var item = {
            'value': value,
            'expiration': new Date()
        };

        localStorage.setItem(key, JSON.stringify(item));
    };

    self.setItem = function (key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    };
    self.getItem = function (key) {
        return JSON.parse(localStorage.getItem(key));
    };

    self.renew = function (key) {
        var item = self.getItem(key);
        if (item.expiration) {
            item.expiration = new Date();

            localStorage.setItem(key, JSON.stringify(item));
        }
    };

    self.checkExpiration = function (key, expiration) {
        var item = self.getItem(key);
        if (item.expiration) {
            var itemexpiration = new Date(item.expiration);

            var lifetime = expiration || Config.StorageExpiration;

            if (new Date() - itemexpiration < lifetime) {
                return item;
            } else {
                return null;
            }
        }
        return null;
    };

    self.checkIfExists = function (key) {
        return localStorage.getItem(key) !== null;
    };
}(LN.Config);

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function SmartLock() {
    var self = this;
    var providers = {
        fb: 'https://www.facebook.com',
        gm: 'https://accounts.google.com'
    };
    this.savePassword = function (email, password, name, iconUrl) {
        if (navigator.credentials && email && existCredential('PasswordCredential')) {
            this.signOut();

            var cred = new PasswordCredential({
                id: email,
                password: password,
                name: name,
                iconURL: iconUrl
            });
            navigator.credentials.store(cred);
        }
    };

    this.saveGmail = function (id, name, iconUrl) {
        if (navigator.credentials && id && existCredential('FederatedCredential')) {
            this.signOut();
            var c = new FederatedCredential({
                id: id,
                name: name,
                provider: 'https://accounts.google.com',
                iconURL: iconUrl
            });
            navigator.credentials.store(c);
            return c;
        }
        return null;
    };
    this.saveFacebook = function (id, name, iconUrl) {
        if (navigator.credentials && id && existCredential('FederatedCredential')) {
            this.signOut();

            var cred = new FederatedCredential({
                id: id,
                name: name,
                provider: providers.fb,
                iconURL: iconUrl
            });
            navigator.credentials.store(cred);
            return cred;
        }
    };

    this.get = function (cb, password, optional) {
        if (navigator.credentials) {
            optional = optional || false;
            password = password || false;
            navigator.credentials.get({
                password: password,
                //unmediated: false,
                mediation: 'optional',
                federated: {
                    providers: [providers.gm, providers.fb]
                }

            }).then(function (cred) {
                processGet(cb, cred);
            });
        }
    };

    var processGet = function processGet(cb, cred) {
        var response = {
            credential: cred,
            type: null
        };
        if (cred) {
            switch (cred.type) {
                case 'password':
                    response.type = 'nativo';
                    break;
                case 'federated':
                    if (cred.provider == providers.fb) response.type = 'fb';else if (cred.provider == providers.gm) response.type = 'gm';
                    break;
            }
        }
        cb && cb(response);
    };

    this.signOut = function () {
        if (navigator.credentials) {
            navigator.credentials.preventSilentAccess();
        }
    };

    var existCredential = function existCredential(credential) {
        return typeof window[credential] == 'function';
    };
}

window.smartlock = new SmartLock();

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


LN.Wcentrix = new function (Config) {
    'use strict';

    this.initChat = function (page) {
        $(document).ready(function () {
            if (Config.idWcentrix) {
                setTimeout(function () {
                    var s;
                    if (window.innerWidth >= 767) {
                        console.log('initWc');
                        s = document.createElement("script");
                        s.src = "https://wcentrix.net/tabhelp/wctabs.aspx?id=" + Config.idWcentrix + "&" + new Date().getTime(), document.head.appendChild(s);
                    }
                }, Config.wCentrixTime);
            }
        });
    };
}(LN.Config);

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Autotab - jQuery plugin 1.9.2
 * https://github.com/Mathachew/jquery-autotab
 * 
 * Copyright (c) 2008, 2015 Matthew Miller
 * 
 * Licensed under the MIT licensing:
 *   http://www.opensource.org/licenses/mit-license.php
 */

(function ($) {
    var platform = navigator.platform,
        settings = {
        tabPause: 800,
        focusChange: null,
        iOS: platform === 'iPad' || platform === 'iPhone' || platform === 'iPod',
        firefox: typeof InstallTrigger !== 'undefined',
        ie11: !window.ActiveXObject && "ActiveXObject" in window
    };

    var setSettings = function setSettings(e, settings) {
        if (settings === null || typeof settings === 'undefined') {
            return;
        }

        for (var key in settings) {
            $(e).data('autotab-' + key, settings[key]);
        }
    };

    var getSettings = function getSettings(e) {
        var settings = {
            arrowKey: false,
            format: 'all',
            loaded: false,
            disabled: false,
            pattern: null,
            uppercase: false,
            lowercase: false,
            nospace: false,
            maxlength: 2147483647,
            target: null,
            previous: null,
            trigger: null,
            originalValue: '',
            changed: false,
            editable: e.type === 'text' || e.type === 'password' || e.type === 'textarea' || e.type === 'tel' || e.type === 'number' || e.type === 'email' || e.type === 'search' || e.type === 'url',
            filterable: e.type === 'text' || e.type === 'password' || e.type === 'textarea',
            tabOnSelect: false
        };

        // If $.autotab.selectFilterByClas is true and the format not specified, automatically select an element's format based on a matching class name.
        // The first matched element becomes the selected format for the filter.
        if ($.autotab.selectFilterByClass === true && typeof $(e).data('autotab-format') === 'undefined') {
            var classes = ['all', 'text', 'alpha', 'number', 'numeric', 'alphanumeric', 'hex', 'hexadecimal', 'custom'];

            for (var key in classes) {
                if ($(e).hasClass(classes[key])) {
                    settings.format = classes[key];
                    break;
                }
            }
        }

        for (var key in settings) {
            if (typeof $(e).data('autotab-' + key) !== 'undefined') {
                settings[key] = $(e).data('autotab-' + key);
            }
        }

        // Save settings on first run
        if (!settings.loaded) {
            if (settings.trigger !== null && typeof settings.trigger === 'string') {
                settings.trigger = settings.trigger.toString();
            }

            setSettings(e, settings);
        }

        return settings;
    };

    var queryObject = function queryObject(e) {
        return typeof e !== 'undefined' && (typeof e === 'string' || !(e instanceof jQuery));
    };

    var getSelection = function getSelection(e) {
        var start = 0,
            end = 0,
            selectionType = 0;

        if (e.type === 'text' || e.type === 'password' || e.type === 'textarea') {
            if (typeof e.selectionStart === 'number' && typeof e.selectionEnd === 'number') {
                // Non-IE browsers and IE 9+
                start = e.selectionStart;
                end = e.selectionEnd;
                selectionType = 1;
            } else if (document.selection && document.selection.createRange) {
                // For IE up to version 8
                var selectionRange = document.selection.createRange(),
                    textInputRange = e.createTextRange(),
                    precedingRange = e.createTextRange(),
                    bookmark = selectionRange.getBookmark();
                textInputRange.moveToBookmark(bookmark);
                precedingRange.setEndPoint("EndToStart", textInputRange);
                start = precedingRange.text.length;
                end = start + selectionRange.text.length;
                selectionType = 2;
            }
        }

        return {
            start: start,
            end: end,
            selectionType: selectionType
        };
    };

    $.autotab = function (options) {
        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
            options = {};
        }

        $(':input').autotab(options);
    };

    $.autotab.selectFilterByClass = false;

    $.autotab.next = function () {
        var e = $(document.activeElement);

        if (e.length) {
            e.trigger('autotab-next');
        }
    };

    $.autotab.previous = function () {
        var e = $(document.activeElement);

        if (e.length) {
            e.trigger('autotab-previous');
        }
    };

    $.autotab.remove = function (e) {
        queryObject(e) ? $(e).autotab('remove') : $(':input').autotab('remove');
    };

    $.autotab.restore = function (e) {
        queryObject(e) ? $(e).autotab('restore') : $(':input').autotab('restore');
    };

    $.autotab.refresh = function (e) {
        queryObject(e) ? $(e).autotab('refresh') : $(':input').autotab('refresh');
    };

    $.fn.autotab = function (method, options) {
        if (!this.length) {
            return this;
        }

        // Remove hidden fields since tabbing backwards is supported on different form elements
        var filtered = $.grep(this, function (e, i) {
            return e.type != 'hidden';
        });

        // Apply filter options
        if (method == 'filter') {
            if (typeof options === 'string' || typeof options === 'function') {
                options = { format: options };
            }

            for (var i = 0, length = filtered.length; i < length; i++) {
                var defaults = getSettings(filtered[i]),
                    newOptions = options;

                // Retain the established target/previous values as this area is for filtering only
                newOptions.target = defaults.target;
                newOptions.previous = defaults.previous;

                $.extend(defaults, newOptions);

                if (!defaults.loaded) {
                    defaults.disabled = true;
                    autotabBind(filtered[i], newOptions);
                } else {
                    setSettings(filtered[i], defaults);
                }
            }
        }
        // Disable auto tab and filtering
        else if (method == 'remove' || method == 'destroy' || method == 'disable') {
                for (var i = 0, length = filtered.length; i < length; i++) {
                    var defaults = getSettings(filtered[i]);

                    defaults.disabled = true;

                    setSettings(filtered[i], defaults);
                }
            }
            // Re-enable auto tab and filtering
            else if (method == 'restore' || method == 'enable') {
                    for (var i = 0, length = filtered.length; i < length; i++) {
                        var defaults = getSettings(filtered[i]);

                        defaults.disabled = false;

                        setSettings(filtered[i], defaults);
                    }
                }
                // Refresh target/previous elements
                else if (method == 'refresh') {
                        for (var i = 0, length = filtered.length; i < length; i++) {
                            var defaults = getSettings(filtered[i]),
                                n = i + 1,
                                p = i - 1,
                                selectTarget = function selectTarget() {
                                if (i > 0 && n < length) {
                                    defaults.target = filtered[n];
                                } else if (i > 0) {
                                    defaults.target = null;
                                } else {
                                    defaults.target = filtered[n];
                                }
                            },
                                selectPrevious = function selectPrevious() {
                                if (i > 0 && n < length) {
                                    defaults.previous = filtered[p];
                                } else if (i > 0) {
                                    defaults.previous = filtered[p];
                                } else {
                                    defaults.previous = null;
                                }
                            };

                            // Nothing was specified for the target element, so automatically set it
                            if (defaults.target === null || defaults.target.selector === '') {
                                selectTarget();
                            } else if (typeof defaults.target === 'string' || defaults.target.selector) {
                                defaults.target = $(typeof defaults.target === 'string' ? defaults.target : defaults.target.selector);

                                if (defaults.target.length === 0) {
                                    selectTarget();
                                }
                            }

                            // Nothing was specified for the previous element, so automatically set it
                            if (defaults.previous === null || defaults.previous.selector === '') {
                                selectPrevious();
                            } else if (typeof defaults.previous === 'string' || defaults.previous.selector) {
                                defaults.previous = $(typeof defaults.previous === 'string' ? defaults.previous : defaults.previous.selector);

                                if (defaults.previous.length === 0) {
                                    selectPrevious();
                                }
                            }

                            if (!defaults.loaded) {
                                autotabBind(filtered[i], defaults);
                            } else {
                                if (queryObject(defaults.target)) {
                                    defaults.target = $(defaults.target);
                                }

                                if (queryObject(defaults.previous)) {
                                    defaults.previous = $(defaults.previous);
                                }

                                setSettings(filtered[i], defaults);
                            }
                        }
                    } else {
                        if (method === null || typeof method === 'undefined') {
                            options = {};
                        } else if (typeof method === 'string' || typeof method === 'function') {
                            options = { format: method };
                        } else if ((typeof method === 'undefined' ? 'undefined' : _typeof(method)) === 'object') {
                            options = method;
                        }

                        // Bind key events to element(s) passed
                        if (filtered.length > 1) {
                            for (var i = 0, length = filtered.length; i < length; i++) {
                                var n = i + 1,
                                    p = i - 1,
                                    newOptions = options;

                                if (i > 0 && n < length) {
                                    newOptions.target = filtered[n];
                                    newOptions.previous = filtered[p];
                                } else if (i > 0) {
                                    newOptions.target = null;
                                    newOptions.previous = filtered[p];
                                } else {
                                    newOptions.target = filtered[n];
                                    newOptions.previous = null;
                                }

                                autotabBind(filtered[i], newOptions);
                            }
                        } else {
                            autotabBind(filtered[0], options);
                        }
                    }

        return this;
    };

    var filterValue = function filterValue(e, value, defaults) {
        if (typeof defaults.format === 'function') {
            return defaults.format(value, e);
        }

        var pattern = null;

        switch (defaults.format) {
            case 'text':
                pattern = new RegExp('[0-9]+', 'g');
                break;

            case 'alpha':
                pattern = new RegExp('[^a-zA-Z]+', 'g');
                break;

            case 'number':
            case 'numeric':
                pattern = new RegExp('[^0-9]+', 'g');
                break;

            case 'alphanumeric':
                pattern = new RegExp('[^0-9a-zA-Z]+', 'g');
                break;

            case 'hex':
            case 'hexadecimal':
                pattern = new RegExp('[^0-9A-Fa-f]+', 'g');
                break;

            case 'custom':
                pattern = new RegExp(defaults.pattern, 'g');
                break;

            case 'all':
            default:
                break;
        }

        if (pattern !== null) {
            value = value.replace(pattern, '');
        }

        if (defaults.nospace) {
            pattern = new RegExp('[ ]+', 'g');
            value = value.replace(pattern, '');
        }

        if (defaults.uppercase) {
            value = value.toUpperCase();
        }

        if (defaults.lowercase) {
            value = value.toLowerCase();
        }

        return value;
    };

    var autotabBind = function autotabBind(element, options) {
        var defaults = getSettings(element);

        if (defaults.disabled) {
            defaults.disabled = false;
            defaults.target = null;
            defaults.previous = null;
        }

        $.extend(defaults, options);

        // Sets targets to element based on the name or ID passed if they are not currently objects
        if (queryObject(defaults.target)) {
            defaults.target = $(defaults.target);
        }

        if (queryObject(defaults.previous)) {
            defaults.previous = $(defaults.previous);
        }

        var oldMaxlength = element.maxLength;

        if (typeof element.maxLength === 'undefined' && element.type == 'textarea') {
            oldMaxlength = element.maxLength = element.getAttribute('maxlength');
        }

        // defaults.maxlength has not changed and maxlength was specified
        if (defaults.maxlength == 2147483647 && oldMaxlength != 2147483647 && oldMaxlength != -1) {
            defaults.maxlength = oldMaxlength;
        }
        // defaults.maxlength overrides maxlength
        else if (defaults.maxlength > 0) {
                element.maxLength = defaults.maxlength;
            }
            // defaults.maxlength and maxlength have not been specified
            // A target cannot be used since there is no defined maxlength
            else {
                    defaults.target = null;
                }

        if (!defaults.loaded) {
            defaults.loaded = true;
            setSettings(element, defaults);
        } else {
            setSettings(element, defaults);
            return;
        }

        // Add a change event to select lists only so that we can auto tab when a value is selected
        if (element.type == 'select-one') {
            $(element).on('change', function (e) {
                var defaults = getSettings(this);

                if (defaults.tabOnSelect) {
                    $(this).trigger('autotab-next');
                }
            });
        }

        // The 1ms timeouts allow for keypress events to complete in case a
        // custom function or exterior method calls for a manual auto tab
        $(element).on('autotab-next', function (event, defaults) {
            var self = this;
            setTimeout(function () {
                if (!defaults) {
                    defaults = getSettings(self);
                }

                var target = defaults.target;

                if (!defaults.disabled && target.length) {
                    // Using focus on iOS devices is a pain, so use the browser's next/previous buttons to proceed
                    if (!settings.iOS) {

                        // Field is disabled/readonly, so tab to next element
                        if (target.prop('disabled') || target.prop('readonly')) {
                            target.trigger('autotab-next');
                        } else {
                            // Allows the user to navigate between each charater with arrow keys
                            if (defaults.arrowKey) {
                                target.focus();
                            } else {
                                target.focus().select();
                            }
                        }

                        settings.focusChange = new Date();
                    }
                }
            }, 1);
        }).on('autotab-previous', function (event, defaults) {
            var self = this;
            setTimeout(function () {
                if (!defaults) {
                    defaults = getSettings(self);
                }

                var previous = defaults.previous;

                if (!defaults.disabled && previous.length) {
                    var value = previous.val();

                    // Field is disabled/readonly, so tab to previous element
                    if (previous.prop('disabled') || previous.prop('readonly')) {
                        previous.trigger('autotab-previous');
                    } else if (value.length && previous.data('autotab-editable') && !defaults.arrowKey) {
                        if (settings.ie11) {
                            previous.val(value.substring(0, value.length - 1)).focus();
                        } else {
                            previous.focus().val(value.substring(0, value.length - 1));
                        }

                        setSettings(previous, { changed: true });
                    } else {
                        if (defaults.arrowKey) {
                            setSettings(this, { arrowKey: false });
                        }

                        if (settings.ie11) {
                            previous.val(value).focus();
                        } else {
                            previous.focus().val(value);
                        }
                    }

                    settings.focusChange = null;
                }
            }, 1);
        }).on('focus', function () {
            setSettings(this, { originalValue: this.value });
        }).on('blur', function () {
            var defaults = getSettings(this);

            if (defaults.changed && this.value != defaults.originalValue) {
                setSettings(this, { changed: false });
                $(this).change();
            }
        }).on('keydown.autotab', function (e) {
            var defaults = getSettings(this);

            if (!defaults || defaults.disabled) {
                return true;
            }

            var selection = getSelection(this),
                keyCode = e.which || e.charCode;

            // Go to the previous element when backspace
            // is pressed in an empty input field
            if (keyCode == 8) {
                defaults.arrowKey = false;

                // Prevent the browser from of navigating to the previous page
                if (!defaults.editable) {
                    $(this).trigger('autotab-previous', defaults);
                    return false;
                }

                setSettings(this, { changed: this.value !== defaults.originalValue });

                if (this.value.length === 0) {
                    $(this).trigger('autotab-previous', defaults);
                    return;
                }
            } else if (keyCode == 9 && settings.focusChange !== null) {
                // Tab backwards
                if (e.shiftKey) {
                    settings.focusChange = null;
                    return;
                }

                if (new Date().getTime() - settings.focusChange.getTime() < settings.tabPause) {
                    settings.focusChange = null;
                    return false;
                }
            } else if (this.type !== 'range' && this.type !== 'select-one' && this.type !== 'select-multiple') {
                if (this.type !== 'tel' && this.type !== 'number' || (this.type === 'tel' || this.type === 'number') && this.value.length == 0) {
                    if (keyCode == 37 && (!defaults.editable || selection.start == 0)) {
                        defaults.arrowKey = true;
                        $(this).trigger('autotab-previous', defaults);
                    } else if (keyCode == 39 && (!defaults.editable || !defaults.filterable || selection.end == this.value.length || this.value.length == 0)) {
                        defaults.arrowKey = true;
                        $(this).trigger('autotab-next', defaults);
                    }
                }
            }
        }).on('keypress.autotab', function (e) {
            var defaults = getSettings(this),
                keyCode = e.which || e.keyCode;

            // e.charCode == 0 indicates a special key has been pressed, which only Firefox triggers
            if (!defaults || defaults.disabled || settings.firefox && e.charCode === 0 || e.ctrlKey || e.altKey || keyCode == 13 || this.disabled) {
                return true;
            }

            var keyChar = String.fromCharCode(keyCode);

            if (this.type != 'text' && this.type != 'password' && this.type != 'textarea') {
                // this.value.length is the length before the keypress event was trigged
                if (this.value.length + 1 >= defaults.maxlength) {
                    defaults.arrowKey = false;
                    $(this).trigger('autotab-next', defaults);
                }

                return !(this.value.length == defaults.maxlength);
            }

            // Prevents auto tabbing when defaults.trigger is pressed
            if (defaults.trigger !== null && defaults.trigger.indexOf(keyChar) >= 0) {
                if (settings.focusChange !== null && new Date().getTime() - settings.focusChange.getTime() < settings.tabPause) {
                    settings.focusChange = null;
                } else {
                    defaults.arrowKey = false;
                    $(this).trigger('autotab-next', defaults);
                }

                return false;
            }

            settings.focusChange = null;

            var hasValue = document.selection && document.selection.createRange ? true : keyCode > 0;

            keyChar = filterValue(this, keyChar, defaults);

            if (hasValue && (keyChar === null || keyChar === '')) {
                return false;
            }

            // Many, many thanks to Tim Down for this solution: http://stackoverflow.com/a/3923320/94656
            if (hasValue && this.value.length <= this.maxLength) {
                var selection = getSelection(this);

                // Text is fully selected, so it needs to be replaced
                if (selection.start === 0 && selection.end == this.value.length) {
                    this.value = keyChar;
                    setSettings(this, { changed: this.value != defaults.originalValue });
                } else {
                    if (this.value.length == this.maxLength && selection.start === selection.end) {
                        defaults.arrowKey = false;
                        $(this).trigger('autotab-next', defaults);
                        return false;
                    }

                    this.value = this.value.slice(0, selection.start) + keyChar + this.value.slice(selection.end);
                    setSettings(this, { changed: this.value != defaults.originalValue });
                }

                // Prevents the cursor position from being set to the end of the text box
                // This is called even if the text is fully selected and replaced due to an unexpected behavior in IE6 and up (#32)
                if (this.value.length != defaults.maxlength) {
                    selection.start++;

                    if (selection.selectionType == 1) {
                        this.selectionStart = this.selectionEnd = selection.start;
                    } else if (selection.selectionType == 2) {
                        var range = this.createTextRange();
                        range.collapse(true);
                        range.moveEnd('character', selection.start);
                        range.moveStart('character', selection.start);
                        range.select();
                    }
                }
            }

            if (this.value.length == defaults.maxlength) {
                defaults.arrowKey = false;
                $(this).trigger('autotab-next', defaults);
            }

            return false;
        }).on('drop paste', function (e) {
            var defaults = getSettings(this);

            if (!defaults) {
                return true;
            }

            this.maxLength = 2147483647;

            (function (e, originDefaults) {
                setTimeout(function () {
                    var lastIndex = -1,
                        hiddenInput = document.createElement('input');
                    hiddenInput.type = 'hidden';
                    hiddenInput.value = e.value.toLowerCase();
                    hiddenInput.originalValue = e.value;

                    e.value = filterValue(e, e.value, originDefaults).substr(0, originDefaults.maxlength);

                    var handlePaste = function handlePaste(e, previousValue) {
                        if (!e) {
                            return;
                        }

                        var defaults = getSettings(e);

                        if ($(e).prop('disabled') || $(e).prop('readonly') || !defaults.editable) {
                            $(e).trigger('autotab-next');

                            if (!settings.iOS) {
                                handlePaste(defaults.target[0], previousValue);
                            }
                            return;
                        }

                        for (var i = 0, count = previousValue.length; i < count; i++) {
                            lastIndex = hiddenInput.value.indexOf(previousValue.charAt(i).toLowerCase(), lastIndex) + 1;
                        }

                        var trimmedValue = hiddenInput.originalValue.substr(lastIndex),
                            filteredValue = filterValue(e, trimmedValue, defaults).substr(0, defaults.maxlength);

                        if (!filteredValue) {
                            return;
                        }

                        e.value = filteredValue;

                        if (filteredValue.length == defaults.maxlength) {
                            defaults.arrowKey = false;
                            $(e).trigger('autotab-next', defaults);

                            // Firefox causes all but the first and last elements to retain a select all state, so in order to
                            // effectively support arrow keys, the starting point of the selection is to the last possible cursor
                            if (settings.firefox) {
                                setTimeout(function () {
                                    e.selectionStart = e.value.length;
                                }, 1);
                            }

                            if (!settings.iOS) {
                                handlePaste(defaults.target[0], filteredValue);
                            }
                        }
                    };

                    if (e.value.length == originDefaults.maxlength) {
                        defaults.arrowKey = false;
                        $(e).trigger('autotab-next', defaults);

                        if (!settings.iOS) {
                            handlePaste(originDefaults.target[0], e.value.toLowerCase());
                        }
                    }

                    e.maxLength = originDefaults.maxlength;
                }, 1);
            })(this, defaults);
        });
    };

    // Deprecated, here for backwards compatibility
    $.fn.autotab_magic = function (focus) {
        return $(this).autotab();
    };
    $.fn.autotab_filter = function (options) {
        var defaults = {};

        if (typeof options === 'string' || typeof options === 'function') {
            defaults.format = options;
        } else {
            $.extend(defaults, options);
        }

        return $(this).autotab('filter', defaults);
    };
})(jQuery);

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*  jQuery Nice Select - v1.1.0
    https://github.com/hernansartorio/jquery-nice-select
    Made by Hernán Sartorio  */

(function ($) {

  $.fn.niceSelect = function (method) {

    // Methods
    if (typeof method == 'string') {
      if (method == 'update') {
        this.each(function () {
          var $select = $(this);
          var $dropdown = $(this).next('.nice-select');
          var open = $dropdown.hasClass('open');

          if ($dropdown.length) {
            $dropdown.remove();
            create_nice_select($select);

            if (open) {
              $select.next().trigger('click');
            }
          }
        });
      } else if (method == 'destroy') {
        this.each(function () {
          var $select = $(this);
          var $dropdown = $(this).next('.nice-select');

          if ($dropdown.length) {
            $dropdown.remove();
            $select.css('display', '');
          }
        });
        if ($('.nice-select').length == 0) {
          $(document).off('.nice_select');
        }
      } else {
        console.log('Method "' + method + '" does not exist.');
      }
      return this;
    }

    // Hide native select
    this.hide();

    // Create custom markup
    this.each(function () {
      var $select = $(this);

      if (!$select.next().hasClass('nice-select')) {
        create_nice_select($select);
      }
    });

    function create_nice_select($select) {
      $select.after($('<div></div>').addClass('nice-select').addClass($select.attr('class') || '').addClass($select.attr('disabled') ? 'disabled' : '').attr('tabindex', $select.attr('disabled') ? null : '0').html('<span class="current"></span><ul class="list"></ul>'));

      var $dropdown = $select.next();
      var $options = $select.find('option');
      var $selected = $select.find('option:selected');

      $dropdown.find('.current').html($selected.data('display') || $selected.text());

      $options.each(function (i) {
        var $option = $(this);
        var display = $option.data('display');

        $dropdown.find('ul').append($('<li></li>').attr('data-value', $option.val()).attr('data-display', display || null).addClass('option' + ($option.is(':selected') ? ' selected' : '') + ($option.is(':disabled') ? ' disabled' : '')).html($option.text()));
      });
    }

    /* Event listeners */

    // Unbind existing events in case that the plugin has been initialized before
    $(document).off('.nice_select');

    // Open/close
    $(document).on('click.nice_select', '.nice-select', function (event) {
      var $dropdown = $(this);

      $('.nice-select').not($dropdown).removeClass('open');
      $dropdown.toggleClass('open');

      if ($dropdown.hasClass('open')) {
        $dropdown.find('.option');
        $dropdown.find('.focus').removeClass('focus');
        $dropdown.find('.selected').addClass('focus');
      } else {
        $dropdown.focus();
      }
    });

    // Close when clicking outside
    $(document).on('click.nice_select', function (event) {
      if ($(event.target).closest('.nice-select').length === 0) {
        $('.nice-select').removeClass('open').find('.option');
      }
    });

    // Option click
    $(document).on('click.nice_select', '.nice-select .option:not(.disabled)', function (event) {
      var $option = $(this);
      var $dropdown = $option.closest('.nice-select');
      var oldSelectedValue = $dropdown.find('.selected').data('value');
      $dropdown.find('.selected').removeClass('selected');
      $option.addClass('selected');

      var text = $option.data('display') || $option.text();
      $dropdown.find('.current').text(text);

      $dropdown.prev('select').find('option[value="' + oldSelectedValue + '"]').attr('selected', false);
      $dropdown.prev('select').find('option[value="' + $option.data('value') + '"]').attr('selected', 'true');
      $dropdown.prev('select').val($option.data('value')).change();
    });

    // Keyboard events
    $(document).on('keydown.nice_select', '.nice-select', function (event) {
      var $dropdown = $(this);
      var $focused_option = $($dropdown.find('.focus') || $dropdown.find('.list .option.selected'));

      // Space or Enter
      if (event.keyCode == 32 || event.keyCode == 13) {
        if ($dropdown.hasClass('open')) {
          $focused_option.trigger('click');
        } else {
          $dropdown.trigger('click');
        }
        return false;
        // Down
      } else if (event.keyCode == 40) {
        if (!$dropdown.hasClass('open')) {
          $dropdown.trigger('click');
        } else {
          var $next = $focused_option.nextAll('.option:not(.disabled)').first();
          if ($next.length > 0) {
            $dropdown.find('.focus').removeClass('focus');
            $next.addClass('focus');
          }
        }
        return false;
        // Up
      } else if (event.keyCode == 38) {
        if (!$dropdown.hasClass('open')) {
          $dropdown.trigger('click');
        } else {
          var $prev = $focused_option.prevAll('.option:not(.disabled)').first();
          if ($prev.length > 0) {
            $dropdown.find('.focus').removeClass('focus');
            $prev.addClass('focus');
          }
        }
        return false;
        // Esc
      } else if (event.keyCode == 27) {
        if ($dropdown.hasClass('open')) {
          $dropdown.trigger('click');
        }
        // Tab
      } else if (event.keyCode == 9) {
        if ($dropdown.hasClass('open')) {
          return false;
        }
      }
    });

    // Detect CSS pointer-events support, for IE <= 10. From Modernizr.
    var style = document.createElement('a').style;
    style.cssText = 'pointer-events:auto';
    if (style.pointerEvents !== 'auto') {
      $('html').addClass('no-csspointerevents');
    }

    return this;
  };
})(jQuery);

/***/ }),

/***/ 69:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 70:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 71:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function FrameEventClient() {
    var self = this;
    var functions = {};

    function bindEvent(element, eventName, eventHandler) {
        if (element.addEventListener) {
            element.addEventListener(eventName, eventHandler, false);
        } else if (element.attachEvent) {
            element.attachEvent('on' + eventName, eventHandler);
        }
    }

    bindEvent(window, 'message', function (e) {
        var methodName = e.data.name && e.data.name.toLowerCase();
        var method = functions[methodName];
        method && method(e.data);
    });

    this.listen = function (evt, cb) {
        var found = functions[evt.toLowerCase()];
        if (found) new Error("El evento '" + evt.toLowerCase() + "' ya ha sido definido");
        functions[evt.toLowerCase()] = cb;
    };

    this.sendEvent = function (frame, evt, data) {
        var eventObject = {
            name: evt,
            data: data
        };
        var objIframe = frame;
        if (typeof frame == 'string') {
            objIframe = document.getElementById(frame);
        }
        eventObject.frame = objIframe.name;
        objIframe.contentWindow && objIframe.contentWindow.postMessage(eventObject, '*');
    };
}

window.frameEventClient = new FrameEventClient();

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (App, Router, Controller, Service, Handler, Helper, Config, Model, $, Hotjar) {
  'use strict';

  // ==================================================
  // Ejecicion inicial
  // ==================================================  	

  App.init = function () {
    Service.startComscore();
    Service.startEstadisticas();
    Service.createCustomDimension();
    Service.startGoogleTagManager();
    Service.startGoogleOptimize();
    Service.startHotjar();
    Service.setup();

    if (Helper.readCookie('usuario%5Fid')) {
      Hotjar.startRecording(['userId', Helper.readCookie('usuario%5Fid')]);
    } else {
      Hotjar.startRecording(['userId', 'SinSesion']);
    }
  };

  App.reload = function () {
    Helper.resetAll(function () {
      App.init();
    });
  };

  // ==================================================
  // Step Handler Event
  // ==================================================  

  //$(document.body).on('submit', 'form', function (e) {
  //    e.preventDefault();
  //    //var step = $('.next-step').data('step');              
  //    //Handler.stepHandler(step);
  //});


  //});

  $(document.body).on('keypress', document.body, function (e) {
    if (e.which === 13) {
      e.preventDefault();
      if ($(".next-step").length) {
        var step = $('.next-step').data('step');
        Handler.stepHandler(step);
      }
    }
  });

  $(document.body).on('click', '.next-button', function (e) {
    var t = $(this);
    var step = t.data('step');
    Handler.stepHandler(step, t);
    e.preventDefault();
    return false;
  });

  $(document.body).on('click', '.callto', function (e) {
    var telefono = $(this).text();
    if (telefono) {
      LN.AppEvent.sendEvent('CALLTO', telefono);
    }
  });

  $(document.body).on('click', '.mailto', function (e) {
    var mail = $(this).text();
    if (mail) {
      if (Model.MobileEmbed) {
        LN.AppEvent.sendEvent('MAILTO', mail);
        return false;
      } else {
        window.location.href = "mailto:" + mail;
      }
    }
  });
})(LN.App, LN.Router, LN.Controller, LN.Service, LN.Handler, LN.Helper, LN.Config, LN.Model, jQuery, LN.Hotjar);

//ONLOAD
(function (LN) {
  try {
    LN.App.init();
  } catch (err) {
    logger && logger.error('Error: ' + err);
    LN.Service.mostrarError(err);
  }
})(LN);

/***/ })

},[554]);


// WEBPACK FOOTER //
// scripts/paywall.a877793.min.js